import React, { useContext } from 'react';

var colors = {
  skin: {
    light: {
      base: '#fdd2b2',
      shadow: '#f3ab98'
    },
    yellow: {
      base: '#FBE8B3',
      shadow: '#EDD494'
    },
    brown: {
      base: '#D8985D',
      shadow: '#C6854E'
    },
    dark: {
      base: '#A56941',
      shadow: '#8D5638'
    },
    red: {
      base: '#CC734C',
      shadow: '#B56241'
    },
    black: {
      base: '#754437',
      shadow: '#6B3D34'
    }
  },
  hair: {
    blonde: {
      base: '#FEDC58',
      shadow: '#EDBF2E'
    },
    orange: {
      base: '#D96E27',
      shadow: '#C65C22'
    },
    black: {
      base: '#592d3d',
      shadow: '#592d3d'
    },
    white: {
      base: '#ffffff',
      shadow: '#E2E2E2'
    },
    brown: {
      base: '#A56941',
      shadow: '#8D5638'
    },
    blue: {
      base: '#85c5e5',
      shadow: '#67B7D6'
    },
    pink: {
      base: '#D69AC7',
      shadow: '#C683B4'
    }
  },
  lipColors: {
    red: {
      base: '#DD3E3E',
      shadow: '#C43333'
    },
    purple: {
      base: '#B256A1',
      shadow: '#9C4490'
    },
    pink: {
      base: '#D69AC7',
      shadow: '#C683B4'
    },
    turqoise: {
      base: '#5CCBF1',
      shadow: '#49B5CD'
    },
    green: {
      base: '#4AB749',
      shadow: '#3CA047'
    }
  },
  clothing: {
    white: {
      base: '#FFFFFF',
      shadow: '#E2E2E2'
    },
    blue: {
      base: '#85c5e5',
      shadow: '#67B7D6'
    },
    black: {
      base: '#633749',
      shadow: '#5E3244'
    },
    green: {
      base: '#89D86F',
      shadow: '#7DC462'
    },
    red: {
      base: '#D67070',
      shadow: '#C46565'
    }
  },
  bgColors: {
    blue: '#85c5e5'
  },
  outline: '#592d3d',
  white: '#ffffff',
  tongue: '#f28195'
};

var theme = {
  __proto__: null,
  colors: colors
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ThemeContext = /*#__PURE__*/React.createContext({
  colors: colors,
  skin: colors.skin.light
});
var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

var Noop = function Noop() {
  return React.createElement(React.Fragment, null);
};

var Mask = function Mask(_ref) {
  var id = _ref.id;
  return React.createElement("mask", {
    id: id
  }, React.createElement("path", {
    d: "M1000,0H0V718.31H179.2c38.38,142.38,167.45,247.1,320.8,247.1s282.42-104.72,320.8-247.1H1000Z",
    fill: "white"
  }));
};

var BgCircle = function BgCircle(_ref) {
  var circleColor = _ref.circleColor;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var color = colors.bgColors[circleColor];
  return React.createElement("circle", {
    cx: "500",
    cy: "630.1601",
    r: "332.441995",
    fill: color
  });
};

var DressShirt = function DressShirt(_ref) {
  var color = _ref.color,
      _ref$graphic = _ref.graphic,
      Graphic = _ref$graphic === void 0 ? Noop : _ref$graphic;

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      skin = _useTheme.skin;

  var base = colors.clothing[color].base;
  return React.createElement(React.Fragment, null, React.createElement("polygon", {
    points: "547.85 847.98 505.72 813.61 580.35 758.82 419.65 758.82 494.28 813.61 452.15 847.98 414.52 791.48 414.52 869.96 588.78 869.96 588.78 786.52 547.85 847.98",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M616.66,758.16l-42.73.1a119.49,119.49,0,0,1-1.43,13.48,63.7,63.7,0,0,1-1.74,6.34c-2.34,6.49-17.26,12-21.49,16.73a48.22,48.22,0,0,1-4.5,4.43c-25.17,18.2-65.17,19.2-89.48-.58a51.36,51.36,0,0,1-7.11-7.61c-4.23-5.56-16.4-11.59-18.1-18.94a60,60,0,0,1-1.08-6.59,63.55,63.55,0,0,1-.36-6.8s-45.21-.56-45.21-.56a13.28,13.28,0,0,0-13.28,13.27v284.69a13.28,13.28,0,0,0,13.28,13.27H622.36a13.27,13.27,0,0,0,13.27-13.27V778C635.63,765.82,629.75,758.16,616.66,758.16Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M612.84,758.16c63.54,0,88.52,43.39,78.9,272-18.74,6.7-55.91,4.59-55.91,4.59Z",
    fill: colors.white
  }), React.createElement("polygon", {
    points: "451.06 855.4 499.51 831.31 548.09 855.4 511.03 812.38 467.14 813.21 451.06 855.4",
    fill: colors.clothing.white.shadow
  }), React.createElement("path", {
    d: "M635.63,831.31s-22.79,84.54-19.31,234l33.21-31,3.58-137.58C647.49,824.5,635.63,831.31,635.63,831.31Z",
    fill: colors.clothing.white.shadow
  }), React.createElement("path", {
    d: "M389,758.16c-61.78,0-88.88,56.45-80.75,245.48,22.42,9.91,56.19,5.58,56.19,5.58Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M306.94,957.49q.26,20.46,1.21,43.48c15.27.73,43.69.88,57.11,0l4.18-42.81C358.67,956.9,323.66,956.49,306.94,957.49Z",
    fill: colors.clothing.white.shadow
  }), React.createElement("path", {
    d: "M370.12,831.31l-.5,177.69-13.35.9C353.3,860.85,370.12,831.31,370.12,831.31Z",
    fill: colors.clothing.white.shadow
  }), React.createElement("path", {
    d: "M612.84,758.16c67.42,0,78.45,56.28,78.9,133.78v138.22s-50,5.53-55.91,4.59l-.1-142.11",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M389,758.16c-25.73,0-43.52,8.12-55.71,22.44-19.45,22.87-24.63,61.54-25,108.27v123.77c12.06,3.32,61.36-3.64,61.36-3.64l.49-118.6",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M372.6,1011.24c-1.83,2.61-73.77,1.92-74.67,0s-2.19-37.5,0-41c1.8-2.88,72.11-2.27,74.67,0S374.43,1008.63,372.6,1011.24Z",
    fill: colors.white,
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M383.43,1069.39H500c-109.19,0-100.91-231.14-129.89-231.14v217.87A13.28,13.28,0,0,0,383.43,1069.39Z",
    fill: colors.clothing.white.shadow
  }), React.createElement("path", {
    d: "M364.15,860.29c-.19-3.67-.11-7.35.06-11s.47-7.34.85-11c.2-1.83.41-3.67.65-5.51s.49-3.67.85-5.5a44.05,44.05,0,0,1,3.59-11,44.05,44.05,0,0,1,3.59,11c.36,1.83.62,3.67.85,5.5s.45,3.68.65,5.51q.58,5.52.86,11c.16,3.67.24,7.35,0,11Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M635.63,869.4v8c.26,34,.26,69,0,102.76,0,2.87,0,5.72,0,8.53v67.41a13.27,13.27,0,0,1-13.27,13.27H383.43a13.28,13.28,0,0,1-13.28-13.27V990.3c-.26-34.86-.26-69.86,0-105.3V860.29",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M697.42,970.24c2.22,2.26,1.59,38.39,0,41s-64,1.92-64.77,0-1.9-37.5,0-41c.27-.5,2.28-.89,5.45-1.18",
    fill: colors.white,
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M678.92,968.3c3.8.3,15-1.18,15.42-.76",
    fill: colors.white
  }), React.createElement("path", {
    d: "M678.92,968.3a23.67,23.67,0,0,1,1.88-2.16,12.13,12.13,0,0,1,1.78-1.47,12.74,12.74,0,0,1,1.81-1c.61-.29,1.22-.54,1.83-.79a24.1,24.1,0,0,1,3.79-1.18,15.85,15.85,0,0,1,2-.31c.36,0,.73,0,1.17,0,.25,0,.46,0,.82,0,.12,0,.44,0,.71.07l.35,0,.49.11.25.06.2.06.57.21a6.45,6.45,0,0,1,2,1.37l4.2,4.29-8.65,8.48-4.12-4.37a5.73,5.73,0,0,0,1.91,1.32c.18.08.36.14.54.2l.17,0,.19.05a2.34,2.34,0,0,0,.38.09l.19,0h0c.1,0,.26,0,.22,0s-.07,0-.15,0l-.75,0c-.57,0-1.19,0-1.82,0a26.27,26.27,0,0,1-3.92-.53c-.67-.15-1.34-.3-2-.49a12.56,12.56,0,0,1-2-.72,10,10,0,0,1-2.08-1.32A8.19,8.19,0,0,1,678.92,968.3Z",
    fill: colors.outline
  }), React.createElement("polygon", {
    points: "592.51 763.64 517.84 818.45 559.98 852.83 619.4 763.59 592.51 763.64",
    fill: colors.clothing.white.shadow
  }), React.createElement("path", {
    d: "M629.63,869.4c-.19-4.18-.1-8.36.06-12.53s.47-8.36.86-12.53c.2-2.09.4-4.18.64-6.27s.49-4.18.86-6.27a54.83,54.83,0,0,1,3.58-12.53,54.37,54.37,0,0,1,3.59,12.53c.36,2.09.63,4.18.85,6.27s.45,4.18.65,6.27c.39,4.17.69,8.35.85,12.53s.26,8.35.06,12.53Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M383.43,758.26l233.23-.1",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("polygon", {
    points: "529.39 835.55 507.04 813.21 484.7 835.55 495.68 846.53 485.96 953.16 506.7 969.33 528.12 953.16 518.41 846.53 529.39 835.55",
    fill: colors.clothing.white.shadow
  }), React.createElement("line", {
    x1: "500.04",
    y1: "813.21",
    x2: "500.04",
    y2: "1069.39",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "6px"
  }), React.createElement("polygon", {
    points: "500.04 813.21 522.39 828.55 500.04 850.9 477.7 828.55 500.04 813.21",
    fill: base
  }), React.createElement("path", {
    d: "M419.62,758.8s43.27,39.34,74.66,54.81C479,838.82,452.15,848,452.15,848l-59.43-89.23Z",
    fill: colors.white,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M580.38,758.8S541,800,505.72,813.61c10,20.28,42.13,34.37,42.13,34.37l59.43-89.23Z",
    fill: colors.white,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("g", {
    transform: "translate(0 30)"
  }, React.createElement(Graphic, null)), React.createElement("polygon", {
    points: "478.96 946.16 499.7 962.33 521.12 946.16 511.12 836.38 488.96 836.38 478.96 946.16",
    fill: base
  }), React.createElement("polyline", {
    points: "477.7 828.55 488.68 839.53 478.96 946.16 499.7 962.33 521.12 946.16 511.41 839.53 522.39 828.55",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M638.1,969.06c7.51-.71,21.51-.89,34-.67",
    fill: colors.white
  }), React.createElement("path", {
    d: "M637.54,963.08a50.92,50.92,0,0,1,8.84-.47c2.9.07,5.78.3,8.66.65,1.43.18,2.87.37,4.3.61a43.36,43.36,0,0,1,4.29.85,27.53,27.53,0,0,1,8.5,3.67,30.13,30.13,0,0,1-8.52,3.5c-1.41.36-2.82.63-4.23.86s-2.81.47-4.21.69c-2.8.42-5.59.78-8.35,1s-5.52.5-8.16.54l-6,.1-1-11.13Z",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "515.77",
    cy: "982.93",
    r: "4.8",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M490.89,836.19c-.05-.06,0,0,0,0l.07.05a.88.88,0,0,1,.17.12l.38.29c.25.21.52.42.78.65.53.45,1.09.93,1.7,1.39s1.27.9,2,1.42a27.37,27.37,0,0,1,2.71,2.33,5.61,5.61,0,0,1-3.13,2.43,9.41,9.41,0,0,1-3.7.27,11,11,0,0,1-3.63-1,9.72,9.72,0,0,1-1.65-1,8.85,8.85,0,0,1-.77-.63c-.12-.11-.25-.23-.37-.36l-.2-.21-.25-.29Z",
    fill: colors.outline
  }));
};

var FaceMask = function FaceMask(_ref) {
  var color = _ref.color;

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      skin = _useTheme.skin;

  var _colors$clothing$colo = colors.clothing[color],
      base = _colors$clothing$colo.base,
      shadow = _colors$clothing$colo.shadow;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M289.63,652.2q6.38,8,13.32,15.47,6.76,7.26,14,14a204.78,204.78,0,0,0,16.07,13.62q8.34,6.34,17.24,11.82c24,13.28,49.91,22.39,76.71,28.3,6.7,1.47,13.46,2.74,20.24,3.77,69.83,6.22,147.18,6.22,208.41-32.65q8.88-6.12,17.25-12.91c15.56-12.65,28-26.65,40.9-44.33-83.93,0-138.94-94.73-207.41-94.73S367.92,652.2,289.63,652.2Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M291.53,666.4q6.25,7.85,13.08,15.2,6.64,7.14,13.79,13.78a199.59,199.59,0,0,0,15.8,13.38c5.46,4.16,11.12,8,16.93,11.62,23.55,13,49,22,75.37,27.8,6.59,1.45,13.23,2.7,19.89,3.71C515,758,591,758,651.16,719.81q8.73-6,16.94-12.69a268.58,268.58,0,0,0,41.39-42c-82.46,0-137.71-94.64-205-94.64S368.44,666.4,291.53,666.4Z",
    fill: base,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M453.37,752.49l5.5.43,1.32.1c1.57.11,3.14.23,4.72.33l1.29.09,5.18.33,2,.12,5,.26,2.16.1,3.35.15,2.56.1,4.46.14,3,.08,2.41,0c1.73,0,3.46.06,5.19.08h1.91q5.58,0,11.16-.06l1.1,0c2.44,0,4.87-.11,7.3-.2h.28q6-.23,12-.62l.31,0c10.79-.73,21.53-1.92,32.13-3.68h0q4-.66,7.95-1.43c-33.29-9.82-129.24-43.29-193-117.69-29.32,19.08-59.55,35.28-91.16,35.28l.35.44,2.44,3,.75.9c.8,1,1.62,1.93,2.44,2.88l1.57,1.82.53.6c.65.74,1.31,1.49,2,2.22s1.31,1.44,2,2.16c.86.94,1.73,1.87,2.6,2.79l1.21,1.28c1.29,1.34,2.59,2.68,3.91,4l.26.27c1.29,1.28,2.6,2.55,3.91,3.81l1.58,1.5c.95.89,1.9,1.78,2.86,2.66l1.16,1.06c1,.94,2.09,1.86,3.14,2.78,1.54,1.35,3.1,2.66,4.68,3.95l.42.35q2.44,2,4.93,3.89c5.46,4.16,11.12,8,16.93,11.62a262,262,0,0,0,46.16,19.89c2.07.68,4.15,1.32,6.24,2q11.36,3.4,23,6,5.69,1.26,11.42,2.29c2.82.51,5.64,1,8.47,1.42l5.71.49Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M579.81,624.61c-6.52-1.65-13-3.05-19.57-4.22s-13.09-2.18-19.63-3-13.12-1.45-19.68-1.89-13.14-.64-19.71-.65h-4.93l-4.93.13c-1.64,0-3.28.11-4.92.19s-3.29.13-4.92.26c-6.57.38-13.11,1.09-19.66,1.87a398,398,0,0,0-39.21,7.32,159.22,159.22,0,0,1,38.13-13.52c3.32-.66,6.64-1.41,10-1.88,1.68-.25,3.35-.56,5-.75l5.06-.6a192.24,192.24,0,0,1,20.36-1c6.79,0,13.59.39,20.34,1.11a193.91,193.91,0,0,1,20.08,3.25,180.43,180.43,0,0,1,19.57,5.41A118.4,118.4,0,0,1,579.81,624.61Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M364.82,686.87c11.06,3.46,22.25,6.26,33.51,8.69,2.81.59,5.63,1.2,8.45,1.76s5.64,1.12,8.48,1.58c5.66,1,11.32,2,17,2.77,11.38,1.57,22.76,2.94,34.2,3.74s22.88,1.26,34.33,1.29l8.59,0,8.58-.26c2.86,0,5.72-.22,8.58-.37s5.72-.26,8.57-.53c11.43-.76,22.81-2.16,34.18-3.69a531.12,531.12,0,0,0,67.44-15A312.64,312.64,0,0,1,570.36,708c-5.73,1-11.45,2.24-17.24,3-2.89.4-5.77.88-8.67,1.19l-8.7.94c-11.63,1-23.3,1.71-35,1.61s-23.35-.61-35-1.76-23.17-2.82-34.6-5.14a342.06,342.06,0,0,1-33.87-8.46A234,234,0,0,1,364.82,686.87Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M584.88,662.69c-14.62,1.67-29.24,2.5-43.86,3.13s-29.25.86-43.87.87-29.25-.27-43.87-.86-29.24-1.47-43.86-3.14c14.62-1.68,29.24-2.51,43.86-3.15s29.25-.86,43.87-.85,29.24.28,43.87.86S570.26,661,584.88,662.69Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M291.53,666.4q6.25,7.85,13.08,15.2,6.64,7.14,13.79,13.78a199.59,199.59,0,0,0,15.8,13.38c5.46,4.16,11.12,8,16.93,11.62,23.55,13,49,22,75.37,27.8,6.59,1.45,13.23,2.7,19.89,3.71C515,758,591,758,651.16,719.81q8.73-6,16.94-12.69a268.58,268.58,0,0,0,41.39-42c-82.46,0-137.71-94.64-205-94.64S368.44,666.4,291.53,666.4Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M673,659s48.64-10.61,84.3-88.54",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M330,659.06s-53.47-13.43-87-87.61",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }));
};

var Base = function Base(_ref) {
  var Eyes = _ref.eyes,
      Eyebrows = _ref.eyebrows,
      Mouth = _ref.mouth,
      _ref$hair = _ref.hair,
      hair = _ref$hair === void 0 ? {
    Front: Noop,
    Back: Noop
  } : _ref$hair,
      FacialHair = _ref.facialHair,
      _ref$clothing = _ref.clothing,
      clothing = _ref$clothing === void 0 ? {
    Front: Noop,
    Back: Noop
  } : _ref$clothing,
      Accessory = _ref.accessory,
      Graphic = _ref.graphic,
      _ref$hat = _ref.hat,
      hat = _ref$hat === void 0 ? {
    Front: Noop,
    Back: Noop
  } : _ref$hat,
      body = _ref.body,
      hairColor = _ref.hairColor,
      clothingColor = _ref.clothingColor,
      circleColor = _ref.circleColor,
      lipColor = _ref.lipColor,
      hatColor = _ref.hatColor,
      faceMaskColor = _ref.faceMaskColor,
      mask = _ref.mask,
      faceMask = _ref.faceMask,
      lashes = _ref.lashes,
      rest = _objectWithoutPropertiesLoose(_ref, ["eyes", "eyebrows", "mouth", "hair", "facialHair", "clothing", "accessory", "graphic", "hat", "body", "hairColor", "clothingColor", "circleColor", "lipColor", "hatColor", "faceMaskColor", "mask", "faceMask", "lashes"]);

  var _useTheme = useTheme(),
      skin = _useTheme.skin;

  var FrontHair = hair.Front,
      BackHair = hair.Back,
      hatScale = hair.hatScale;
  var FrontHat = hat.Front,
      BackHat = hat.Back;
  var FrontBody = body.Front,
      BackBody = body.Back;
  var ClothingFront = clothing.Front,
      ClothingBack = clothing.Back,
      _clothing$braStraps = clothing.braStraps,
      braStraps = _clothing$braStraps === void 0 ? true : _clothing$braStraps;
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 990"
  }, rest), mask && React.createElement(Mask, {
    id: "mask"
  }), React.createElement("g", {
    mask: mask ? "url(#mask)" : undefined
  }, mask && React.createElement(BgCircle, {
    circleColor: circleColor
  }), React.createElement(BackHat, {
    color: hatColor,
    scale: hatScale
  }), React.createElement(BackHair, {
    hairColor: hairColor,
    hasHat: FrontHat !== Noop
  }), React.createElement("path", {
    d: "M610,758.72c90.76,0,72,114.24,72.87,241.28H610Z",
    fill: skin.base
  }), React.createElement("path", {
    d: "M632.74,831.87,610,870l11.38,130h31.76C653.91,819.73,632.74,831.87,632.74,831.87Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M233.25,500c0-147.32,119.43-266.75,266.75-266.75S766.75,352.68,766.75,500A266.22,266.22,0,0,1,668.1,707.12q-8.21,6.68-16.94,12.69C591,758,515,758,446.39,751.89c-6.66-1-13.3-2.26-19.89-3.71-26.33-5.8-51.82-14.75-75.37-27.8Q342.4,715,334.2,708.76a199.59,199.59,0,0,1-15.8-13.38q-7.14-6.63-13.79-13.78A265.86,265.86,0,0,1,233.25,500Z",
    fill: skin.base
  }), React.createElement("path", {
    d: "M269.61,634.48c.7,1.2,1.39,2.4,2.11,3.58.43.72.88,1.42,1.33,2.14.66,1.07,1.32,2.14,2,3.19.48.76,1,1.5,1.46,2.24.66,1,1.32,2,2,3,.51.76,1,1.52,1.56,2.28.66,1,1.32,1.92,2,2.88.54.77,1.1,1.53,1.65,2.3s1.34,1.85,2,2.77,1.15,1.53,1.73,2.29,1.37,1.8,2.07,2.7,1.19,1.51,1.79,2.26,1.41,1.76,2.12,2.63,1.23,1.49,1.85,2.23,1.44,1.72,2.17,2.57,1.27,1.47,1.91,2.2l2.22,2.5c.65.73,1.31,1.44,2,2.16.86.94,1.73,1.87,2.6,2.79l1.21,1.28c1.29,1.34,2.59,2.68,3.91,4l.26.27c1.29,1.28,2.6,2.55,3.91,3.81l1.58,1.5c.95.89,1.9,1.78,2.86,2.66l1.16,1.06c1,.94,2.09,1.86,3.14,2.78q4.9,4.27,10,8.19,8.19,6.24,16.93,11.62c23.55,13,49,22,75.37,27.8,6.59,1.45,13.23,2.7,19.89,3.71,42.1,3.75,87,5.18,129.28-3.08C508.45,729,185.59,612.74,388.8,257.48h0c-2.72,1.25-5.4,2.54-8.06,3.88l-.59.29c-1.22.61-2.44,1.24-3.65,1.88l-1,.53c-3.76,2-7.48,4.07-11.13,6.23l-.9.53c-1.16.69-2.31,1.39-3.46,2.1l-.87.54q-5.36,3.35-10.55,6.93l-1.08.75c-1.09.76-2.16,1.52-3.23,2.29l-.66.47q-3.27,2.39-6.46,4.84l-.62.48c-1,.78-2,1.58-3,2.39l-1.17.94c-1,.81-2,1.62-3,2.45l0,0c-2.11,1.75-4.19,3.55-6.24,5.37l-1.14,1-2.69,2.45L318,305q-4.28,4-8.37,8.17l-1.38,1.41c-.79.82-1.58,1.64-2.36,2.47-.46.49-.92,1-1.37,1.48q-2.06,2.2-4.06,4.46c-.45.51-.91,1-1.36,1.54-.71.81-1.41,1.63-2.11,2.45l-1.51,1.79c-.68.81-1.36,1.62-2,2.44-.54.66-1.08,1.33-1.61,2-1.07,1.33-2.12,2.66-3.16,4-.54.7-1.08,1.4-1.61,2.11s-1.2,1.59-1.79,2.4-1.07,1.45-1.59,2.18-1.13,1.55-1.68,2.33q-1.42,2-2.8,4.05c-.5.73-1,1.48-1.49,2.22s-1.1,1.66-1.64,2.5l-1.49,2.31-1.68,2.71c-.43.69-.86,1.38-1.28,2.07-.89,1.46-1.75,2.93-2.61,4.4l-1.22,2.16c-.54.95-1.08,1.91-1.61,2.87-.4.73-.8,1.46-1.19,2.19-.64,1.19-1.27,2.39-1.9,3.59l-1.2,2.34c-.64,1.28-1.28,2.55-1.91,3.84-.33.69-.67,1.39-1,2.09-.52,1.09-1,2.19-1.53,3.29-.31.66-.61,1.32-.91,2q-1.11,2.47-2.17,5c-.22.52-.43,1.05-.65,1.57-.53,1.27-1.05,2.54-1.56,3.82-.27.67-.53,1.34-.79,2-.5,1.26-1,2.53-1.45,3.8-.21.55-.42,1.1-.62,1.65q-.94,2.63-1.85,5.26l-.56,1.7q-.66,2-1.29,4l-.6,1.91c-.47,1.54-.93,3.08-1.37,4.63-.1.33-.2.66-.29,1q-.78,2.76-1.5,5.54c-.16.59-.3,1.19-.45,1.78-.35,1.39-.69,2.78-1,4.18l-.42,1.75c-.43,1.9-.85,3.8-1.24,5.71l-.15.77q-.51,2.55-1,5.1c-.11.61-.21,1.21-.32,1.82-.26,1.49-.51,3-.74,4.5-.08.51-.17,1-.24,1.52-.3,1.95-.57,3.91-.83,5.88l-.15,1.3c-.2,1.59-.38,3.19-.55,4.79-.06.6-.13,1.2-.19,1.81-.16,1.68-.31,3.37-.45,5.06,0,.35-.06.69-.08,1q-.22,3-.39,6.05c0,.53,0,1.07-.07,1.6q-.1,2.36-.18,4.71c0,.59,0,1.18,0,1.77,0,2.05-.08,4.11-.08,6.17,0,0,0,.07,0,.1,0,2.22,0,4.42.08,6.62,0,.76.06,1.52.08,2.28.05,1.47.1,2.94.17,4.41,0,.89.11,1.77.16,2.66.08,1.33.15,2.66.25,4,.07,1,.16,1.89.24,2.83.11,1.26.21,2.52.34,3.77.09,1,.21,1.94.31,2.91.14,1.21.27,2.43.42,3.64.12,1,.26,2,.39,2.95.16,1.18.32,2.37.5,3.55.15,1,.31,2,.47,3,.18,1.16.37,2.33.57,3.49.18,1,.36,2,.55,3,.21,1.15.43,2.3.65,3.44s.41,2,.62,3c.24,1.14.48,2.27.74,3.4s.44,2,.68,2.93c.26,1.13.54,2.25.82,3.36s.49,1.95.74,2.91c.3,1.12.6,2.23.91,3.34.26,1,.53,1.92.81,2.87.32,1.11.65,2.21,1,3.31s.58,1.89.88,2.84.7,2.19,1.06,3.28.62,1.87.94,2.8c.38,1.09.76,2.18,1.15,3.27.33.91.65,1.83,1,2.74l1.24,3.27c.35.89.69,1.79,1,2.68.44,1.09.89,2.19,1.34,3.28.36.86.71,1.73,1.08,2.59.47,1.12,1,2.22,1.45,3.33.37.82.73,1.65,1.1,2.47.52,1.16,1.07,2.3,1.6,3.44l1.08,2.3c.61,1.26,1.24,2.5,1.87,3.75.32.63.62,1.27.95,1.9q2.88,5.61,6,11.07C268.88,633.26,269.25,633.87,269.61,634.48Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M233.25,500c0-147.32,119.43-266.75,266.75-266.75S766.75,352.68,766.75,500A266.22,266.22,0,0,1,668.1,707.12q-8.21,6.68-16.94,12.69C591,758,515,758,446.39,751.89c-6.66-1-13.3-2.26-19.89-3.71-26.33-5.8-51.82-14.75-75.37-27.8Q342.4,715,334.2,708.76a199.59,199.59,0,0,1-15.8-13.38q-7.14-6.63-13.79-13.78A265.86,265.86,0,0,1,233.25,500Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M386.12,758.72c-90.77,0-72,114.24-72.87,241.28h72.87Z",
    fill: skin.base
  }), React.createElement("path", {
    d: "M367.23,831.87,390,870l-11.39,130H346.88C346.07,819.73,367.23,831.87,367.23,831.87Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M619.47,1070H380.53a13.28,13.28,0,0,1-13.27-13.28V772a13.28,13.28,0,0,1,13.27-13.28H613.76c13.09,0,19,7.66,19,19.88v278.08A13.28,13.28,0,0,1,619.47,1070Z",
    fill: skin.base
  }), React.createElement("path", {
    d: "M629.05,766.62a19.33,19.33,0,0,1-2.51-4,17.25,17.25,0,0,0-8.28-3.51,28.88,28.88,0,0,0-4.5-.34H380.53A13.28,13.28,0,0,0,367.26,772c29,10.42,83.29,16.24,132.74,16.24C563.06,788.24,604.38,778.89,629.05,766.62Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M610,758.72c90.76,0,72,114.24,72.87,241.28H632.74",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M386.12,758.72c-90.77,0-72,114.24-72.87,241.28h50.07",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M380.53,758.82l233.23-.1",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M380.53,1070H497.15C388,1070,396.24,838.82,367.26,838.82v217.86A13.28,13.28,0,0,0,380.53,1070Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M361.26,860.85c-.19-3.67-.11-7.34.05-11s.47-7.35.86-11c.2-1.84.4-3.67.65-5.51s.49-3.67.85-5.51a44.18,44.18,0,0,1,3.59-11,44.18,44.18,0,0,1,3.59,11c.36,1.84.62,3.67.85,5.51s.45,3.67.65,5.51c.38,3.67.68,7.34.85,11s.25,7.34.06,11Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M632.74,870v8c.26,34,.26,69,0,102.75,0,2.87,0,5.72,0,8.53v67.41A13.28,13.28,0,0,1,619.47,1070H380.53a13.28,13.28,0,0,1-13.27-13.28V998.52c0-2.51,0-5.07,0-7.65-.25-34.87-.25-69.87,0-105.3V860.85",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M626.74,870c-.19-4.17-.1-8.35.06-12.53s.47-8.35.85-12.53c.2-2.09.41-4.18.65-6.27s.49-4.17.85-6.26a55.09,55.09,0,0,1,3.59-12.53,55.09,55.09,0,0,1,3.59,12.53c.36,2.09.62,4.18.85,6.26s.45,4.18.65,6.27c.38,4.18.69,8.35.85,12.53s.25,8.36.06,12.53Z",
    fill: colors.outline
  }), React.createElement(BackBody, {
    clothingColor: clothingColor,
    braStraps: braStraps
  }), React.createElement(ClothingBack, {
    color: clothingColor,
    graphic: Graphic
  }), !(ClothingFront === Noop && ClothingBack === Noop) && React.createElement(FrontBody, {
    clothingColor: ClothingBack === DressShirt ? 'white' : clothingColor,
    braStraps: braStraps
  }), React.createElement(ClothingFront, {
    color: clothingColor,
    graphic: Graphic
  }), !faceMask && React.createElement(FacialHair, {
    color: hairColor
  }), React.createElement(Eyes, {
    withLashes: lashes
  }), React.createElement(Mouth, {
    lipColor: lipColor
  }), faceMask && React.createElement(FaceMask, {
    color: faceMaskColor
  }), React.createElement(FrontHair, {
    hairColor: hairColor,
    hasHat: FrontHat !== Noop
  }), React.createElement(Eyebrows, null), React.createElement(FrontHat, {
    color: hatColor,
    scale: hatScale
  }), React.createElement(Accessory, null)));
};

var NormalEyebrows = function NormalEyebrows() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M600.89,460.57a318.14,318.14,0,0,1,33.51-6.65l-2.66.35c13.18-1.74,26.54-2.25,39.75-.48l-2.66-.36c3.27.46,6.54,1,9.82,1.42l-2.66-.36a221,221,0,0,1,29.48,6.11c5,1.39,11.1-1.73,12.3-7a10.19,10.19,0,0,0-7-12.3,239.21,239.21,0,0,0-34.59-6.78l2.66.36a143,143,0,0,0-33.44-1.95,235.08,235.08,0,0,0-33.09,4.55c-5.62,1.13-11.2,2.43-16.76,3.8-5.08,1.25-8.62,7.26-7,12.3a10.19,10.19,0,0,0,12.3,7Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M286.14,460.6a202.56,202.56,0,0,1,29.25-6.19l-2.66.36a195.53,195.53,0,0,1,51.38.08l-2.66-.35a218.94,218.94,0,0,1,29.45,6.1c5,1.4,11.1-1.73,12.3-7a10.19,10.19,0,0,0-7-12.3A227.26,227.26,0,0,0,352,433.6a208.27,208.27,0,0,0-71.22,7.71,10.39,10.39,0,0,0-6,4.6,10.2,10.2,0,0,0-1,7.7c1.65,5.11,6.91,8.54,12.3,7Z",
    fill: colors.outline
  }));
};

var LeftLoweredEyebrows = function LeftLoweredEyebrows() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M603.1,452.29a320.74,320.74,0,0,1,33.51-6.66L634,446a150.31,150.31,0,0,1,39.75-.48l-2.66-.36c3.28.45,6.54,1,9.82,1.41l-2.66-.35a222.52,222.52,0,0,1,29.48,6.1c5,1.4,11.11-1.72,12.3-7a10.19,10.19,0,0,0-7-12.3,239.34,239.34,0,0,0-34.58-6.78l2.65.36a142.93,142.93,0,0,0-33.43-1.95,236.67,236.67,0,0,0-33.1,4.54c-5.61,1.14-11.19,2.44-16.76,3.81-5.08,1.25-8.61,7.26-7,12.3a10.21,10.21,0,0,0,12.3,7Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M261.26,502.22l14.13-1.48,33.67-3.52L350,492.93l35.18-3.69c5.72-.59,11.44-1.17,17.16-1.79l.24,0c2.73-.28,5.07-.92,7.07-2.93a10,10,0,0,0,0-14.14c-1.83-1.69-4.48-3.2-7.07-2.93l-14.13,1.48-33.67,3.53-41,4.29-35.18,3.68c-5.72.6-11.44,1.18-17.16,1.8l-.24,0c-2.73.29-5.07.93-7.07,2.93a10,10,0,0,0,0,14.15c1.83,1.68,4.48,3.2,7.07,2.92Z",
    fill: colors.outline
  }));
};

var Grin = function Grin() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M463.75,593.17c15.55,0,25.12,12.76,36.49,12.76s25.91-12.76,41.27-12.76,23.72,11.12,23.72,26.52c0,16.65-16.75,46-62.6,46s-65.4-27.74-65.4-45.45C437.23,603.89,448.2,593.17,463.75,593.17Z",
    fill: colors.white,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("line", {
    x1: "477.85",
    y1: "596.6",
    x2: "477.85",
    y2: "662.1",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("line", {
    x1: "526.99",
    y1: "596.6",
    x2: "526.99",
    y2: "662.1",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }));
};

var SadMouth = function SadMouth() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M538.71,665.74c-15.55,0-25.12-12.76-36.48-12.76S476.31,665.74,461,665.74s-23.73-11.11-23.73-26.51c0-16.65,16.75-46.06,62.61-46.06s65.39,27.74,65.39,45.46C565.23,655,554.27,665.74,538.71,665.74Z",
    fill: colors.outline,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M511.14,655.25C506.58,643,491,635,473.29,636.57c-14.79,1.34-26.93,9.09-31.84,19.1,3.92,6.26,10.51,10.07,19.51,10.07,15.35,0,29.9-12.76,41.27-12.76A21.5,21.5,0,0,1,511.14,655.25Z",
    fill: colors.tongue
  }), React.createElement("path", {
    d: "M455.06,628.66l.87-.35.73-.25c.47-.16.94-.28,1.41-.4a21.33,21.33,0,0,1,2.85-.53,24.24,24.24,0,0,1,5.84-.07,21.24,21.24,0,0,1,11.15,4.48,20.07,20.07,0,0,1,6.55,9.27,17.31,17.31,0,0,1,.2,10.44c-2.5-2.58-4.46-4.94-6.43-6.88a27.89,27.89,0,0,0-2.88-2.58,13.78,13.78,0,0,0-3-1.72,15.18,15.18,0,0,0-6.35-1.15,29.08,29.08,0,0,0-3.43.3c-.57.1-1.16.19-1.72.31l-.84.19-.39.08c-.09,0-.29.08-.22,0Z",
    fill: colors.outline
  }));
};

var Lips = function Lips(_ref) {
  var lipColor = _ref.lipColor;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var _colors$lipColors = colors.lipColors[lipColor || 'red'],
      base = _colors$lipColors.base,
      shadow = _colors$lipColors.shadow;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M558.55,642.44c-3.63,0-5.35-1.31-15.58-10.79-7.49-6.93-12.63-10.36-18.91-11.46-7.83-1.37-15.83-.88-24.36,7.68-8.53-8.56-16.52-9-24.36-7.68-6.28,1.1-11.42,4.53-18.91,11.46-10.23,9.48-11.95,10.79-15.58,10.79a1.84,1.84,0,0,0-1.3,3.14q26.25,26.25,60.15,26.28t60.15-26.28A1.84,1.84,0,0,0,558.55,642.44Z",
    fill: base
  }), React.createElement("path", {
    d: "M559.57,645.84l-.55-2.21c-70.56,16.12-118.17.53-118.17.53l-1.77-.31a1.82,1.82,0,0,0,.47,1.73q26.25,26.25,60.15,26.28Q533.38,671.86,559.57,645.84Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M479.28,650.39c13.45-.94,26.69-1.44,39.89-3,6.59-.76,13.15-1.74,19.67-2.86s13-2.41,19.51-3.8l1.34,5.85q-9.87,2.34-19.92,3.81t-20.16,2.06c-6.75.37-13.5.54-20.25.27A127.84,127.84,0,0,1,479.28,650.39Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M441.79,641.31c1.69.43,3.57,1,5.38,1.48s3.65,1.08,5.49,1.63,3.68,1.1,5.52,1.77a27.06,27.06,0,0,1,5.46,2.64,22.06,22.06,0,0,1-6.05.9c-2,0-3.95-.16-5.93-.32s-3.93-.47-5.88-.85a38.82,38.82,0,0,1-5.86-1.55Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M558.55,642.44c-3.63,0-5.35-1.31-15.58-10.79-7.49-6.93-12.53-11.29-18.91-11.46-11.21-.3-19.15,6.12-24.76,6.12s-10.45-7.53-24-6.12c-6.34.66-11.42,4.53-18.91,11.46-10.23,9.48-11.95,10.79-15.58,10.79a1.84,1.84,0,0,0-1.3,3.14q26.25,26.25,60.15,26.28t60.15-26.28A1.84,1.84,0,0,0,558.55,642.44Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M524.06,626.48a41.49,41.49,0,0,0-12.19,2.94c-1.94.77-3.87,1.6-5.85,2.42a20.2,20.2,0,0,1-6.42,1.74,8.92,8.92,0,0,1-3.47-.64,24,24,0,0,1-3-1.4,59.7,59.7,0,0,0-5.58-2.83,27.56,27.56,0,0,0-5.94-1.73,38.5,38.5,0,0,0-6.29-.5,26.31,26.31,0,0,1,6.4-.48,24.54,24.54,0,0,1,6.38,1.25,46,46,0,0,1,5.9,2.6c1.87.94,3.71,1.83,5.52,1.74a19.76,19.76,0,0,0,5.8-1.51c2-.71,4-1.51,6-2.13A30,30,0,0,1,524.06,626.48Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M472.62,652.36c3.22,0,3.23-5,0-5s-3.22,5,0,5Z",
    fill: colors.outline
  }));
};

var SmileOpen = function SmileOpen() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M443.14,621.86c0-18.9,113.72-16.06,113.72,0a56.86,56.86,0,0,1-113.72,0Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M495,643c-16.95-1-31.73,6.75-36.65,18.22a56.86,56.86,0,0,0,65.14,12.53A55.39,55.39,0,0,0,530,670.2C529.08,656.09,514.06,644.18,495,643Z",
    fill: colors.tongue
  }), React.createElement("path", {
    d: "M443.14,621.86c0-18.9,113.72-16.06,113.72,0a56.86,56.86,0,0,1-113.72,0Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "6px"
  }), React.createElement("path", {
    d: "M478.12,632.46c.45-.11.63-.16.92-.21l.75-.14c.49-.09,1-.14,1.46-.18a21.54,21.54,0,0,1,2.89-.1,25,25,0,0,1,5.79.81,21.4,21.4,0,0,1,10.35,6.1,20.18,20.18,0,0,1,5.08,10.16A17.27,17.27,0,0,1,504,659.25c-2.07-2.93-3.66-5.56-5.32-7.76a28.41,28.41,0,0,0-2.45-3,14.06,14.06,0,0,0-2.7-2.16,15.48,15.48,0,0,0-6.11-2.09A29.5,29.5,0,0,0,484,644c-.59,0-1.18,0-1.76.05l-.85.06-.39,0c-.1,0-.3,0-.23,0Z",
    fill: colors.outline
  }));
};

var Back = function Back(_ref) {
  var hairColor = _ref.hairColor;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var base = colors.hair[hairColor].base;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M501.71,209.52c-166.14,0-300.83,134.68-300.83,300.83V816.78c0,166.14,134.69,300.83,300.83,300.83S802.54,982.92,802.54,816.78V510.35C802.54,344.2,667.85,209.52,501.71,209.52Z",
    fill: base,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }));
};
var Front = function Front(_ref2) {
  var hairColor = _ref2.hairColor;

  var _useTheme2 = useTheme(),
      colors = _useTheme2.colors,
      skin = _useTheme2.skin;

  var base = colors.hair[hairColor].base;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M559.29,397.34c-12.87,24-60,37.44-63.83,31.42-4.3-6.73,37.84-55.32,13.9-106.14",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M746.9,365.72c-43.51-90.29-140.27-142-244.74-142-131.19,0-253.5,95-275.32,223.74,0,0,202.41,15.32,275.25-67.4C511.7,384.77,658.18,457.67,746.9,365.72Z",
    fill: base
  }), React.createElement("path", {
    d: "M502.16,233.15a361.93,361.93,0,0,0-51.86,7.33l-12.68,3.05c-4.2,1.13-8.36,2.37-12.54,3.55l-12.39,4c-4.09,1.46-8.13,3-12.2,4.54a339.08,339.08,0,0,0-46.87,22.71,388.52,388.52,0,0,0-43.25,29.58,233,233,0,0,1,40.79-33.56,258.22,258.22,0,0,1,47.14-24.31c4.17-1.5,8.32-3.06,12.5-4.51,4.24-1.29,8.44-2.7,12.7-3.9s8.58-2.19,12.89-3.21,8.68-1.76,13-2.53A224.82,224.82,0,0,1,502.16,233.15Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M537.23,398.81C526.9,418.12,489.07,428.88,486,424c-3.45-5.4,30.38-44.42,11.16-85.22",
    fill: base
  }), React.createElement("path", {
    d: "M240.15,454.33s185.57,8.28,259.86-72c-5,19.52-15.75,34.09-13.79,37.16,2.89,4.53,38-5.42,48.16-23.35,45.56,19,131.48,41.33,206.15-16.09",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }));
};
var hatScale = 1.12;

var LongHair = {
  __proto__: null,
  Back: Back,
  Front: Front,
  hatScale: hatScale
};

var Back$1 = function Back() {
  return React.createElement(React.Fragment, null);
};
var Front$1 = function Front(_ref) {
  var hairColor = _ref.hairColor,
      _ref$hasHat = _ref.hasHat,
      hasHat = _ref$hasHat === void 0 ? false : _ref$hasHat;

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      skin = _useTheme.skin;

  var _colors$hair$hairColo = colors.hair[hairColor],
      base = _colors$hair$hairColo.base,
      shadow = _colors$hair$hairColo.shadow;
  return React.createElement(React.Fragment, null, !hasHat && React.createElement(React.Fragment, null, React.createElement("circle", {
    cx: "499.7",
    cy: "170.67",
    r: "107.58",
    fill: base
  }), React.createElement("path", {
    d: "M559.29,397.34c-12.87,24-60,37.44-63.83,31.42-4.3-6.73,37.84-55.32,13.9-106.14",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M420.82,134.59A71.58,71.58,0,0,1,433,112.84c1.37-1.59,2.72-3.21,4.16-4.74s3-3,4.53-4.41,3.21-2.73,4.88-4,3.41-2.5,5.17-3.65,3.6-2.21,5.47-3.19l2.82-1.43a31,31,0,0,1,2.86-1.35c2-.76,3.89-1.62,5.89-2.29s4-1.32,6-1.81a72,72,0,0,1,24.86-2,112.32,112.32,0,0,0-24,5c-1,.26-1.9.7-2.85,1l-2.85,1c-1.88.73-3.69,1.65-5.54,2.45s-3.58,1.85-5.38,2.77-3.44,2.09-5.17,3.12-3.33,2.28-5,3.41-3.15,2.52-4.76,3.75-3,2.68-4.53,4l-4.28,4.31A110.47,110.47,0,0,0,420.82,134.59Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M409.8,229.76C429,259,435.67,233.25,498,233.25c107.21,0,73.62,25,92.69-5.15-27.59-9.65-44-19.39-88.13-19.39C460.26,208.71,438.69,219.05,409.8,229.76Z",
    fill: shadow
  }), React.createElement("circle", {
    cx: "499.7",
    cy: "170.67",
    r: "107.58",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), React.createElement("path", {
    d: "M421.52,244.56C335.16,273.62,263.78,346.74,245.06,429.8,213,556.34,262.89,634,307.17,681.6c4.37,4.7-69.46-138.26-2.43-241,61.1-2.32,152.42-14.38,195.78-62.86C496.18,398.87,484,415,486,418.18c2.88,4.51,38.19-5.53,47.84-23.54l.83-3.61c34.72,12.58,91.76,26.59,144,6.61C801.81,535.94,691.29,689,700.3,679a265.78,265.78,0,0,0,69-179c0-86.42-44.28-148.89-44.28-148.89C694.5,296.7,641.5,259.24,580.22,242",
    fill: base
  }), React.createElement("path", {
    d: "M326.66,439.38c5.38-52.22,25-112.5,64.7-181.9h0q-4.07,1.88-8.06,3.88l-.59.29c-1.22.61-2.44,1.24-3.65,1.88l-1,.53q-5.64,3-11.13,6.23l-.9.53c-1.16.69-2.31,1.39-3.46,2.1l-.86.54q-5.37,3.35-10.56,6.93l-1.08.75c-1.08.76-2.16,1.52-3.23,2.29l-.65.47q-3.27,2.39-6.47,4.84l-.62.48c-1,.78-2,1.58-3,2.39l-1.18.94c-1,.81-2,1.62-3,2.45l0,0c-2.11,1.75-4.18,3.55-6.24,5.37l-1.14,1-2.69,2.45L320.53,305q-4.27,4-8.37,8.17l-1.37,1.41c-.8.82-1.59,1.64-2.37,2.47l-1.37,1.48Q305,320.77,303,323c-.46.51-.92,1-1.37,1.54-.71.81-1.41,1.63-2.11,2.46-.51.59-1,1.18-1.51,1.78-.68.81-1.36,1.62-2,2.44-.54.66-1.07,1.33-1.61,2-1.06,1.33-2.11,2.66-3.15,4-.55.7-1.09,1.4-1.62,2.11s-1.2,1.59-1.79,2.4l-1.59,2.18c-.56.78-1.13,1.55-1.68,2.33-.94,1.34-1.88,2.69-2.8,4.05-.5.73-1,1.48-1.48,2.22s-1.11,1.66-1.65,2.5-1,1.54-1.48,2.31-1.13,1.8-1.69,2.71c-.43.69-.86,1.38-1.28,2.07q-1.32,2.19-2.6,4.4c-.42.72-.82,1.44-1.23,2.16-.54.95-1.08,1.91-1.61,2.87-.4.73-.8,1.46-1.19,2.19-.64,1.19-1.27,2.39-1.89,3.59-.41.78-.81,1.56-1.21,2.34-.64,1.28-1.28,2.55-1.9,3.84-.34.69-.67,1.39-1,2.09-.52,1.09-1,2.19-1.54,3.29l-.91,2q-1.11,2.47-2.17,5c-.22.52-.43,1.05-.65,1.57-.53,1.27-1,2.54-1.56,3.82-.26.67-.53,1.34-.79,2-.49,1.26-1,2.53-1.45,3.8l-.61,1.65q-1,2.63-1.86,5.26l-.56,1.7q-.66,2-1.29,4c-.2.63-.4,1.27-.59,1.91q-.72,2.31-1.38,4.63c-.1.33-.2.66-.29,1q-.78,2.76-1.5,5.54l-.45,1.78c-.19.74-.37,1.49-.55,2.24-1.56,6.69-2.88,13.23-4,19.64-.1.65-.22,1.3-.32,1.95l-.24,1.51q-.45,2.94-.82,5.89c-.06.43-.11.87-.16,1.3-.2,1.59-.38,3.19-.55,4.79l-.18,1.81c-.17,1.68-.32,3.37-.45,5.06l-.09,1q-.23,3-.38,6.05c0,.53-.05,1.07-.08,1.6q-.11,2.36-.18,4.71c0,.59,0,1.18-.05,1.77,0,2.05-.07,4.11-.07,6.17v.1q0,3.31.08,6.62c0,.76.06,1.52.08,2.28.05,1.47.1,2.94.17,4.41.05.89.11,1.77.16,2.66.08,1.33.16,2.66.25,4,.07,1,.16,1.89.24,2.83.11,1.26.21,2.52.34,3.77.09,1,.21,1.94.31,2.91.14,1.21.27,2.43.42,3.64.12,1,.26,2,.39,2.95.16,1.18.33,2.37.5,3.55.15,1,.31,2,.47,3,.19,1.16.37,2.33.58,3.49.17,1,.35,2,.54,3,.21,1.15.43,2.3.66,3.44s.4,2,.61,3c.24,1.14.48,2.27.74,3.4s.45,2,.68,2.93c.26,1.13.54,2.25.82,3.36s.49,1.95.75,2.91c.29,1.12.59,2.23.9,3.34.27,1,.53,1.92.81,2.87.32,1.11.65,2.21,1,3.31s.57,1.89.87,2.84.71,2.19,1.07,3.28c.31.93.61,1.87.93,2.8l1.15,3.27,1,2.74c.41,1.09.83,2.18,1.25,3.27.34.89.68,1.79,1,2.68.44,1.09.89,2.19,1.34,3.28.36.86.71,1.73,1.08,2.59.48,1.12,1,2.22,1.46,3.33.36.83.72,1.65,1.09,2.47.52,1.16,1.07,2.3,1.61,3.44.36.77.71,1.54,1.08,2.3.6,1.26,1.23,2.5,1.86,3.75l.95,1.9q2.88,5.61,6,11.07c.36.62.73,1.23,1.09,1.84.7,1.2,1.39,2.4,2.11,3.58.44.72.89,1.42,1.33,2.14.66,1.07,1.32,2.14,2,3.19.48.76,1,1.5,1.47,2.24.65,1,1.31,2,2,3,.51.76,1,1.52,1.56,2.28.66,1,1.32,1.92,2,2.88.54.77,1.1,1.53,1.65,2.3s1.34,1.85,2,2.77,1.15,1.53,1.72,2.29l2.07,2.7c.59.76,1.19,1.51,1.79,2.26s1.41,1.76,2.12,2.63,1.23,1.49,1.85,2.23,1.44,1.72,2.17,2.57,1.27,1.47,1.91,2.2l2.22,2.5c.65.73,1.31,1.44,2,2.16l1.15,1.25c2.9,1.92-68.91-139.3-2.51-241.08C311.7,440.33,319,439.94,326.66,439.38Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M657.94,378.93s-2.1,20.81-50.63,28.22c23.11,1.6,47.74-.46,71.38-9.51C681.91,401.25,657.94,378.93,657.94,378.93Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M304.74,441s-11,1.14-30.77-1.89",
    fill: base
  }), React.createElement("path", {
    d: "M305.35,447c-.51.08-.81.11-1.19.15s-.71.07-1.07.1c-.7,0-1.39.08-2.08.08-1.37,0-2.73,0-4.08-.16a61,61,0,0,1-8-1.22c-1.31-.29-2.61-.59-3.9-1a31.69,31.69,0,0,1-3.83-1.25,22.55,22.55,0,0,1-7.25-4.59,23.84,23.84,0,0,1,4.11-1.63,31.51,31.51,0,0,1,3.95-.91c2.59-.42,5.12-.55,7.64-.79s5-.39,7.45-.53c1.22-.08,2.44-.12,3.63-.17l1.78,0c.29,0,.59,0,.86,0s.6,0,.73,0Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M677,396.19s-10.71-14.3-40.38-31",
    fill: base
  }), React.createElement("path", {
    d: "M672.14,399.78l-1.77-1.91-2-2.12c-1.39-1.41-2.82-2.85-4.27-4.25-2.92-2.82-5.95-5.62-9-8.4s-6.3-5.44-9.43-8.32c-1.56-1.44-3.13-2.91-4.63-4.52a48,48,0,0,1-4.39-5.1,43.5,43.5,0,0,1,6.65,1.34,60,60,0,0,1,6.24,2.24c2,.89,4,1.83,5.91,2.91s3.84,2.13,5.72,3.29A96.15,96.15,0,0,1,672,382.62c1.71,1.45,3.43,2.91,5,4.53.82.79,1.61,1.63,2.39,2.5.39.45.78.87,1.16,1.35s.72.89,1.22,1.59Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M421.52,244.56C335.16,273.62,263.78,346.74,245.06,429.8,213,556.34,262.89,634,307.17,681.6c4.37,4.7-69.46-138.26-2.43-241,61.1-2.32,152.42-14.38,195.78-62.86C496.18,398.87,484,415,486,418.18c2.88,4.51,38.19-5.53,47.84-23.54l.83-3.61c34.72,12.58,91.76,26.59,144,6.61C801.81,535.94,691.29,689,700.3,679a265.78,265.78,0,0,0,69-179c0-86.42-44.28-148.89-44.28-148.89C694.5,296.7,641.5,259.24,580.22,242",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M520.11,249.17a367.15,367.15,0,0,0-42.48,4.93c-3.49.68-7,1.42-10.44,2.06s-6.9,1.61-10.35,2.41l-10.27,2.72c-3.39,1-6.76,2.08-10.14,3.11A312.8,312.8,0,0,0,397,280.14a347.55,347.55,0,0,0-37.25,21A183.48,183.48,0,0,1,394.83,276a218.27,218.27,0,0,1,39.76-17.3c3.47-1,6.93-2.08,10.42-3.05s7-1.82,10.54-2.59,7.1-1.41,10.66-2,7.15-1.08,10.74-1.52A189.39,189.39,0,0,1,520.11,249.17Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M529.83,233.83a70.16,70.16,0,0,1,15.44-1.92c2.56-.06,5.11,0,7.67.13s5.12.3,7.68.52a138.69,138.69,0,0,1,15.35,2.2A95.37,95.37,0,0,1,591.05,239l-3.9,11.35c-4.61-1.38-9.24-2.78-13.94-4.07s-9.45-2.51-14.25-3.71l-7.25-1.76c-2.43-.57-4.87-1.15-7.3-1.81A85.14,85.14,0,0,1,529.83,233.83Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M412.45,241.49a96.65,96.65,0,0,1,13.65-4.15,138.88,138.88,0,0,1,14-2.45c2.34-.28,4.68-.53,7-.71s4.69-.33,7-.34a57.35,57.35,0,0,1,14.27,1.58,77.5,77.5,0,0,1-13.13,5.5c-2.19.73-4.39,1.37-6.59,2l-6.55,1.93c-4.34,1.32-8.67,2.6-12.94,4s-8.52,2.72-12.79,4Z",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "514.26",
    cy: "233.25",
    r: "5.84",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "497.99",
    cy: "233.25",
    r: "4.13",
    fill: colors.outline
  }));
};

var BunHair = {
  __proto__: null,
  Back: Back$1,
  Front: Front$1
};

var Back$2 = function Back() {
  return React.createElement(React.Fragment, null);
};
var Front$2 = function Front(_ref) {
  var hairColor = _ref.hairColor;

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      skin = _useTheme.skin;

  var _colors$hair$hairColo = colors.hair[hairColor],
      base = _colors$hair$hairColo.base,
      shadow = _colors$hair$hairColo.shadow;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M558.73,399.34c-12.86,24-60,37.44-63.83,31.42-4.29-6.73,37.85-55.32,13.9-106.14",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M784,342.85c-5.1-5.1-31.06,1.83-57.19-.23A281,281,0,0,0,505.63,228.28c-2.44-20.48-.75-37.68-2.61-40.1-2.49-3.22-15.49,12.68-18.87,31-11.91-15-32.14-23-32.72-18.8-.38,2.68,7.44,14.09,14.81,29.9-111.6,13.47-203.08,92.26-235.08,197-13.86,11.92-26.86,20.34-27,25.69-.27,9.92,39.31,9.36,56.58,7.82v-.06c60.65-2,179-13.78,236.42-72.89C491.64,406.93,481.47,421,483.43,424c3,4.67,38.32-5.19,50.07-23.24,48,19.59,139.49,43.16,219-16.16l-.22-.43C766.77,372.06,790.35,349.25,784,342.85Z",
    fill: base
  }), React.createElement("path", {
    d: "M726.85,348.62c-5.4.24-10.66.11-16-.14s-10.59-.67-15.87-1.26c-2.64-.29-5.28-.6-7.91-1s-5.27-.72-7.89-1.23a76.91,76.91,0,0,1-15.58-4.54,91.87,91.87,0,0,1,16-2.62c2.63-.22,5.26-.37,7.89-.48l7.88-.34c5.25-.22,10.49-.34,15.72-.45s10.48-.12,15.62,0Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M236.6,430s0,.24,0,.39l-.12.53-.28,1.11c-.21.75-.43,1.52-.66,2.29-.47,1.55-1,3.14-1.54,4.75s-1.06,3.28-1.77,5a20.6,20.6,0,0,1-1.38,2.6,17.91,17.91,0,0,1-2.07,2.77,13.14,13.14,0,0,1-3.72-5.47,16.11,16.11,0,0,1-.76-2.9c-.21-1-.31-2-.43-2.95a30,30,0,0,1,0-6,24.44,24.44,0,0,1,.48-3c.12-.5.25-1,.41-1.51a7.84,7.84,0,0,1,.27-.77c.1-.28.18-.48.36-.9Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M260.74,460.82v-.06c17-.56,38.63-1.9,62.14-4.84,2.63-55.92,22-121.58,65.92-198.44h0L382,254.23A282.15,282.15,0,0,0,231.16,427.31c-13.86,11.92-26.86,20.34-27,25.69C203.89,462.92,243.47,462.36,260.74,460.82Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M784,342.85c-5.1-5.1-31.06,1.83-57.19-.23A281,281,0,0,0,505.63,228.28c-2.44-20.48-.75-37.68-2.61-40.1-2.49-3.22-15.49,12.68-18.87,31-11.91-15-32.14-23-32.72-18.8-.38,2.68,7.44,14.09,14.81,29.9-111.6,13.47-203.08,92.26-235.08,197-13.86,11.92-26.86,20.34-27,25.69-.27,9.92,39.31,9.36,56.58,7.82v-.06c60.65-2,179-13.78,236.42-72.89C491.64,406.93,481.47,421,483.43,424c3,4.67,38.32-5.19,50.07-23.24,48,19.59,139.49,43.16,219-16.16l-.22-.43C766.77,372.06,790.35,349.25,784,342.85Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M505.93,244.31a367.42,367.42,0,0,0-42.48,4.94c-3.48.67-6.95,1.41-10.44,2.05s-6.9,1.61-10.35,2.41l-10.26,2.72c-3.4,1-6.77,2.08-10.15,3.12a314.12,314.12,0,0,0-39.43,15.73,348.31,348.31,0,0,0-37.25,21,183.85,183.85,0,0,1,35.08-25.14,219.23,219.23,0,0,1,39.76-17.29c3.48-1,6.94-2.09,10.42-3.05s7-1.82,10.55-2.6,7.1-1.4,10.66-2,7.15-1.07,10.73-1.52A190,190,0,0,1,505.93,244.31Z",
    fill: colors.white
  }));
};

var ShortHair = {
  __proto__: null,
  Back: Back$2,
  Front: Front$2
};

var Back$3 = function Back() {
  return React.createElement(React.Fragment, null);
};
var Front$3 = function Front(_ref) {
  var hairColor = _ref.hairColor;

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      skin = _useTheme.skin;

  var _colors$hair$hairColo = colors.hair[hairColor],
      base = _colors$hair$hairColo.base,
      shadow = _colors$hair$hairColo.shadow;
  return React.createElement(React.Fragment, null, React.createElement("rect", {
    x: "290.23",
    y: "414.02",
    width: "439.24",
    height: "64.15",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M710,667.66q-4.71,5.82-9.71,11.37C697.79,681.8,702.87,677.91,710,667.66Zm15-316.55C694.5,296.7,641.5,259.24,580.22,242l-6.35-1.71c-22.7-6.28-46.62-7-71.32-7-26.69,0-52.46,2.74-76.77,10l-4.26,1.27C335.16,273.62,263.78,346.74,245.06,429.8,213,556.34,262.89,634,307.17,681.6c4.37,4.7-57.93-101.85-17.42-216,7.73-.29,20.24-.51,36.19-.67l15.5-50.61,17.44,50.38c27.4-.13,59.88-.15,93.88-.12l12.32-52.36L479,464.6c74.37.14,151.44.52,195.28.77l13.2-52.17,15,52.33,8.21.05C760.78,572,728.5,641.13,710,667.66A265.62,265.62,0,0,0,769.3,500C769.3,413.58,725,351.11,725,351.11Z",
    fill: base
  }), React.createElement("path", {
    d: "M325.14,464.92c.9-57.85,19.88-126.43,66.22-207.44h0q-4.07,1.88-8.06,3.88l-.59.29c-1.22.61-2.44,1.24-3.65,1.88l-1,.53q-5.64,3-11.13,6.23l-.9.53c-1.16.69-2.31,1.39-3.46,2.1l-.86.54q-5.37,3.35-10.56,6.93l-1.08.75c-1.08.76-2.16,1.52-3.23,2.29l-.65.47q-3.27,2.39-6.47,4.84l-.62.48c-1,.78-2,1.58-3,2.39l-1.18.94c-1,.81-2,1.62-3,2.45l0,0c-2.11,1.75-4.18,3.55-6.24,5.37l-1.14,1-2.69,2.45L320.53,305q-4.27,4-8.37,8.17l-1.37,1.41c-.8.82-1.59,1.64-2.37,2.47l-1.37,1.48Q305,320.77,303,323c-.46.51-.92,1-1.37,1.54-.71.81-1.41,1.63-2.11,2.45L298,328.8c-.68.81-1.36,1.62-2,2.44-.54.66-1.07,1.33-1.61,2-1.06,1.33-2.11,2.66-3.15,4-.55.7-1.09,1.4-1.62,2.11s-1.2,1.59-1.79,2.4l-1.59,2.18c-.56.78-1.13,1.55-1.68,2.33-.94,1.34-1.88,2.69-2.8,4.05-.5.73-1,1.48-1.48,2.22s-1.11,1.66-1.65,2.5-1,1.54-1.48,2.31-1.13,1.8-1.69,2.71c-.43.69-.86,1.38-1.28,2.07q-1.32,2.19-2.6,4.4c-.42.72-.82,1.44-1.23,2.16-.54.95-1.08,1.91-1.61,2.87-.4.73-.8,1.46-1.19,2.19-.64,1.19-1.27,2.39-1.89,3.59-.41.78-.81,1.56-1.21,2.34-.64,1.28-1.28,2.55-1.9,3.84-.34.69-.67,1.39-1,2.09-.52,1.09-1,2.19-1.54,3.29l-.91,2q-1.11,2.47-2.17,5c-.22.52-.43,1.05-.65,1.57-.53,1.27-1,2.54-1.56,3.82-.27.67-.53,1.34-.79,2-.49,1.26-1,2.53-1.45,3.8l-.61,1.65q-1,2.63-1.86,5.26l-.56,1.7q-.66,2-1.29,4c-.2.63-.4,1.27-.59,1.91q-.72,2.31-1.38,4.63c-.1.33-.2.66-.29,1q-.78,2.76-1.5,5.54l-.45,1.78c-.19.74-.37,1.49-.55,2.24-1.56,6.69-2.88,13.23-4,19.63-.1.66-.22,1.31-.32,2l-.24,1.52q-.45,2.93-.82,5.88c-.06.43-.11.87-.16,1.3-.2,1.59-.38,3.19-.55,4.79l-.18,1.81c-.17,1.68-.32,3.37-.45,5.06l-.09,1q-.23,3-.38,6.05c0,.53-.05,1.07-.08,1.6q-.11,2.36-.18,4.71c0,.59,0,1.18-.05,1.77,0,2.05-.07,4.11-.07,6.17v.1c0,2.22,0,4.42.08,6.62,0,.76.06,1.52.08,2.28.05,1.47.1,2.94.17,4.41.05.89.11,1.77.16,2.66.08,1.33.16,2.66.25,4l.24,2.83c.11,1.26.21,2.52.34,3.77.09,1,.21,1.94.31,2.91.14,1.21.27,2.43.42,3.64.12,1,.26,2,.39,2.95.16,1.18.33,2.37.5,3.55.15,1,.31,2,.47,3,.19,1.16.37,2.33.58,3.49.17,1,.35,2,.54,3,.21,1.15.43,2.3.66,3.44s.4,2,.61,3c.24,1.14.48,2.27.74,3.4s.45,2,.68,2.93c.27,1.13.54,2.25.82,3.36s.49,1.95.75,2.92.59,2.22.9,3.33c.26,1,.53,1.92.81,2.87.32,1.11.65,2.21,1,3.31s.57,1.89.87,2.84.71,2.19,1.07,3.28c.31.93.61,1.87.93,2.8.38,1.09.76,2.18,1.15,3.27l1,2.74c.41,1.09.83,2.18,1.25,3.27.34.89.68,1.79,1,2.68.44,1.09.89,2.19,1.34,3.28.36.86.71,1.73,1.08,2.59.48,1.12,1,2.22,1.46,3.33.36.83.72,1.65,1.09,2.47.52,1.16,1.07,2.3,1.61,3.44.36.77.71,1.54,1.08,2.3.6,1.26,1.23,2.5,1.86,3.75l.95,1.9q2.88,5.61,6,11.07c.36.62.73,1.23,1.09,1.84.7,1.2,1.39,2.4,2.11,3.58.44.72.89,1.42,1.33,2.14.66,1.07,1.32,2.14,2,3.19.48.76,1,1.5,1.47,2.24.65,1,1.31,2,2,3,.51.76,1,1.52,1.56,2.28.66,1,1.32,1.92,2,2.88.54.77,1.1,1.53,1.65,2.3s1.34,1.85,2,2.77,1.15,1.53,1.72,2.29l2.07,2.7c.59.76,1.19,1.51,1.79,2.26s1.41,1.76,2.12,2.63,1.23,1.49,1.85,2.23,1.44,1.72,2.17,2.57l1.91,2.2,2.22,2.5c.65.73,1.31,1.44,2,2.16.4.44.81.87,1.22,1.31,2.37,1.37-57.48-103.69-17.57-216.15C297.34,465.29,309.57,465.08,325.14,464.92Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M420.82,134.59A71.58,71.58,0,0,1,433,112.84c1.37-1.59,2.72-3.21,4.16-4.74s3-3,4.53-4.41,3.21-2.73,4.88-4,3.41-2.5,5.17-3.65,3.6-2.21,5.47-3.19l2.82-1.43a31,31,0,0,1,2.86-1.35c2-.76,3.89-1.62,5.89-2.29s4-1.32,6-1.81a72,72,0,0,1,24.86-2,112.32,112.32,0,0,0-24,5c-1,.26-1.9.7-2.85,1l-2.85,1c-1.88.73-3.69,1.65-5.54,2.45s-3.58,1.85-5.38,2.77-3.44,2.09-5.17,3.12-3.33,2.28-5,3.41-3.15,2.52-4.76,3.75-3,2.68-4.53,4l-4.28,4.31A110.47,110.47,0,0,0,420.82,134.59Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M520.11,249.17a367.15,367.15,0,0,0-42.48,4.93c-3.49.68-7,1.42-10.44,2.06s-6.9,1.61-10.35,2.41l-10.27,2.72c-3.39,1-6.76,2.08-10.14,3.11A312.8,312.8,0,0,0,397,280.14a347.55,347.55,0,0,0-37.25,21A183.48,183.48,0,0,1,394.83,276a218.27,218.27,0,0,1,39.76-17.3c3.47-1,6.93-2.08,10.42-3.05s7-1.82,10.54-2.59,7.1-1.41,10.66-2,7.15-1.08,10.74-1.52A189.39,189.39,0,0,1,520.11,249.17Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M529.83,233.83a70.16,70.16,0,0,1,15.44-1.92c2.56-.06,5.11,0,7.67.13s5.12.3,7.68.52a138.69,138.69,0,0,1,15.35,2.2A95.37,95.37,0,0,1,591.05,239l-3.89,11.35c-4.62-1.38-9.25-2.78-13.95-4.07s-9.45-2.51-14.25-3.71l-7.25-1.76c-2.43-.57-4.87-1.15-7.3-1.81A85.14,85.14,0,0,1,529.83,233.83Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M710,667.66q-4.71,5.82-9.71,11.37C697.79,681.8,702.87,677.91,710,667.66Zm15-316.55C694.5,296.7,641.5,259.24,580.22,242l-6.35-1.71c-22.7-6.28-46.62-7-71.32-7-26.69,0-52.46,2.74-76.77,10l-4.26,1.27C335.16,273.62,263.78,346.74,245.06,429.8,213,556.34,262.89,634,307.17,681.6c4.37,4.7-57.93-101.85-17.42-216,7.73-.29,20.24-.51,36.19-.67l15.5-50.61,17.44,50.38c27.4-.13,59.88-.15,93.88-.12l12.32-52.36L479,464.6c74.37.14,151.44.52,195.28.77l13.2-52.17,15,52.33,8.21.05C760.78,572,728.5,641.13,710,667.66A265.62,265.62,0,0,0,769.3,500C769.3,413.58,725,351.11,725,351.11Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M284.48,462.85c.18-.75.33-1.32.53-1.94s.4-1.2.62-1.78c.46-1.17,1-2.31,1.51-3.42a48.48,48.48,0,0,1,3.85-6.42,37.51,37.51,0,0,1,4.88-5.75,17,17,0,0,1,7-4,31,31,0,0,1-.87,7.68c-.28,1.14-.59,2.25-.93,3.32l-1,3.25q-1,3.23-2,6.39c-.33,1.06-.68,2.09-1,3.13-.17.51-.37,1-.56,1.53s-.39,1-.56,1.4Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M710.68,459.58a35,35,0,0,1,6.23.06,60.73,60.73,0,0,1,6.24.86c1,.2,2.08.4,3.12.64a25.74,25.74,0,0,1,3.11.86,18.53,18.53,0,0,1,6.24,3.58,18.74,18.74,0,0,1-6.24,3.59,25.68,25.68,0,0,1-3.11.85c-1,.25-2.08.45-3.12.65q-3.12.58-6.24.86a35,35,0,0,1-6.23.05Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M444.84,452.07a132.29,132.29,0,0,1,1.49-14.25c.72-4.7,1.6-9.37,2.61-14s2.15-9.25,3.44-13.83A132.09,132.09,0,0,1,457,396.4a131.77,131.77,0,0,1-1.5,14.25q-1.08,7.05-2.61,14t-3.44,13.83A137,137,0,0,1,444.84,452.07Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M668,452.07a134.88,134.88,0,0,1,1.49-14.25q1.09-7.05,2.61-14T675.49,410a132.09,132.09,0,0,1,4.57-13.58,131.76,131.76,0,0,1-1.49,14.25q-1.1,7.05-2.61,14c-1,4.64-2.16,9.25-3.45,13.83A134.48,134.48,0,0,1,668,452.07Z",
    fill: colors.white
  }));
};

var PixieCut = {
  __proto__: null,
  Back: Back$3,
  Front: Front$3
};

var Back$4 = function Back() {
  return React.createElement(React.Fragment, null);
};
var Front$4 = function Front(_ref) {
  var hairColor = _ref.hairColor;

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      skin = _useTheme.skin;

  var base = colors.hair[hairColor].base;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M425.22,300.35a148.61,148.61,0,0,1,35.91-15A151.13,151.13,0,0,1,500,280,145.16,145.16,0,0,1,539,285.08a138.61,138.61,0,0,1,35.82,15.27,315.9,315.9,0,0,0-37.19-9.13A210.64,210.64,0,0,0,500.05,288a222,222,0,0,0-37.55,3.48A366.93,366.93,0,0,0,425.22,300.35Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M425.22,328.3a148.61,148.61,0,0,1,35.91-15A151.56,151.56,0,0,1,500,308,145.15,145.15,0,0,1,539,313a138.61,138.61,0,0,1,35.82,15.27,317.89,317.89,0,0,0-37.19-9.13,210.64,210.64,0,0,0-37.54-3.23,222,222,0,0,0-37.55,3.48A369.62,369.62,0,0,0,425.22,328.3Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M574.78,328.43a310.55,310.55,0,0,1-37.2,5.68Q518.85,335.91,500,336c-12.55,0-25.1-.47-37.6-1.64a271,271,0,0,1-37.19-5.91c12.59-.39,25-.34,37.49-.37L500,328l37.29-.13C549.73,327.87,562.2,327.86,574.78,328.43Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M574.78,300.47a330.88,330.88,0,0,1-37.24,5.22q-18.72,1.63-37.53,1.71c-12.53.05-25.06-.42-37.56-1.48a288,288,0,0,1-37.23-5.45c12.57-.59,25-.7,37.47-.84L500,299.4c12.42,0,24.85-.06,37.31,0S562.22,299.7,574.78,300.47Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M871.11,500c-94.26-5.93-88.36-172.82-144.1-140.14h0l.42.69c-1.08,8.7-11.09,100.12,26.09,224.1.41-1.25.81-2.51,1.21-3.77,2,5.4,17,39.1,75.81,23.16-40.58-34.22-31.47-75.27-31.47-75.27S843.62,530.09,871.11,500Z",
    fill: base
  }), React.createElement("path", {
    d: "M871.11,500c-94.26-5.93-88.36-172.82-144.1-140.14h0l.42.69c-1.08,8.7-11.09,100.12,26.09,224.1.41-1.25.81-2.51,1.21-3.77,2,5.4,17,39.1,75.81,23.16-40.58-34.22-31.47-75.27-31.47-75.27S843.62,530.09,871.11,500Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M766.75,500a121.9,121.9,0,0,1,1.52,21.66,210.12,210.12,0,0,1-1.6,21.69q-.7,5.4-1.62,10.78c-.65,3.57-1.35,7.14-2.16,10.69a190.76,190.76,0,0,1-6,21l-7.59-2.54c2.11-6.73,4.13-13.49,5.92-20.32l1.32-5.13,1.22-5.16,1.17-5.17,1.07-5.2c1.41-6.94,2.5-13.94,3.53-21S765.53,507.16,766.75,500Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M730.85,358.46A199.08,199.08,0,0,1,742,378.52c.83,1.72,1.62,3.46,2.42,5.2l2.3,5.25,2.15,5.32,2,5.36a210.27,210.27,0,0,1,6.64,21.88,127.56,127.56,0,0,1,3.37,22.58c-2.76-7.11-5.29-14.18-7.94-21.19s-5.32-13.95-8.36-20.76l-2.29-5.09-2.39-5-2.45-5-2.55-4.95c-3.43-6.59-7.09-13-10.87-19.43Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M128.89,500c94.26-5.93,88.36-172.82,144.1-140.14h0l-.42.69c1.08,8.7,11.09,100.12-26.09,224.1-.41-1.25-.81-2.51-1.21-3.77-2,5.4-17,39.1-75.81,23.16,40.58-34.22,31.47-75.27,31.47-75.27S156.38,530.09,128.89,500Z",
    fill: base
  }), React.createElement("path", {
    d: "M128.89,500c94.26-5.93,88.36-172.82,144.1-140.14h0l-.42.69c1.08,8.7,11.09,100.12-26.09,224.1-.41-1.25-.81-2.51-1.21-3.77-2,5.4-17,39.1-75.81,23.16,40.58-34.22,31.47-75.27,31.47-75.27S156.38,530.09,128.89,500Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M233.25,500c1.22,7.16,2.18,14.24,3.24,21.28s2.12,14.05,3.53,21l1.07,5.2,1.17,5.17,1.22,5.16,1.32,5.13c1.79,6.83,3.8,13.59,5.92,20.32l-7.59,2.54a190.76,190.76,0,0,1-6-21c-.81-3.55-1.51-7.12-2.16-10.69s-1.15-7.18-1.62-10.78a210.12,210.12,0,0,1-1.6-21.69A121.9,121.9,0,0,1,233.25,500Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M276,362.65c-3.78,6.39-7.44,12.84-10.87,19.43L262.55,387l-2.45,5-2.39,5-2.29,5.09c-3,6.81-5.74,13.76-8.36,20.76s-5.18,14.08-7.94,21.19a127.56,127.56,0,0,1,3.37-22.58,210.27,210.27,0,0,1,6.64-21.88l2-5.36L253.3,389l2.3-5.25c.8-1.74,1.59-3.48,2.42-5.2a199.08,199.08,0,0,1,11.13-20.06Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M198.29,528.85l-1.6-15.59c-.26-2.66-.59-5.32-.79-8-.07-1.36-.15-2.72-.11-4.13a28.85,28.85,0,0,1,.3-4.29,30.11,30.11,0,0,1,4.45,7.27c.57,1.27,1.06,2.57,1.51,3.88s.88,2.63,1.29,4,.76,2.67,1.1,4,.63,2.72.89,4.09.49,2.75.65,4.15a36.91,36.91,0,0,1,.31,4.34Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M793.65,527.37a36.62,36.62,0,0,1,.88-6.66c.24-1.07.53-2.14.82-3.2s.66-2.11,1-3.15a39.45,39.45,0,0,1,2.68-6.07,17.68,17.68,0,0,1,4.45-5.25,33.5,33.5,0,0,1,.11,6.68c-.09,1-.18,2.09-.31,3.1L803,515.9l-.63,6.1c-.22,2-.43,4.09-.72,5.93Z",
    fill: colors.outline
  }));
};
var hatScale$1 = 0;

var BaldingHair = {
  __proto__: null,
  Back: Back$4,
  Front: Front$4,
  hatScale: hatScale$1
};

var Back$5 = Noop;
var Front$5 = function Front(_ref) {
  var hairColor = _ref.hairColor;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var _colors$hair$hairColo = colors.hair[hairColor],
      base = _colors$hair$hairColo.base,
      shadow = _colors$hair$hairColo.shadow;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M500,233.25c-135.7,0-247.73,101.33-264.56,232.45a307.11,307.11,0,0,0,70.16-98.91A919.45,919.45,0,0,0,500,387.94a899.57,899.57,0,0,0,194.4-21.15,307.11,307.11,0,0,0,70.16,98.91C747.73,334.58,635.7,233.25,500,233.25Z",
    fill: base
  }), React.createElement("path", {
    d: "M305.6,366.79q15.94,3.45,32.07,6.35c10.61-35.4,27.23-73.88,51.13-115.66h0c-1.33.62-2.66,1.24-4,1.87l-.17.08c-1.31.63-2.62,1.27-3.92,1.93l-.59.29c-1.22.61-2.44,1.24-3.65,1.88l-1,.53c-3.76,2-7.48,4.07-11.13,6.23l-.8.47-.14.09q-1.73,1-3.42,2.07l-.87.54q-5.36,3.35-10.55,6.93l-1.08.75c-1,.71-2,1.42-3,2.14l-.71.52-.15.1q-3.27,2.39-6.46,4.84l-.62.48c-1,.78-2,1.58-3,2.39l-1.17.94-2.41,2-.78.65c-2.05,1.71-4.06,3.45-6.06,5.22l-1.14,1-2.69,2.45L318,305q-4.28,4-8.37,8.17l-1,1c-.22.22-.43.44-.64.67-.7.72-1.39,1.44-2.08,2.17-.46.49-.92,1-1.37,1.48q-2.06,2.2-4.06,4.46l-.48.55c-.31.35-.63.7-.94,1.06L297,327c-.11.14-.22.27-.34.4l-1.2,1.43c-.61.72-1.21,1.45-1.81,2.18-.39.47-.78,1-1.17,1.44l-.66.82q-1.59,2-3.13,4l-.07.09c-.53.68-1.05,1.36-1.57,2.05-.4.52-.79,1.05-1.17,1.57l-1,1.33-1.22,1.68-1,1.35-1.41,2c-.57.81-1.13,1.62-1.69,2.44s-1.11,1.64-1.65,2.46l-.25.36-1.52,2.31-1.74,2.72c-.52.83-1,1.66-1.55,2.49h0c-.57.92-1.14,1.84-1.7,2.77s-1,1.68-1.48,2.52-.92,1.56-1.36,2.34l-.57,1-1.13,2c-.42.77-.85,1.53-1.26,2.3-.14.25-.28.5-.41.75-.42.78-.84,1.57-1.25,2.36s-.68,1.29-1,1.94l-.84,1.63-.93,1.88c-.39.78-.78,1.55-1.16,2.34l-.82,1.71-.3.65c-.44.92-.87,1.85-1.3,2.78l-.72,1.59c-.41.91-.81,1.83-1.21,2.75l-1,2.34c-.45,1.07-.88,2.14-1.32,3.21-.32.77-.63,1.53-.94,2.3-.11.26-.21.53-.31.8-.35.88-.69,1.77-1,2.66s-.61,1.57-.9,2.36l-.16.43c-.38,1-.74,2-1.1,3.06s-.64,1.79-1,2.69c-.37,1.08-.73,2.15-1.08,3.23-.3.91-.6,1.82-.89,2.73-.35,1.09-.68,2.17-1,3.26-.28.92-.55,1.84-.82,2.77-.32,1.09-.64,2.19-.94,3.29-.26.92-.51,1.85-.75,2.78-.3,1.11-.59,2.22-.87,3.34-.24.92-.46,1.86-.68,2.79-.27,1.12-.54,2.25-.8,3.37-.21.93-.41,1.87-.61,2.8-.24,1.14-.49,2.29-.73,3.44-.18.91-.35,1.82-.52,2.74s-.39,2-.57,3l-.18,1-.33,2c-.18,1.09-.37,2.19-.54,3.29,0,.21-.07.42-.1.63q-.45,3-.84,6A307.11,307.11,0,0,0,305.6,366.79Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M500,233.25c-135.7,0-247.73,101.33-264.56,232.45a307.11,307.11,0,0,0,70.16-98.91A919.45,919.45,0,0,0,500,387.94a899.57,899.57,0,0,0,194.4-21.15,307.11,307.11,0,0,0,70.16,98.91C747.73,334.58,635.7,233.25,500,233.25Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M506.21,250.1c-12.57,1.68-24.94,3.38-37.16,5.76s-24.29,5.18-36.18,8.64-23.62,7.48-35.18,12.07-22.95,9.73-34.46,15.05a170,170,0,0,1,31.87-20.78,204.11,204.11,0,0,1,73.07-21.19A172.76,172.76,0,0,1,506.21,250.1Z",
    fill: colors.white
  }));
};

var BuzzCut = {
  __proto__: null,
  Back: Back$5,
  Front: Front$5
};

var Back$6 = function Back(_ref) {
  var hairColor = _ref.hairColor;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var _colors$hair$hairColo = colors.hair[hairColor],
      base = _colors$hair$hairColo.base,
      shadow = _colors$hair$hairColo.shadow;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M833.15,369a58.35,58.35,0,0,0-35.89-54.16,58.56,58.56,0,0,0,25.82-48.77c0-27.77-19-51-44.47-56.88a59.13,59.13,0,0,0,7.51-28.9C786.12,148.1,760.55,122,729,122a55.89,55.89,0,0,0-24.2,5.49,58.35,58.35,0,0,0,.67-8.92c0-32.21-25.57-58.33-57.12-58.33a56.49,56.49,0,0,0-43.76,20.86c-1.61-30.74-26.53-55.17-57-55.17A56.9,56.9,0,0,0,497.6,56a56.93,56.93,0,0,0-50-30.07c-30.5,0-55.42,24.43-57,55.17a56.53,56.53,0,0,0-43.77-20.86c-31.53,0-57.11,26.11-57.11,58.33a59.65,59.65,0,0,0,.66,8.92A55.76,55.76,0,0,0,266.21,122c-31.54,0-57.12,26.12-57.12,58.33a59,59,0,0,0,7.51,28.9c-25.45,5.88-44.46,29.11-44.46,56.88A58.56,58.56,0,0,0,198,314.86a58.83,58.83,0,0,0-1.13,107.85,58.81,58.81,0,0,0-14.6,39c0,28.51,20.05,52.25,46.54,57.33-11.51,10.31,545.36,10.93,534.18.55,28.2-3.57,50-28.11,50-57.87a58.87,58.87,0,0,0-14.61-39A58.4,58.4,0,0,0,833.15,369ZM270.81,513.54c-.93-.52-1.89-1-2.85-1.41C268.93,511.56,270.81,513.54,270.81,513.54Z",
    fill: base
  }), React.createElement("path", {
    d: "M470,505.43a51,51,0,0,1-85.38-36.67,51.1,51.1,0,0,1-63.44-66.59,51.18,51.18,0,0,1-32.54-87.48,51.32,51.32,0,0,1-1.26-93.62A51.42,51.42,0,0,1,327,136.89h.16a51.55,51.55,0,0,1,50-63.89,53,53,0,0,1,5.66.31,56.13,56.13,0,0,0-36-13.09c-31.54,0-57.11,26.11-57.11,58.33a59.65,59.65,0,0,0,.66,8.92A55.76,55.76,0,0,0,266.21,122c-31.54,0-57.12,26.12-57.12,58.33a59,59,0,0,0,7.51,28.9c-25.45,5.88-44.46,29.11-44.46,56.88A58.56,58.56,0,0,0,198,314.86a58.83,58.83,0,0,0-1.13,107.85,58.81,58.81,0,0,0-14.6,39c0,28.51,20.05,52.25,46.54,57.33-5.61,5,123.81,7.75,256.66,8A51.14,51.14,0,0,1,470,505.43Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M741.2,386l-35,78.16,39.47,58.61c12.24-.91,18.61-2,17.31-3.17,28.2-3.57,50-28.11,50-57.87a60.75,60.75,0,0,0-.8-9.7C792.18,391.39,741.2,386,741.2,386Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M833.15,369a58.35,58.35,0,0,0-35.89-54.16,58.56,58.56,0,0,0,25.82-48.77c0-27.77-19-51-44.47-56.88a59.13,59.13,0,0,0,7.51-28.9C786.12,148.1,760.55,122,729,122a55.89,55.89,0,0,0-24.2,5.49,58.35,58.35,0,0,0,.67-8.92c0-32.21-25.57-58.33-57.12-58.33a56.49,56.49,0,0,0-43.76,20.86c-1.61-30.74-26.53-55.17-57-55.17A56.9,56.9,0,0,0,497.6,56a56.93,56.93,0,0,0-50-30.07c-30.5,0-55.42,24.43-57,55.17a56.53,56.53,0,0,0-43.77-20.86c-31.53,0-57.11,26.11-57.11,58.33a59.65,59.65,0,0,0,.66,8.92A55.76,55.76,0,0,0,266.21,122c-31.54,0-57.12,26.12-57.12,58.33a59,59,0,0,0,7.51,28.9c-25.45,5.88-44.46,29.11-44.46,56.88A58.56,58.56,0,0,0,198,314.86a58.83,58.83,0,0,0-1.13,107.85,58.81,58.81,0,0,0-14.6,39c0,28.51,20.05,52.25,46.54,57.33-11.51,10.31,545.36,10.93,534.18.55,28.2-3.57,50-28.11,50-57.87a58.87,58.87,0,0,0-14.61-39A58.4,58.4,0,0,0,833.15,369Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }));
};
var Front$6 = function Front(_ref2) {
  var hairColor = _ref2.hairColor;

  var _useTheme2 = useTheme(),
      colors = _useTheme2.colors,
      skin = _useTheme2.skin;

  var _colors$hair$hairColo2 = colors.hair[hairColor],
      base = _colors$hair$hairColo2.base,
      shadow = _colors$hair$hairColo2.shadow;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M558.42,406.88c-12.87,24-60,37.45-63.83,31.42-4.3-6.73,37.85-55.32,13.9-106.14",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M500.15,221.81C369,221.81,247.79,328.25,226,457c0,0,201.33,15.23,274.66-66.75-4.65,22.65-17.72,39.87-15.51,43.33,3.08,4.84,40.92-5.92,51.25-25.22l-3.66-5.48C582.65,421,680.23,443.46,746,375.26,702.52,285,604.61,221.81,500.15,221.81Z",
    fill: base
  }), React.createElement("path", {
    d: "M331.52,454.81a51.09,51.09,0,0,1-10.35-52.64,51.12,51.12,0,0,1-47.23-58.35c-24.09,33.69-41,72.3-48,113.18A671.08,671.08,0,0,0,331.52,454.81Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M739.66,389.6C665,447,579.07,424.7,533.51,405.69c-10.14,17.94-45.26,27.89-48.15,23.36-2-3.08,8.82-17.65,13.78-37.16-74.28,80.27-259.85,72-259.85,72",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M280.92,140.17a53.59,53.59,0,0,0-20.26,5A45.83,45.83,0,0,0,245,157a18.94,18.94,0,0,0-1.53,1.92c-.48.66-1,1.28-1.46,2a43.23,43.23,0,0,0-2.56,4.23,52.32,52.32,0,0,0-3.9,9.18,62.77,62.77,0,0,0-2.29,20.8A36.91,36.91,0,0,1,229.42,173l.53-2.86.29-1.44c.11-.47.27-.93.41-1.4.28-.94.56-1.88.87-2.81s.76-1.8,1.14-2.71a43.25,43.25,0,0,1,2.76-5.21c.51-.85,1.14-1.61,1.7-2.42a24.27,24.27,0,0,1,1.82-2.33,39.88,39.88,0,0,1,19.58-12.56A34.18,34.18,0,0,1,280.92,140.17Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M358.88,77.15a62.84,62.84,0,0,0-18,2,52.26,52.26,0,0,0-15.47,7.06A51.64,51.64,0,0,0,313.09,98c-.84,1.18-1.8,2.31-2.53,3.58l-1.21,1.88c-.43.62-.71,1.3-1.09,2a73.25,73.25,0,0,0-4.1,8.38,28.54,28.54,0,0,1,.39-9.7c.17-.8.27-1.63.52-2.42l.74-2.36a31.32,31.32,0,0,1,1.91-4.61A39,39,0,0,1,321,79.59,39.38,39.38,0,0,1,339.89,73,32.35,32.35,0,0,1,358.88,77.15Z",
    fill: colors.white
  }));
};
var hatScale$2 = 0;

var Afro = {
  __proto__: null,
  Back: Back$6,
  Front: Front$6,
  hatScale: hatScale$2
};

var Back$7 = function Back(_ref) {
  var hairColor = _ref.hairColor;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var _colors$hair$hairColo = colors.hair[hairColor],
      base = _colors$hair$hairColo.base,
      shadow = _colors$hair$hairColo.shadow;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M501.71,209.52c-166.14,0-300.83,134.68-300.83,300.83V673.78c9.48,10.52,25.37,19.57,46,27.19L260.2,661.2l14.46,48.46c152.76,40.64,466.71,25.28,527.88-35.88V510.35C802.54,344.2,667.85,209.52,501.71,209.52Z",
    fill: base
  }), React.createElement("path", {
    d: "M242.87,699.45c1.32.51,2.65,1,4,1.52L260.2,661.2l14.46,48.46c45.22,12,104.55,19.15,167.28,21.63l27.28-26.22L235.81,529.43S229.67,630.88,242.87,699.45Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M617.2,552.78l25.31,170.76c34.8-4.34,66.62-10.27,93.11-17.73h0s33.09-36.89,29.52-176.38S617.2,552.78,617.2,552.78Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M501.71,209.52c-166.14,0-300.83,134.68-300.83,300.83V673.78c9.48,10.52,25.37,19.57,46,27.19L260.2,661.2l14.46,48.46c152.76,40.64,466.71,25.28,527.88-35.88V510.35C802.54,344.2,667.85,209.52,501.71,209.52Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }));
};
var Front$7 = function Front(_ref2) {
  var hairColor = _ref2.hairColor;

  var _useTheme2 = useTheme(),
      colors = _useTheme2.colors,
      skin = _useTheme2.skin;

  var base = colors.hair[hairColor].base;
  return React.createElement(React.Fragment, null, React.createElement("rect", {
    x: "290.23",
    y: "414.02",
    width: "439.24",
    height: "64.15",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M710,667.66q-4.71,5.82-9.71,11.37C697.79,681.8,702.87,677.91,710,667.66Zm15-316.55C694.5,296.7,641.5,259.24,580.22,242l-6.35-1.71c-22.7-6.28-46.62-7-71.32-7-26.69,0-52.46,2.74-76.77,10l-4.26,1.27A283.11,283.11,0,0,0,332.67,294q-4.37,3.58-8.57,7.32c-28.34,23.69-50.34,53.69-65.47,87.9q-2.2,4.92-4.16,9.93a212.31,212.31,0,0,0-9.41,30.61C213,556.34,262.89,634,307.17,681.6c4.37,4.7-57.93-101.85-17.42-216,7.73-.29,20.24-.51,36.19-.67l15.5-50.61,17.44,50.38c27.4-.13,59.88-.15,93.88-.12l12.32-52.36L479,464.6c74.37.14,151.44.52,195.28.77l13.2-52.17,15,52.33,8.21.05C760.78,572,728.5,641.13,710,667.66A265.62,265.62,0,0,0,769.3,500C769.3,413.58,725,351.11,725,351.11Z",
    fill: base
  }), React.createElement("path", {
    d: "M710,667.66q-4.71,5.82-9.71,11.37C697.79,681.8,702.87,677.91,710,667.66Zm15-316.55C694.5,296.7,641.5,259.24,580.22,242l-6.35-1.71c-22.7-6.28-46.62-7-71.32-7-26.69,0-52.46,2.74-76.77,10l-4.26,1.27A283.11,283.11,0,0,0,332.67,294q-4.37,3.58-8.57,7.32c-28.34,23.69-50.34,53.69-65.47,87.9q-2.2,4.92-4.16,9.93a212.31,212.31,0,0,0-9.41,30.61C213,556.34,262.89,634,307.17,681.6c4.37,4.7-57.93-101.85-17.42-216,7.73-.29,20.24-.51,36.19-.67l15.5-50.61,17.44,50.38c27.4-.13,59.88-.15,93.88-.12l12.32-52.36L479,464.6c74.37.14,151.44.52,195.28.77l13.2-52.17,15,52.33,8.21.05C760.78,572,728.5,641.13,710,667.66A265.62,265.62,0,0,0,769.3,500C769.3,413.58,725,351.11,725,351.11Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M584.15,228l-6.47-1.74c-25.21-7-50.93-7.55-75.13-7.55-30.59,0-57.07,3.49-80.91,10.64l-4.26,1.27-.49.15a299.89,299.89,0,0,0-93.42,52c-3,2.46-6,5-8.84,7.55-29.63,24.82-52.93,56.11-69.24,93-1.56,3.49-3,7.05-4.42,10.57-4.18,10.69-21.29,59.77-23.75,70.65l72.53,1c7.73-.29,20.24-.51,36.19-.67l15.5-50.61,17.44,50.38c27.4-.13,59.88-.15,93.88-.12l12.32-52.36L479,464.6c74.37.14,151.44.52,195.28.77l13.2-52.17,15,52.33,8.21.05L783.8,500c0-86.19-41.3-149-46.48-156.6C706,288,651.63,247,584.15,228ZM750.31,547.25c-3.17-25.92-11.17-55.26-26.51-87.84l-3.89-8.27-6.49,0-26.78-93.63L663,450.81c-40.43-.22-107.06-.54-172.86-.69l-25.95-97.57-22.94,97.5c-27.4,0-51.55,0-72.09.09L340.6,367.53l-25.42,83c-11.45.15-20.16.34-26,.56l-9.83.38-3.29,9.26C261.72,501.22,257.92,545,264.76,591c-15.9-40-22.46-91.39-5.65-157.63l.09-.38A197.7,197.7,0,0,1,268,404.47c1.2-3.09,2.51-6.22,3.91-9.35,14.54-32.86,35.24-60.67,61.51-82.63l.33-.29c2.65-2.35,5.39-4.69,8.14-6.95a270.41,270.41,0,0,1,84-46.87l4.05-1.2c21.12-6.34,44.87-9.43,72.6-9.43,22.22,0,45.73.51,67.45,6.52l6.38,1.71c60.24,17,108.53,53.27,136,102.23l.37.66.44.63c.42.59,41.61,59.63,41.61,140.5A252.08,252.08,0,0,1,750.31,547.25Z",
    fill: base
  }), React.createElement("path", {
    d: "M710,667.66q-4.71,5.82-9.71,11.37C697.79,681.8,702.87,677.91,710,667.66ZM307.17,681.6c4.37,4.7-57.93-101.85-17.42-216,7.73-.29,20.24-.51,36.19-.67l15.5-50.61,17.44,50.38c27.4-.13,59.88-.15,93.88-.12l12.32-52.36L479,464.6c74.37.14,151.44.52,195.28.77l13.2-52.17,15,52.33,8.21.05C760.78,572,728.5,641.13,710,667.66",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M284.48,462.85c.18-.75.33-1.32.53-1.94s.4-1.2.62-1.78c.46-1.17,1-2.31,1.51-3.42a48.48,48.48,0,0,1,3.85-6.42,37.51,37.51,0,0,1,4.88-5.75,17,17,0,0,1,7-4,31,31,0,0,1-.87,7.68c-.28,1.14-.59,2.25-.93,3.32l-1,3.25q-1,3.23-2,6.39c-.33,1.06-.68,2.09-1,3.13-.17.51-.37,1-.56,1.53s-.39,1-.56,1.4Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M710.68,459.58a35,35,0,0,1,6.23.06,60.73,60.73,0,0,1,6.24.86c1,.2,2.08.4,3.12.64a25.74,25.74,0,0,1,3.11.86,18.53,18.53,0,0,1,6.24,3.58,18.74,18.74,0,0,1-6.24,3.59,25.68,25.68,0,0,1-3.11.85c-1,.25-2.08.45-3.12.65q-3.12.58-6.24.86a35,35,0,0,1-6.23.05Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M444.84,452.07a134.88,134.88,0,0,1,1.49-14.25c.72-4.7,1.6-9.37,2.61-14s2.15-9.25,3.44-13.83A132.09,132.09,0,0,1,457,396.4a131.77,131.77,0,0,1-1.5,14.25q-1.08,7.05-2.61,14t-3.44,13.83A137,137,0,0,1,444.84,452.07Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M668,452.07a134.88,134.88,0,0,1,1.49-14.25q1.09-7.05,2.61-14T675.49,410a132.09,132.09,0,0,1,4.57-13.58,131.76,131.76,0,0,1-1.49,14.25q-1.1,7.05-2.61,14c-1,4.64-2.16,9.25-3.45,13.83A134.48,134.48,0,0,1,668,452.07Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M237.55,468.26a143,143,0,0,1,11.42-38",
    fill: base
  }), React.createElement("path", {
    d: "M231.6,467.51c.09-1,.18-1.85.32-2.73s.29-1.72.46-2.58c.35-1.7.75-3.38,1.23-5a78.48,78.48,0,0,1,3.47-9.75,66.09,66.09,0,0,1,4.7-9.22,29.18,29.18,0,0,1,7.19-7.91,50.46,50.46,0,0,1-.48,10.43c-.25,1.63-.51,3.25-.83,4.84s-.58,3.19-.83,4.78l-1.63,9.49-.83,4.68c-.12.78-.28,1.56-.42,2.32s-.3,1.57-.44,2.19Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M769.33,496s-.46-20.78-8.37-47.63",
    fill: base
  }), React.createElement("path", {
    d: "M763.33,496.12l-.24-2.76c-.08-1-.16-1.93-.22-2.89l-.45-5.84-.91-11.8c-.3-3.95-.71-7.91-1-11.93-.08-2-.16-4.06-.1-6.14a47.58,47.58,0,0,1,.5-6.4,42.78,42.78,0,0,1,6.58,10.89,62.13,62.13,0,0,1,2.17,5.84c.67,2,1.24,4,1.81,6a111.89,111.89,0,0,1,2.69,12.17c.33,2.05.63,4.12.81,6.21q.16,1.56.24,3.15c.06,1.07.08,2.07.07,3.28Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M506.7,235.5a369.62,369.62,0,0,0-42.48,4.93c-3.48.68-7,1.42-10.44,2.06s-6.9,1.61-10.35,2.41l-10.26,2.72c-3.4,1-6.77,2.08-10.15,3.12a314.87,314.87,0,0,0-39.44,15.73,348.17,348.17,0,0,0-37.24,21,183.41,183.41,0,0,1,35.08-25.14A219.23,219.23,0,0,1,421.18,245c3.48-1,6.94-2.09,10.42-3.05s7-1.82,10.55-2.6,7.1-1.4,10.65-2,7.16-1.07,10.74-1.52A190,190,0,0,1,506.7,235.5Z",
    fill: colors.white
  }));
};
var hatScale$3 = 1.12;

var BobCut = {
  __proto__: null,
  Back: Back$7,
  Front: Front$7,
  hatScale: hatScale$3
};

var Front$8 = function Front(_ref) {
  var color = _ref.color,
      _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 1 : _ref$scale;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var _colors$clothing$colo = colors.clothing[color],
      base = _colors$clothing$colo.base,
      shadow = _colors$clothing$colo.shadow;
  return React.createElement("g", {
    style: {
      transformOrigin: 'center'
    },
    transform: "scale(" + scale + ")"
  }, React.createElement("circle", {
    cx: "491.44",
    cy: "157.14",
    r: "47.48",
    fill: base
  }), React.createElement("path", {
    d: "M491.44,204.62a47.47,47.47,0,0,0,46.46-57.31c-30.78-4.77-62.7-2-93.77,6-.1,1.26-.17,2.53-.17,3.82A47.48,47.48,0,0,0,491.44,204.62Z",
    fill: shadow
  }), React.createElement("circle", {
    cx: "491.44",
    cy: "157.14",
    r: "47.48",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M240.26,423.13a254.67,254.67,0,0,1,6.54-57.5q1.29-5.55,2.81-11c2.9-32.3,20-58.94,42.86-82.73,4.76-3.81,5.71-12.37,10.47-17.13,16.18-14.27,30.45-28.55,48.53-40,74.22-47.58,172.23-73.27,251.21-29.5,16.17,8.56,34.25,13.32,47.57,24.74,25.7,21.88,43.77,47.58,69.47,68.51,22.83,19,26.64,49.48,34.74,76.07q1.53,5.44,2.81,11a254.67,254.67,0,0,1,6.54,57.5Z",
    fill: base
  }), React.createElement("path", {
    d: "M246.8,365.63a254.67,254.67,0,0,0-6.54,57.5h83C321.7,342.47,301,275.11,406,193,330.68,221.59,262.05,284.38,246.8,365.63Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M258.18,321.12a109.41,109.41,0,0,0-8.57,33.51q-1.52,5.44-2.81,11a254.67,254.67,0,0,0-6.54,57.5H440.31a827.17,827.17,0,0,1,127.59,0H763.81a254.67,254.67,0,0,0-6.54-57.5q-1.29-5.55-2.81-11c-3.46-11.37-6.15-23.44-9.86-35C582.71,259.73,419,261,258.18,321.12Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M240.26,423.13a254.67,254.67,0,0,1,6.54-57.5q1.29-5.55,2.81-11c2.9-32.3,20-58.94,42.86-82.73,4.76-3.81,5.71-12.37,10.47-17.13,16.18-14.27,30.45-28.55,48.53-40,74.22-47.58,172.23-73.27,251.21-29.5,16.17,8.56,34.25,13.32,47.57,24.74,25.7,21.88,43.77,47.58,69.47,68.51,22.83,19,26.64,49.48,34.74,76.07q1.53,5.44,2.81,11a254.67,254.67,0,0,1,6.54,57.5Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M225.35,356.43c183.42-78,371.14-79.06,555.94,0,17.53,7.5,17.43,139.87,0,133.81-180.47-62.83-371.33-63.5-555.94,0C203.39,497.79,205.53,364.86,225.35,356.43Z",
    fill: base
  }), React.createElement("path", {
    d: "M751.33,443.71a43.58,43.58,0,0,1,1.35,9.9c.09,3.27-.11,6.52-.26,9.78l-.36,4.87c-.16,1.62-.32,3.24-.52,4.85-.4,3.23-.89,6.44-1.59,9.61l-7.87-1.41c.44-3.17,1-6.31,1.64-9.45l1-4.71,1-4.7c.74-3.13,1.37-6.27,2.22-9.4A53.94,53.94,0,0,1,751.33,443.71Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M749.91,342.47a175.32,175.32,0,0,1,3.63,19c.43,3.19.78,6.39,1.09,9.59s.49,6.42.66,9.63c.26,6.42.37,12.84.06,19.25a114.35,114.35,0,0,1-2.45,19.11c-1-6.39-1.67-12.7-2.32-19s-1.21-12.55-2.05-18.78c-.39-3.12-.83-6.22-1.3-9.32s-1-6.19-1.52-9.27c-1.07-6.17-2.3-12.29-3.59-18.41Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M668.78,322c7.56,42.87,6.71,89.49,0,138.73",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M598.19,307.61c5.15,42.9,4.57,89.55,0,138.83",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M533.85,356.47a172.75,172.75,0,0,1,2.37,20.68c.4,6.9.52,13.8.65,20.71l0,10.36c0,3.45,0,6.9-.12,10.35-.15,6.9-.4,13.8-.87,20.69l-8-.4c.22-6.87.57-13.73.94-20.59l1.21-20.57c.46-6.86.82-13.73,1.35-20.6S532.69,363.36,533.85,356.47Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M535.93,299.88a58.54,58.54,0,0,1,.28,6.35c0,1.06-.05,2.12-.08,3.18L536,312.6c-.17,2.12-.32,4.25-.68,6.38a22.42,22.42,0,0,1-2.08,6.41,23.29,23.29,0,0,1-2.7-6.21c-.57-2.08-.93-4.16-1.31-6.25l-.49-3.12c-.13-1.05-.28-2.09-.39-3.13a55,55,0,0,1-.35-6.29Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M467.76,299.65c.35,43,.31,89.67,0,139",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M403.38,306.18c-2.06,43-1.83,89.73,0,139.11",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M333.37,391.65a161.31,161.31,0,0,1,2.71,16.78c.63,5.59,1.09,11.17,1.65,16.75l1.51,16.73c.47,5.57.93,11.15,1.25,16.74l-8,.64c-.58-5.61-.93-11.24-1.18-16.87-.13-2.82-.2-5.64-.28-8.46l-.1-8.46c0-5.64.05-11.29.35-16.93A117.52,117.52,0,0,1,333.37,391.65Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M340.48,320.18c-.25,3.65-.64,7.28-1.05,10.91l-.66,5.45-.72,5.45c-.54,3.64-.95,7.28-1.6,10.93a67.39,67.39,0,0,1-2.8,10.92,55.71,55.71,0,0,1-2-11.14c-.3-3.72-.32-7.42-.38-11.14l0-5.56c.06-1.86.11-3.71.2-5.56.2-3.71.49-7.41,1-11.09Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M264.86,340.45c-6.86,43-6.09,89.85,0,139.3",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M753.07,434.58a3.75,3.75,0,1,0-3.75-3.75,3.8,3.8,0,0,0,3.75,3.75Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M758.28,341.38c10,42.84,8.85,89.43,0,138.64",
    fill: "none",
    stroke: shadow,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M681,320c7.56,42.87,6.71,89.49,0,138.74",
    fill: "none",
    stroke: shadow,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M610.38,305.45c5.15,42.9,4.57,89.55,0,138.83",
    fill: "none",
    stroke: shadow,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M544.06,297.82c2.74,42.92,2.44,89.61,0,138.92",
    fill: "none",
    stroke: shadow,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M479.8,297.16c.34,42.95.31,89.67,0,139",
    fill: "none",
    stroke: shadow,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M415.34,303.53c-2.06,43-1.83,89.73,0,139.11",
    fill: "none",
    stroke: shadow,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M348.41,317c-4.46,43-4,89.79,0,139.21",
    fill: "none",
    stroke: shadow,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M276.74,337.64c-6.86,43-6.09,89.85,0,139.3",
    fill: "none",
    stroke: shadow,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M225.35,356.43c183.42-78,371.14-79.06,555.94,0,17.53,7.5,17.43,139.87,0,133.81-180.47-62.83-371.33-63.5-555.94,0C203.39,497.79,205.53,364.86,225.35,356.43Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M426.76,283.72A328.8,328.8,0,0,1,465.37,278c3.25-.28,6.49-.56,9.74-.78l9.75-.56c3.26-.14,6.51-.2,9.77-.3l9.77-.13c13,0,26.05.63,39,1.84a324.4,324.4,0,0,1,38.6,5.8c-13-.29-26-.79-38.88-1.13s-25.84-.49-38.75-.52h-9.68c-3.23,0-6.46.12-9.69.11l-9.68.14c-3.23.11-6.46.16-9.7.2C452.72,283,439.78,283.46,426.76,283.72Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M347.31,233.83a183.71,183.71,0,0,1,22.38-15.33c7.78-4.62,15.81-8.84,24-12.66,2-1,4.13-1.86,6.2-2.78s4.13-1.86,6.24-2.67c4.22-1.65,8.4-3.38,12.7-4.8a217,217,0,0,1,26.06-7.5c-2.07.91-4.16,1.78-6.25,2.63s-4.19,1.64-6.25,2.56c-4.15,1.74-8.31,3.42-12.43,5.22l-3.09,1.33c-1,.43-2.08.85-3.1,1.32l-6.15,2.73c-2.06.88-4.09,1.83-6.14,2.75s-4.09,1.84-6.1,2.83l-6.1,2.83c-2,1-4,2-6.05,3-4,1.94-8,4-12.05,6C363.19,225.31,355.23,229.48,347.31,233.83Z",
    fill: colors.white
  }));
};
var Back$8 = function Back(_ref2) {
  var _ref2$scale = _ref2.scale,
      scale = _ref2$scale === void 0 ? 1 : _ref2$scale;

  var _useTheme2 = useTheme(),
      colors = _useTheme2.colors;

  return React.createElement("g", {
    style: {
      transformOrigin: 'center'
    },
    transform: "scale(" + scale + ")"
  }, React.createElement("path", {
    d: "M225.35,498c183.42,77.95,371.14,79.06,555.94,0,17.53-7.5,17.43-139.87,0-133.81-180.47,62.83-371.33,63.5-555.94,0C203.39,356.6,205.53,489.53,225.35,498Z",
    fill: colors.outline,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }));
};

var Beanie = {
  __proto__: null,
  Front: Front$8,
  Back: Back$8
};

var Front$9 = function Front(_ref) {
  var color = _ref.color,
      _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 1 : _ref$scale;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var _colors$clothing$colo = colors.clothing[color],
      base = _colors$clothing$colo.base,
      shadow = _colors$clothing$colo.shadow;
  return React.createElement("g", {
    style: {
      transformOrigin: 'center'
    },
    transform: "scale(" + scale + ")"
  }, React.createElement("path", {
    d: "M765.63,495.43s.3-2.94.8-8.24C759.75,345.82,643,233.25,500,233.25c-147.32,0-266.75,119.43-266.75,266.75,0,7.28.31,14.49.89,21.63,12.11-39.32,161.32-77.95,298.44-133.08C631.75,452.24,765.63,495.43,765.63,495.43Z",
    opacity: 0.15
  }), React.createElement("path", {
    d: "M747.94,163.66l0,0C684.65,74.76,266,93.83,204.16,155.69c-66.94,66.94,29.18,351,29.18,351,0-41.1,160.33-82.31,303.37-139.83,99.17,63.69,228.92,108.54,228.92,108.54S793.59,209.32,747.94,163.66Z",
    fill: base
  }), React.createElement("path", {
    d: "M610.06,159.09c-36.6-4-184.31-1.44-322.45,25.65A481,481,0,0,0,235,197.59c-4.25,1.37-8.49,2.76-12.62,4.33s-8.24,3.18-12.18,5a112.44,112.44,0,0,0-11.34,5.93c-3.54,2.16-10.85,8.81-13.51,11.39l-7.3-15.56a69.81,69.81,0,0,1,12.33-9.59,116.58,116.58,0,0,1,13-6.93,217.66,217.66,0,0,1,26.74-10.11,460.64,460.64,0,0,1,54.55-12.9c18.3-3.27,36.69-5.71,55.1-7.7s35.8-7.94,54.26-8.88C494.59,148.61,592.19,154.62,610.06,159.09Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M188.17,320.14c3.47-1.42,6.8-2.75,10.2-4.07s6.78-2.61,10.18-3.87c6.79-2.57,13.62-5,20.45-7.36q20.52-7.09,41.26-13.47c6.91-2.14,13.82-4.25,20.78-6.22l10.42-3c3.47-1,6.94-2,10.44-2.93l20.94-5.59,21-5.25C382,261.7,484.59,232.18,513.37,230c-7,1.8-168.2,54.82-176.74,57.39L316,293.56q-20.57,6.22-41,12.91c-6.83,2.16-13.6,4.47-20.38,6.76s-13.54,4.65-20.3,7l-10.1,3.61q-5.07,1.77-10.08,3.64l-10,3.71c-3.32,1.23-6.69,2.52-9.9,3.78Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M711.7,270.48c-39.92,36.15-102.55,67-169.48,94.19l16.51,15.78h0S659.21,340.49,711.7,270.48Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M214.45,457.18a24.45,24.45,0,0,1,.66-5.43,27,27,0,0,1,1.75-4.9,36.8,36.8,0,0,1,5.26-8,72.69,72.69,0,0,1,13-11.7,206,206,0,0,1,28.63-16.72c19.57-9.69,39.67-17.6,59.8-25.27s40.4-14.82,60.64-22S424.76,349,445,341.87c40.42-14.25,79.8-31.3,119.21-47.95,9.86-4.14,93.82-54.66,102.72-60.67-8.32,6.8-67.53,50.51-99.82,67.22-39.1,18-78.43,35.84-118.64,50.95-20.13,7.5-40.29,14.87-60.43,22.25s-40.27,14.71-60.19,22.46c-10,3.88-19.86,7.85-29.66,12s-19.51,8.46-28.95,13.15A195.93,195.93,0,0,0,242.3,437a64.46,64.46,0,0,0-10.93,9.68c-3,3.49-7.94,11.25-7.92,14.53Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M747.94,163.66l0,0C684.65,74.76,266,93.83,204.16,155.69c-66.94,66.94,29.18,351,29.18,351,0-41.1,160.33-82.31,303.37-139.83,99.17,63.69,228.92,108.54,228.92,108.54S793.59,209.32,747.94,163.66Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M534.47,361.33c16.1-6.69,32.19-13.37,48.12-20.36l6-2.61,5.95-2.67,6-2.66,5.91-2.76,5.92-2.73c2-.91,3.92-1.88,5.88-2.81,3.91-1.89,7.83-3.75,11.69-5.74q23.34-11.6,45.56-25.15a427.09,427.09,0,0,0,43-29.7c-1.44,1.66-2.86,3.34-4.34,5s-2.9,3.33-4.49,4.84c-3.12,3.11-6.22,6.29-9.55,9.17-1.64,1.49-3.31,2.92-5,4.39s-3.41,2.8-5.12,4.21-3.45,2.76-5.2,4.11l-5.32,4A448.92,448.92,0,0,1,634.62,328c-3.84,2.18-7.74,4.23-11.63,6.29s-7.8,4.1-11.74,6.08l-5.9,3-6,2.87c-4,1.91-7.92,3.84-11.93,5.64q-24,11.06-48.52,20.65Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M769.08,431.09c-1.42-.23-2.71-.46-4-.72s-2.63-.53-3.94-.82c-2.62-.55-5.2-1.21-7.79-1.86q-7.74-2-15.34-4.43a315.52,315.52,0,0,1-29.83-11.2A306.66,306.66,0,0,1,679.61,398a208.59,208.59,0,0,1-26.43-17.56c2.42,1.09,4.82,2.19,7.19,3.35s4.7,2.34,7.12,3.39c4.77,2.18,9.47,4.49,14.28,6.55q14.25,6.56,28.91,12l7.33,2.71L725.4,411c4.94,1.65,9.9,3.22,14.89,4.67s10,2.83,15,4.13l3.77.91c1.26.32,2.52.62,3.78.89,2.5.57,5.08,1.14,7.49,1.59Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M615.36,160c-36.49-4.61-73.12-6.62-109.74-7.18s-73.25.43-109.73,3.15c-18.24,1.33-36.45,3.08-54.58,5.35s-36.18,5-54.06,8.36a484.87,484.87,0,0,0-52.83,12.84,211.12,211.12,0,0,0-25,9.44A113.77,113.77,0,0,0,197.84,198a56.05,56.05,0,0,0-9.85,7.45L179.5,197a67.76,67.76,0,0,1,12-9.28,115.9,115.9,0,0,1,12.81-6.8,226.14,226.14,0,0,1,26.49-10A457.87,457.87,0,0,1,285.08,158c36.5-6.53,73.31-10.19,110.17-12.17a1068.52,1068.52,0,0,1,110.62-.17c9.2.53,18.4,1.16,27.59,1.94s18.35,1.78,27.49,2.93A542.75,542.75,0,0,1,615.36,160Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M210.05,449.36a24.5,24.5,0,0,1,.64-5.37,26.93,26.93,0,0,1,1.71-4.87,36.36,36.36,0,0,1,5.18-8,71.43,71.43,0,0,1,12.89-11.68,202.41,202.41,0,0,1,28.39-16.69c19.41-9.65,39.35-17.52,59.32-25.14s40.08-14.74,60.17-21.86,40.21-14,60.25-21.15c40.11-14.17,80-28.92,119.07-45.49q14.67-6.18,29.14-12.83t28.69-13.79q14.22-7.17,28-15.08t27.08-16.87c-8.25,6.75-16.94,13-25.81,18.91s-18,11.55-27.24,16.89S598.9,276.71,589.4,281.6s-19.15,9.51-28.82,14c-38.79,18-78.6,33.46-118.5,48.49-20,7.46-40,14.78-59.95,22.12s-39.95,14.62-59.72,22.33c-9.87,3.85-19.7,7.81-29.41,11.95s-19.35,8.41-28.71,13.08a191.39,191.39,0,0,0-26.63,15.63,63.16,63.16,0,0,0-10.78,9.64c-3,3.47-4.85,7.2-4.83,10.48Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M184.48,311.25C198,305.7,211.57,300.86,225.22,296s27.38-9.26,41.18-13.53c27.6-8.52,55.41-16.36,83.45-23.23S406,246,434.45,240.93L445.09,239l5.33-1,5.34-.85L477.15,234c7.13-1.1,14.3-1.92,21.46-2.74s14.33-1.6,21.5-2.31q-10.54,2.44-21.09,4.73c-7,1.55-14.09,2.94-21.08,4.63-14,3.22-28.07,6.22-42,9.66q-42,9.66-83.48,21.17l-20.73,5.79L311.07,281c-13.74,4.12-27.44,8.36-41.07,12.81-6.84,2.15-13.63,4.46-20.42,6.74s-13.57,4.62-20.35,6.94c-13.48,4.75-27,9.69-40.19,14.83Z",
    fill: colors.outline
  }));
};
var Back$9 = Noop;

var Turban = {
  __proto__: null,
  Front: Front$9,
  Back: Back$9
};

var Front$a = Noop;
var Back$a = function Back() {
  var _useTheme = useTheme(),
      skin = _useTheme.skin,
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M570.68,842.45C570.9,833,582.9,829,588.9,835a10.61,10.61,0,1,1-15.16,14.85A10.4,10.4,0,0,1,570.68,842.45Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M408.11,842.15C407.9,834,416.9,830,422.9,833c8,3,8,14,0,19-4,2-8,0-11.75-2.48A10.39,10.39,0,0,1,408.11,842.15Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M500,831.77a27.13,27.13,0,0,1,1.5,5.84,42.47,42.47,0,0,1,.49,5.84l.3,11.69c.09,3.89.21,7.79.25,11.69l.17,11.67c.23,15.57.22,31.16.28,46.74s.18,31.16,0,46.74c-.09,7.79-.3,15.58-.53,23.37-.1,3.89-.29,7.79-.67,11.68a92.5,92.5,0,0,1-1.77,11.69,92.5,92.5,0,0,1-1.77-11.69c-.38-3.89-.57-7.79-.67-11.68-.23-7.79-.44-15.58-.53-23.37-.2-15.58,0-31.16,0-46.74s0-31.15.18-46.73l.17-11.7.33-11.68.33-11.68a44.11,44.11,0,0,1,.5-5.84A27.13,27.13,0,0,1,500,831.77Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M425.22,883a18.51,18.51,0,0,1,4.67-1.5,29.75,29.75,0,0,1,4.68-.5l9.35-.33,18.7-.41c12.46-.19,24.91-.24,37.38-.27s24.93-.16,37.39,0c6.23.09,12.46.3,18.7.53,3.11.11,6.23.3,9.34.67a61.34,61.34,0,0,1,9.35,1.78,59.17,59.17,0,0,1-9.35,1.77c-3.11.38-6.23.57-9.34.67-6.24.23-12.47.43-18.7.52-12.46.19-24.92,0-37.39,0s-24.93,0-37.4-.15c-6.23-.06-12.46-.26-18.68-.5l-9.35-.34a29.5,29.5,0,0,1-4.67-.5A18.45,18.45,0,0,1,425.22,883Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M442.41,914.38a12.51,12.51,0,0,1,3.74-1.11,18.35,18.35,0,0,1,3.62-.15c2.39.1,4.78.16,7.17.21,4.78.11,9.56.15,14.34.17,9.63,0,19.09.08,28.76-.21s19.26-.43,28.88-.39c4.81,0,9.62.13,14.42.24a70.37,70.37,0,0,1,7.23.47,38.17,38.17,0,0,1,7.27,1.53,36.56,36.56,0,0,1-7.16,2,61.08,61.08,0,0,1-7.21.86c-4.82.35-9.64.65-14.45.82-9.64.36-19.27.32-28.88.45-4.81,0-9.61.22-14.48.1s-9.69-.13-14.52-.31-9.68-.58-14.5-1.08c-2.42-.27-4.82-.57-7.23-.9a16.82,16.82,0,0,1-3.57-.84A11.51,11.51,0,0,1,442.41,914.38Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M438.93,949.87a13.07,13.07,0,0,1,3.82-1.5,19.13,19.13,0,0,1,3.82-.49l7.63-.32c5.09-.18,10.19-.33,15.28-.41C479.66,947,489.84,947,500,947s20.36-.17,30.54,0c5.09.09,10.18.3,15.27.53a72.73,72.73,0,0,1,7.63.66A41.2,41.2,0,0,1,561.1,950a41.25,41.25,0,0,1-7.63,1.77,70.34,70.34,0,0,1-7.64.67c-5.09.23-10.18.44-15.27.53-10.18.2-20.37.06-30.55,0s-20.36-.06-30.54-.25c-5.09-.1-10.19-.28-15.28-.49l-7.63-.37a19.33,19.33,0,0,1-3.82-.5A12.85,12.85,0,0,1,438.93,949.87Z",
    fill: skin.shadow
  }));
};

var Chest = {
  __proto__: null,
  Front: Front$a,
  Back: Back$a
};

var Front$b = function Front(_ref) {
  var clothingColor = _ref.clothingColor;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var base = colors.clothing[clothingColor].base;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M426.88,961.63a69.32,69.32,0,0,0,65.62-47,71,71,0,0,1-118.19,6.64L374.26,936C387,951.63,405.15,961.63,426.88,961.63Z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M573.12,961.63a69.32,69.32,0,0,1-65.62-47,71,71,0,0,0,118.19,6.64l0,14.72C613,951.63,594.85,961.63,573.12,961.63Z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M407,943.81A69.33,69.33,0,0,1,380.42,831.7",
    fill: base
  }), React.createElement("path", {
    d: "M407,943.81a57.14,57.14,0,0,1-31.21-16l-1.62-1.6c-.53-.54-1-1.13-1.53-1.69s-1-1.15-1.48-1.73a22,22,0,0,1-1.43-1.79c-.9-1.23-1.81-2.46-2.68-3.72l-2.37-3.93a69,69,0,0,1-6.71-17.13,70.52,70.52,0,0,1-1.69-18.3,64.09,64.09,0,0,1,3.4-17.93c.26-.71.49-1.43.76-2.14l.88-2.1c.55-1.4,1.26-2.74,1.91-4.09a60.79,60.79,0,0,1,4.74-7.63c.85-1.21,1.82-2.35,2.75-3.49s1.94-2.23,3-3.23a47.65,47.65,0,0,1,6.73-5.59c-5.79,10-9.9,20.19-11.66,30.67A78.09,78.09,0,0,0,367.61,878a84.63,84.63,0,0,0,2,15.41,80.81,80.81,0,0,0,5.12,14.65,76.2,76.2,0,0,0,8.08,13.47,79,79,0,0,0,10.81,11.95A115,115,0,0,0,407,943.81Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M593.05,943.81A69.33,69.33,0,0,0,619.58,831.7",
    fill: base
  }), React.createElement("path", {
    d: "M593.05,943.81a115,115,0,0,0,13.35-10.29,79,79,0,0,0,10.81-11.95,76.2,76.2,0,0,0,8.08-13.47,80.81,80.81,0,0,0,5.12-14.65,84.63,84.63,0,0,0,2-15.41,78.09,78.09,0,0,0-1.15-15.67c-1.76-10.48-5.87-20.64-11.66-30.67a47.65,47.65,0,0,1,6.73,5.59c1.08,1,2,2.14,3,3.23s1.9,2.28,2.75,3.49a60.79,60.79,0,0,1,4.74,7.63c.65,1.35,1.36,2.69,1.91,4.09l.88,2.1c.27.71.5,1.43.76,2.14a64.09,64.09,0,0,1,3.4,17.93,70.52,70.52,0,0,1-1.69,18.3,69,69,0,0,1-6.71,17.13L633,917.26c-.87,1.26-1.78,2.49-2.68,3.72a22,22,0,0,1-1.43,1.79c-.49.58-1,1.16-1.48,1.73s-1,1.15-1.53,1.69l-1.62,1.6A57.14,57.14,0,0,1,593.05,943.81Z",
    fill: colors.outline
  }));
};
var Back$b = function Back(_ref2) {
  var clothingColor = _ref2.clothingColor,
      braStraps = _ref2.braStraps;

  var _useTheme2 = useTheme(),
      skin = _useTheme2.skin,
      colors = _useTheme2.colors;

  var _colors$clothing$clot = colors.clothing[clothingColor],
      base = _colors$clothing$clot.base,
      shadow = _colors$clothing$clot.shadow;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M502.07,878.86A69.31,69.31,0,1,1,371,847.39",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M371,847.39a69.68,69.68,0,0,1,15-19.67",
    fill: skin.base
  }), React.createElement("path", {
    d: "M365.65,844.66a27,27,0,0,1,3.38-5.84,37.22,37.22,0,0,1,4.53-5c.84-.76,1.69-1.5,2.58-2.19a21.1,21.1,0,0,1,2.81-1.92,15,15,0,0,1,7-2,25,25,0,0,1-1.75,6.81c-.39,1-.83,1.88-1.29,2.77l-1.3,2.67c-.85,1.76-1.69,3.49-2.55,5.19a54.51,54.51,0,0,1-2.76,5Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M489.33,838.82a69,69,0,0,1,12.74,40",
    fill: skin.base
  }), React.createElement("path", {
    d: "M489.33,838.82a26.55,26.55,0,0,1,8.69,7.55,38.8,38.8,0,0,1,3.1,4.79c.93,1.67,1.77,3.39,2.55,5.15a55.12,55.12,0,0,1,3.46,11,48,48,0,0,1,.94,11.53h-12c-.19-3.25-.36-6.48-.7-9.73s-.77-6.48-1.4-9.74l-.5-2.44-.58-2.45c-.42-1.63-.87-3.26-1.29-4.93A104.17,104.17,0,0,1,489.33,838.82Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M641.65,878.86a69.14,69.14,0,0,0-21.94-50.6",
    fill: skin.base
  }), React.createElement("path", {
    d: "M635.65,878.86A107,107,0,0,0,634.39,866a81.92,81.92,0,0,0-3.12-12.67c-.34-1-.74-2.07-1.11-3.11s-.84-2.05-1.25-3.09-.94-2-1.38-3.05l-1.46-3c-2-4.1-4.17-8.19-6.36-12.75a35.76,35.76,0,0,1,12.22,8.61c.83.94,1.7,1.86,2.47,2.85s1.54,2,2.25,3,1.43,2.09,2.07,3.18,1.31,2.18,1.88,3.32A62.19,62.19,0,0,1,646,863.58a56.6,56.6,0,0,1,1.62,15.28Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M503,878.86a69.31,69.31,0,1,0,138.61,0",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M515.77,838.82a69,69,0,0,0-12.73,40",
    fill: skin.base
  }), React.createElement("path", {
    d: "M515.77,838.82a104.17,104.17,0,0,1-2.27,10.75c-.42,1.67-.87,3.3-1.29,4.93l-.57,2.45-.5,2.44c-.63,3.26-1.09,6.5-1.41,9.74s-.5,6.48-.69,9.73H497a47,47,0,0,1,.94-11.53,54.48,54.48,0,0,1,3.46-11c.77-1.76,1.61-3.48,2.54-5.15a40,40,0,0,1,3.1-4.79A26.66,26.66,0,0,1,515.77,838.82Z",
    fill: colors.outline
  }), braStraps && React.createElement(React.Fragment, null, React.createElement("line", {
    x1: "383.44",
    y1: "837.55",
    x2: "383.44",
    y2: "758.72",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("line", {
    x1: "616.46",
    y1: "837.55",
    x2: "616.46",
    y2: "758.72",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  })), React.createElement("path", {
    d: "M470.5,897.78h53.9v19.7c-17.74-6.05-35.71-5.9-53.9,0Z",
    fill: base,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M638.1,878.86a69.06,69.06,0,0,0-18.63-47.28c-4.22-4.52-44.27,6.19-67.81,27.26-23.11,20.69-43.23,54.49-40.35,58.75A69.31,69.31,0,0,0,638.1,878.86Z",
    fill: base,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M598.11,848.39c-6.12,3.67-12.15,7.18-18,11a154.79,154.79,0,0,0-16.53,12.18c-5.15,4.46-10.11,9.32-15,14.26s-9.69,10-14.75,15.07a100,100,0,0,1,11.18-18.17A106.06,106.06,0,0,1,559.72,867a84.36,84.36,0,0,1,18.14-11.73A83.45,83.45,0,0,1,598.11,848.39Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M361.9,878.86a69.06,69.06,0,0,1,18.63-47.28c4.22-4.52,44.27,6.19,67.81,27.26,23.11,20.69,43.23,54.49,40.35,58.75A69.31,69.31,0,0,1,361.9,878.86Z",
    fill: base,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M455.75,938.92a85.36,85.36,0,0,1-85.36-85.36,86.38,86.38,0,0,1,.44-8.71,69.31,69.31,0,0,0,96.31,93.29A85.67,85.67,0,0,1,455.75,938.92Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M361.9,878.86a69.06,69.06,0,0,1,18.63-47.28c4.22-4.52,44.27,6.19,67.81,27.26,23.11,20.69,43.23,54.49,40.35,58.75A69.31,69.31,0,0,1,361.9,878.86Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M401.89,848.39a83.45,83.45,0,0,1,20.25,6.87A84.36,84.36,0,0,1,440.28,867a106.06,106.06,0,0,1,14.65,15.71,100,100,0,0,1,11.18,18.17c-5.06-5-9.84-10.13-14.75-15.07s-9.84-9.8-15-14.26a154.79,154.79,0,0,0-16.53-12.18C414,855.57,408,852.06,401.89,848.39Z",
    fill: colors.white
  }));
};

var Breasts = {
  __proto__: null,
  Front: Front$b,
  Back: Back$b
};

var MediumBeard = function MediumBeard(_ref) {
  var color = _ref.color;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var _colors$hair$color = colors.hair[color],
      base = _colors$hair$color.base,
      shadow = _colors$hair$color.shadow;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M670.06,788.32q3.3-3.32,6.5-6.71c45.16-54.71,48.7-112.39,57.87-148.37V619l-2.44.84c.83-1.52,1.65-3,2.44-4.56-.06-.1-3.49,3.38-3.55,3.28A33.65,33.65,0,0,1,725.8,622l-32.55,11.28a220.36,220.36,0,0,1-43.89,3.82c-63-.26-63.24-14.87-113.2-20l-96.49,1.58c-25.69,3.84-37.06,11.81-88,12.85-44.15.9-83.62-10-83.62-10v12.68c14,36.84,4.58,64.43,29,110.49,0-.65,0-1.31-.05-2-4.39-21.71,0-41.57,2.12-49.19.21-1.88.36-2.92.36-2.92v-.07c0-.12,0-.2,0-.2l0,.1c0,.14.11.45.22.9.23-.72.36-1.11.36-1.11s.89,4.91,2.54,12.74c3.93,15.48,11.16,43,19.45,70.08.92,2.43,1.87,4.81,2.84,7.11.07.21.15.44.23.65,27.94,29.88,62.13,55.36,93.14,74.5,3.34,2,6.51,3.87,9.48,5.61a86.4,86.4,0,0,1,2.41-43.06s.07.38.21,1.08c.24-.77.4-1.19.4-1.19s11.43,47.45,34.52,62.83c.57.24,1.15.47,1.73.66l-.44.16.1.06c.58.33,1.18.65,1.77,1a208.45,208.45,0,0,0,21.34,8.53c5.41,1.57,9.84,2.39,12,2.39,4.75,0,32-10.61,48.69-49.07,1.1-3.27,1.63-5.32,1.63-5.32l.28.69c.11-.27.22-.53.32-.8A56,56,0,0,1,560.7,869a526,526,0,0,0,72.06-47.55l0-.11c.27-.64.53-1.29.8-1.94l.06-.13.81-2v0l.84-2.08v0c14.48-35.83,23.58-89,23.58-89,.06-.18.28.09.6.74,0-.55,0-.85,0-.85S675.72,748.49,670.06,788.32Z",
    fill: base
  }), React.createElement("path", {
    d: "M670.06,788.32q3.3-3.32,6.5-6.71c45.16-54.71,48.7-112.39,57.87-148.37V619l-2.44.84c.83-1.52,1.65-3,2.44-4.56-.06-.1-3.49,3.38-3.55,3.28A33.65,33.65,0,0,1,725.8,622l-32.55,11.28a220.36,220.36,0,0,1-43.89,3.82c-63-.26-63.24-14.87-113.2-20l-96.49,1.58c-25.69,3.84-37.06,11.81-88,12.85-44.15.9-83.62-10-83.62-10v12.68c14,36.84,4.58,64.43,29,110.49,0-.65,0-1.31-.05-2-4.39-21.71,0-41.57,2.12-49.19.21-1.88.36-2.92.36-2.92v-.07c0-.12,0-.2,0-.2l0,.1c0,.14.11.45.22.9.23-.72.36-1.11.36-1.11s.89,4.91,2.54,12.74c3.93,15.48,11.16,43,19.45,70.08.92,2.43,1.87,4.81,2.84,7.11.07.21.15.44.23.65,27.94,29.88,62.13,55.36,93.14,74.5,3.34,2,6.51,3.87,9.48,5.61a86.4,86.4,0,0,1,2.41-43.06s.07.38.21,1.08c.24-.77.4-1.19.4-1.19s11.43,47.45,34.52,62.83c.57.24,1.15.47,1.73.66l-.44.16.1.06c.58.33,1.18.65,1.77,1a208.45,208.45,0,0,0,21.34,8.53c5.41,1.57,9.84,2.39,12,2.39,4.75,0,32-10.61,48.69-49.07,1.1-3.27,1.63-5.32,1.63-5.32l.28.69c.11-.27.22-.53.32-.8A56,56,0,0,1,560.7,869a526,526,0,0,0,72.06-47.55l0-.11c.27-.64.53-1.29.8-1.94l.06-.13.81-2v0l.84-2.08v0c14.48-35.83,23.58-89,23.58-89,.06-.18.28.09.6.74,0-.55,0-.85,0-.85S675.72,748.49,670.06,788.32Z",
    fill: base
  }), React.createElement("path", {
    d: "M670.06,788.32q3.3-3.32,6.5-6.71c45.16-54.71,48.7-112.39,57.87-148.37V619l-2.44.84c.83-1.52,1.65-3,2.44-4.56-.06-.1-3.49,3.38-3.55,3.28A33.65,33.65,0,0,1,725.8,622l-32.55,11.28a220.36,220.36,0,0,1-43.89,3.82c-63-.26-78.3-19.69-113.2-20s-76.95-1.23-96.49,1.58-37.06,11.81-88,12.85c-44.15.9-83.62-10-83.62-10v12.68c14,36.84,4.58,64.43,29,110.49,0-.65,0-1.31-.05-2-4.39-21.71,0-41.57,2.12-49.19.21-1.88.36-2.92.36-2.92v-.07c0-.12,0-.2,0-.2l0,.1c0,.14.11.45.22.9.23-.72.36-1.11.36-1.11s.89,4.91,2.54,12.74c3.93,15.48,11.16,43,19.45,70.08.92,2.43,1.87,4.81,2.84,7.11.07.21.15.44.23.65,27.94,29.88,62.13,55.36,93.14,74.5,3.34,2,6.51,3.87,9.48,5.61a86.4,86.4,0,0,1,2.41-43.06s.07.38.21,1.08c.24-.77.4-1.19.4-1.19s11.43,47.45,34.52,62.83c.57.24,1.15.47,1.73.66l-.44.16.1.06c.58.33,1.18.65,1.77,1a208.45,208.45,0,0,0,21.34,8.53c5.41,1.57,9.84,2.39,12,2.39,4.75,0,32-10.61,48.69-49.07,1.1-3.27,1.63-5.32,1.63-5.32l.28.69c.11-.27.22-.53.32-.8A56,56,0,0,1,560.7,869a526,526,0,0,0,72.06-47.55l0-.11c.27-.64.53-1.29.8-1.94l.06-.13.81-2v0l.84-2.08v0c14.48-35.83,23.58-89,23.58-89,.06-.18.28.09.6.74,0-.55,0-.85,0-.85S675.72,748.49,670.06,788.32Z",
    fill: base
  }), React.createElement("path", {
    d: "M343.5,706.91a23.12,23.12,0,0,0,13.79,5.8C343,701.34,337.78,690.32,336,685.36A271.66,271.66,0,0,1,326,630.81a329.37,329.37,0,0,1-57.87-9.33v12.68c14,36.84,4.58,64.43,29,110.49,0-.65,0-1.31-.05-2-4.39-21.71,0-41.57,2.12-49.19.21-1.88.36-2.92.36-2.92v-.07c0-.12,0-.2,0-.2l0,.1c0,.14.11.45.22.9.23-.72.36-1.11.36-1.11s.89,4.91,2.54,12.74c3.93,15.48,11.16,43,19.45,70.08.92,2.43,1.87,4.81,2.84,7.11.07.21.15.44.23.65,27.94,29.88,62.13,55.36,93.14,74.5,3.34,2,6.51,3.87,9.48,5.61a86.4,86.4,0,0,1,2.41-43.06s.07.38.21,1.08c.24-.77.4-1.19.4-1.19s11.43,47.45,34.52,62.83c.57.24,1.15.47,1.73.66l-.44.16.1.06c.58.33,1.18.65,1.77,1a208.45,208.45,0,0,0,21.34,8.53c5.41,1.57,9.84,2.39,12,2.39,3.53,0,19.51-5.88,34.33-24.72C466.94,846.06,380.78,800,343.5,706.91Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M433.87,816.78s9.49,9,29.29,4.09c-1.47,3.55-5.93,5.4-5.93,5.4s6.17,8.13,19.06,7.75c0,0-7.73,4.8-15.53,1.65A169.67,169.67,0,0,0,442.41,834l-13.51-9.38Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M351.7,631.52q-2.64.48-5.28.84c-.89.11-1.77.25-2.65.35l-2.66.24-5.32.38c-1.78.08-3.56.09-5.33.14-3.56.07-7.11-.07-10.67-.2s-7.1-.37-10.64-.71-7.07-.7-10.61-1.1-7.05-1-10.56-1.56a196.89,196.89,0,0,1-21-4.57l-3.85-1.08,2.1-7.57,3.88.94c6.61,1.61,13.47,3.13,20.27,4.49s13.68,2.64,20.57,3.72c3.44.59,6.89,1,10.35,1.56s6.92,1,10.39,1.31C337.67,629.65,344.64,630.36,351.7,631.52Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M669.31,789.07c10.26-10.26,9.29-9.63,17.79-20.94-1.5-34.48-30-53.71-30-53.71L659,726.08c.84.16,7.91,18.47,7.56,46.08Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M575.36,859.87c-5.72-24.9-22.42-29.15-22.42-29.15l3.21,19.45a96.48,96.48,0,0,1,3.9,19.14c5-2.72,10.16-5.66,15.45-8.78Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M340.09,735.62a90.52,90.52,0,0,0,6.59,20.14A121.79,121.79,0,0,0,357,773.89l3.09,4.18c.53.68,1,1.42,1.56,2.07l1.66,2c1.13,1.31,2.19,2.68,3.35,4l3.56,3.78c.6.62,1.16,1.28,1.77,1.89l1.9,1.78,3.77,3.58c2.58,2.32,5.33,4.45,7.94,6.75l-6.28,3.32-.06-4c.05-1.32.07-2.64.2-4s.23-2.65.46-4c.11-.66.18-1.32.32-2l.43-2a43.84,43.84,0,0,1,2.52-7.67A35,35,0,0,1,385,780c.34-.6.73-1.18,1.13-1.77.21-.29.4-.57.64-.87s.42-.54.78-.95l4.46-5.06.56,6.55c.1,1.09.3,2.4.53,3.61s.51,2.46.84,3.68a48,48,0,0,0,2.51,7.14,36.29,36.29,0,0,0,3.9,6.55,29,29,0,0,0,5.62,5.42,23.79,23.79,0,0,1-7-4.07,31.32,31.32,0,0,1-5.54-6.17,43.85,43.85,0,0,1-4-7.32c-.54-1.28-1-2.58-1.46-3.91a34,34,0,0,1-1.11-4.16l5,1.49c0,.08-.22.35-.34.55s-.26.46-.39.69c-.25.48-.5,1-.73,1.48a33.23,33.23,0,0,0-1.24,3.15,44.39,44.39,0,0,0-1.62,6.69,55.25,55.25,0,0,0-.65,6.94c-.06,1.16,0,2.34,0,3.51l.16,3.53.4,8.64-6.68-5.32c-1.44-1.15-2.87-2.29-4.29-3.46l-2.14-1.75c-.7-.59-1.44-1.14-2.09-1.79l-4-3.83-2-1.91c-.64-.67-1.25-1.36-1.86-2.05l-3.67-4.15c-1.21-1.39-2.26-2.92-3.38-4.39a105.25,105.25,0,0,1-6.17-9.19,91.82,91.82,0,0,1-8.63-20.3C340.61,750.19,339.43,742.84,340.09,735.62Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M638.78,724.34A5.35,5.35,0,0,1,640,726a16.7,16.7,0,0,1,.84,1.94A33.87,33.87,0,0,1,642,732a58.47,58.47,0,0,1,1.08,8.32,94.26,94.26,0,0,1-.54,16.71,109.35,109.35,0,0,1-9,32.28A90.58,90.58,0,0,1,614.3,817a70.11,70.11,0,0,1-28.51,17,111.55,111.55,0,0,0,23.91-21.31A118.63,118.63,0,0,0,626.25,786a157.47,157.47,0,0,0,10.09-30,151.49,151.49,0,0,0,2.81-15.76c.32-2.65.54-5.32.63-8a33.51,33.51,0,0,0-.08-4,14.64,14.64,0,0,0-.26-2A5.74,5.74,0,0,0,638.78,724.34Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M262.51,621.57c22.24,43.9,7.22,72.38,35.18,124.3-7-29,2.43-55.68,2.43-55.68S310,744.78,325,780.12c7.28,23.46,69.85,61.4,103.55,81.17a86.33,86.33,0,0,1,2.32-43.58s11.89,49.36,35.91,63.71c13.43,7.58,30.15,11.89,35.13,11.89s34.53-11.58,50.92-54.5a56,56,0,0,1,7.9,30.68c22.18-12,53.39-25.68,72.45-47.65C659.52,787.15,659.52,726,659.52,726S676,748.85,669.93,789.3c61.76-68.3,54.34-143.14,71.42-175.57",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M734.38,616.77a3.8,3.8,0,0,0,1.16,1.29,4,4,0,0,0,2.15.7,3.81,3.81,0,0,0,1.68-.34h0l-.09,0-.2.11-.48.24-1,.51-2,1q-2,1-4,2c-2.69,1.32-5.41,2.57-8.13,3.81s-5.5,2.41-8.27,3.57-5.6,2.23-8.47,3.26c-1.44.51-2.89,1-4.39,1.43a39.36,39.36,0,0,1-4.75,1.15c-.47.08-.81.11-1.18.16l-1.12.13c-.74.09-1.48.16-2.23.23-1.49.14-3,.3-4.49.4a85.55,85.55,0,0,1-18.09-.43c5.86-1.58,11.62-2.89,17.37-4.29l8.59-2a35.39,35.39,0,0,0,3.81-1.36c1.31-.52,2.63-1.14,4-1.72,2.65-1.19,5.29-2.47,7.93-3.77s5.29-2.61,7.93-3.93l7.94-4,4-2,2-1,1-.48.53-.25.3-.13.16-.08.05,0a4.11,4.11,0,0,1,5.19,1.57l2.13,3.38-7.06,4.19Z",
    fill: colors.outline
  }));
};

var HappyEyes = function HappyEyes() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M296.49,572.61V559.68a49.6,49.6,0,0,1,1.94-25.32,46,46,0,0,1,3.51-7.65C305.29,518,314.29,511,323.29,508c14-4,31-2,42,9,14,15,12,37,12.45,55.62",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M623.31,573c-2.34-26.62,1.66-63.62,36.13-67.17a45,45,0,0,1,8.12,0A43.68,43.68,0,0,1,690,514.41c18,15,14,39,13.95,58.63",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }));
};

var RightLash = function RightLash() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement("path", {
    d: "M721.21,500.43c7.82-6.25,14.69-21.65,12.5-20-15.72,12.14-28,10-30.28,9.19-61.66-16.6-100.28,14-72.48,9,32.73-11.48,76.32-2.8,89.38,17.44,12.5-2.88,27.76-11.11,33.4-26.94C734.42,500.22,732.56,500.21,721.21,500.43Z",
    fill: colors.outline,
    fillRule: "evenodd"
  });
};
var LeftLash = function LeftLash() {
  var _useTheme2 = useTheme(),
      colors = _useTheme2.colors;

  return React.createElement("path", {
    d: "M243.89,489.13c5.64,15.83,20.9,24.06,33.4,26.94,13.06-20.24,56.65-28.92,89.37-17.44,27.8,5-10.81-25.57-72.47-9-2.31.85-14.56,2.95-30.28-9.19-2.19-1.69,4.68,13.71,12.5,20C265.06,500.21,263.2,500.22,243.89,489.13Z",
    fill: colors.outline,
    fillRule: "evenodd"
  });
};

var NormalEyes = function NormalEyes(_ref) {
  var withLashes = _ref.withLashes;

  var _useTheme = useTheme(),
      skin = _useTheme.skin,
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M271.4,568.53c-1-28.36,18-52.36,43.28-63.56a62.37,62.37,0,0,1,8.16-2.7A70,70,0,0,1,365.05,505a71.67,71.67,0,0,1,8.93,4.16c29.53,15.89,42.79,53.25,31.36,83.46a61.68,61.68,0,0,1-4.18,8.82,54.68,54.68,0,0,1-17.51,20.83,69.25,69.25,0,0,1-7.85,5c-27.38,13-64.38,9-86.45-11.4a68.39,68.39,0,0,1-6.11-7.47,64.89,64.89,0,0,1-5.57-9.5A55.78,55.78,0,0,1,272,577.1,75.67,75.67,0,0,1,271.4,568.53Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M269.77,550.18c-1-28.36,18-52.36,43.28-63.56a62.23,62.23,0,0,1,8.15-2.7,70,70,0,0,1,42.22,2.68,71.54,71.54,0,0,1,8.92,4.16c29.53,15.89,42.79,53.26,31.36,83.46a59.6,59.6,0,0,1-4.18,8.82,63.85,63.85,0,0,1-4.71,7.8,64.78,64.78,0,0,1-5.68,7,63.08,63.08,0,0,1-7.12,6.07,68.37,68.37,0,0,1-7.85,5c-27.38,13-64.38,9-86.44-11.39a68.28,68.28,0,0,1-6.11-7.48,65,65,0,0,1-5.58-9.5,55.59,55.59,0,0,1-5.71-21.73A71.3,71.3,0,0,1,269.77,550.18Z",
    fill: colors.white,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("circle", {
    cx: "338.51",
    cy: "550.79",
    r: "12.24",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M583.89,560.47c.43-15.13,6.67-30.09,15.1-41.33a72.82,72.82,0,0,1,7.12-8.53,69.73,69.73,0,0,1,90.17-8.95,73.27,73.27,0,0,1,6.53,5.13c27,21.45,30.12,63.14,15.32,93.23a62.31,62.31,0,0,1-4.78,6.86,72.09,72.09,0,0,1-7.58,8.13c-20.27,17.83-51.81,22.13-77.41,12.42a71.34,71.34,0,0,1-10.55-5c-17.9-10.78-30.37-31.09-33.43-52.23A62.93,62.93,0,0,1,583.89,560.47Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M589.38,549c.42-14.15,6.42-28.15,14.52-38.66a70.56,70.56,0,0,1,6.86-8A68.55,68.55,0,0,1,697.53,494a69.81,69.81,0,0,1,6.28,4.79c26,20.07,29,59.07,14.74,87.22a56.5,56.5,0,0,1-4.6,6.42,68.91,68.91,0,0,1-7.29,7.6c-19.51,16.68-49.86,20.71-74.49,11.62A68.79,68.79,0,0,1,622,606.9c-17.22-10.08-29.22-29.08-32.17-48.85A56.34,56.34,0,0,1,589.38,549Z",
    fill: colors.white,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("circle", {
    cx: "659.21",
    cy: "550.79",
    r: "12.24",
    fill: colors.outline
  }), withLashes && React.createElement("g", {
    transform: "translate(0 -5)"
  }, React.createElement(LeftLash, null), React.createElement(RightLash, null)));
};

var LeftTwitchEyes = function LeftTwitchEyes(_ref) {
  var withLashes = _ref.withLashes;

  var _useTheme = useTheme(),
      skin = _useTheme.skin,
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M271.4,568.53c-1-28.36,18-52.36,43.28-63.56a62.37,62.37,0,0,1,8.16-2.7A70,70,0,0,1,365.05,505a71.67,71.67,0,0,1,8.93,4.16c29.53,15.89,42.79,53.25,31.36,83.46a61.68,61.68,0,0,1-4.18,8.82,54.68,54.68,0,0,1-17.51,20.83,69.25,69.25,0,0,1-7.85,5c-27.38,13-64.38,9-86.45-11.4a68.39,68.39,0,0,1-6.11-7.47,64.89,64.89,0,0,1-5.57-9.5A55.78,55.78,0,0,1,272,577.1,75.67,75.67,0,0,1,271.4,568.53Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M269.77,550.18c-1-28.36,18-52.36,43.28-63.56a62.23,62.23,0,0,1,8.15-2.7,70,70,0,0,1,42.22,2.68,71.54,71.54,0,0,1,8.92,4.16c29.53,15.89,42.79,53.26,31.36,83.46a59.6,59.6,0,0,1-4.18,8.82,63.85,63.85,0,0,1-4.71,7.8,64.78,64.78,0,0,1-5.68,7,63.08,63.08,0,0,1-7.12,6.07,68.37,68.37,0,0,1-7.85,5c-27.38,13-64.38,9-86.44-11.39a68.28,68.28,0,0,1-6.11-7.48,65,65,0,0,1-5.58-9.5,55.59,55.59,0,0,1-5.71-21.73A71.3,71.3,0,0,1,269.77,550.18Z",
    fill: colors.white
  }), React.createElement("circle", {
    cx: "338.51",
    cy: "541.79",
    r: "12.24",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M399.52,583a59.6,59.6,0,0,0,4.18-8.82,62.5,62.5,0,0,0,2.57-8.64c-68.32-7.75-127,20.81-127,20.81l1.1,1.75c.41.62.82,1.24,1.25,1.84a68.28,68.28,0,0,0,6.11,7.48c22.06,20.36,59.06,24.36,86.44,11.39a68.37,68.37,0,0,0,7.85-5,63.08,63.08,0,0,0,7.12-6.07,64.78,64.78,0,0,0,5.68-7A63.85,63.85,0,0,0,399.52,583Z",
    fill: skin.base,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "6px"
  }), React.createElement("path", {
    d: "M269.77,550.18c-1-28.36,18-52.36,43.28-63.56a62.23,62.23,0,0,1,8.15-2.7,70,70,0,0,1,42.22,2.68,71.54,71.54,0,0,1,8.92,4.16c29.53,15.89,42.79,53.26,31.36,83.46a59.6,59.6,0,0,1-4.18,8.82,63.85,63.85,0,0,1-4.71,7.8,64.78,64.78,0,0,1-5.68,7,63.08,63.08,0,0,1-7.12,6.07,68.37,68.37,0,0,1-7.85,5c-27.38,13-64.38,9-86.44-11.39a68.28,68.28,0,0,1-6.11-7.48,65,65,0,0,1-5.58-9.5,55.59,55.59,0,0,1-5.71-21.73A71.3,71.3,0,0,1,269.77,550.18Z",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    fill: "none",
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M583.89,560.47c.43-15.13,6.67-30.09,15.1-41.33a72.82,72.82,0,0,1,7.12-8.53,69.73,69.73,0,0,1,90.17-8.95,73.27,73.27,0,0,1,6.53,5.13c27,21.45,30.12,63.14,15.32,93.23a62.31,62.31,0,0,1-4.78,6.86,72.09,72.09,0,0,1-7.58,8.13c-20.27,17.83-51.81,22.13-77.41,12.42a71.34,71.34,0,0,1-10.55-5c-17.9-10.78-30.37-31.09-33.43-52.23A62.93,62.93,0,0,1,583.89,560.47Z",
    fill: skin.base
  }), React.createElement("path", {
    d: "M589.38,549c.42-14.15,6.42-28.15,14.52-38.66a70.56,70.56,0,0,1,6.86-8A68.55,68.55,0,0,1,697.53,494a69.81,69.81,0,0,1,6.28,4.79c26,20.07,29,59.07,14.74,87.22a56.5,56.5,0,0,1-4.6,6.42,68.91,68.91,0,0,1-7.29,7.6c-19.51,16.68-49.86,20.71-74.49,11.62A68.79,68.79,0,0,1,622,606.9c-17.22-10.08-29.22-29.08-32.17-48.85A56.34,56.34,0,0,1,589.38,549Z",
    stroke: colors.outline,
    fill: colors.white,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("circle", {
    cx: "659.21",
    cy: "550.79",
    r: "12.24",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M718.86,618.11c-10.23,5-20.32,9.55-31.34,12.69a97.34,97.34,0,0,1-16.46,3.3,141.1,141.1,0,0,1-17.69.3A144.2,144.2,0,0,1,633,632.48c-1.93-.31-4.13.51-4.62,2.62-.41,1.81.55,4.28,2.62,4.62a164.26,164.26,0,0,0,19.66,2.1c3.19.13,6.37.06,9.56.16a78.25,78.25,0,0,0,9.06-.21c12-1,23.62-4.28,34.76-8.76,6.32-2.55,12.52-5.4,18.63-8.42a3.77,3.77,0,0,0,1.34-5.13,3.83,3.83,0,0,0-5.13-1.35Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M365.31,627.42c-11.37,2.16-22.4,3.8-34.06,3.83a95.68,95.68,0,0,1-17-1.36,171.78,171.78,0,0,1-35.56-11.64,3.85,3.85,0,0,0-5.13,1.35c-.95,1.62-.5,4.27,1.34,5.13a164.42,164.42,0,0,0,17.87,7.1c2.91,1,5.87,1.7,8.78,2.6a91.22,91.22,0,0,0,8.91,2.35c11.95,2.42,24.22,2.37,36.31,1,6.88-.76,13.71-1.88,20.51-3.17,2-.37,3.12-2.77,2.62-4.61a3.83,3.83,0,0,0-4.62-2.62Z",
    fill: colors.outline
  }), withLashes && React.createElement("g", {
    transform: "translate(0 -5)"
  }, React.createElement(LeftLash, null), React.createElement(RightLash, null)));
};

var Shirt = function Shirt(_ref) {
  var color = _ref.color,
      _ref$graphic = _ref.graphic,
      Graphic = _ref$graphic === void 0 ? Noop : _ref$graphic;

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      skin = _useTheme.skin;

  var _colors$clothing$colo = colors.clothing[color],
      base = _colors$clothing$colo.base,
      shadow = _colors$clothing$colo.shadow;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M677.8,906.35c.21-37.11-1.21-70.07-7.73-95.39C660,785.6,641.89,770.48,610,770.48L632.79,905S655.31,915.24,677.8,906.35Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M686.41,895.79a20.31,20.31,0,0,1-3.7,2.43",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M326.11,809.88c-6.83,25.57-8,59.13-7.74,97,19.9,8.54,50.42-2.15,50.42-2.15l17.33-132.24C355.25,772.46,336.85,786.36,326.11,809.88Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M613.76,758.72H559.55v.1a62.78,62.78,0,0,1-1.44,13.39,60.92,60.92,0,0,1-1.74,6.33,50.88,50.88,0,0,1-10,16.83,48.2,48.2,0,0,1-4.5,4.43c-25.17,18.2-65.17,19.2-89.48-.58a51.79,51.79,0,0,1-7.11-7.6,50.84,50.84,0,0,1-9.1-19.41,62.41,62.41,0,0,1-1.07-6.59,61,61,0,0,1-.37-6.8v-.1H380.53A13.28,13.28,0,0,0,367.26,772v284.68A13.28,13.28,0,0,0,380.53,1070H619.47a13.28,13.28,0,0,0,13.27-13.28V778.6C632.74,766.38,626.85,758.72,613.76,758.72Z",
    fill: base
  }), React.createElement("path", {
    d: "M610,758.72c63.54,0,73.4,56,73.9,133.17-18.6,11.62-48.91,1.31-48.91,1.31Z",
    fill: base
  }), React.createElement("path", {
    d: "M632.74,831.87,610,870l11.38,130h11.61V894.35l17.28,2.89C644.6,825.07,632.74,831.87,632.74,831.87Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M386.12,758.72c-61.78,0-75.83,53.8-76.85,127.66,19,19.86,58,4.58,58,4.58Z",
    fill: base
  }), React.createElement("path", {
    d: "M367.23,831.87V891l-17.31,4.31C355.59,825.19,367.23,831.87,367.23,831.87Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M610,758.72c67.41,0,78.45,56.29,78.9,133.78-26.2,12.43-53.91.7-53.91.7",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M386.12,758.72c-66.79,0-80.08,54.7-80.76,130.72C326,904.22,367.22,891,367.22,891",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M380.53,1070H497.15C388,1070,396.24,838.82,367.26,838.82v217.86A13.28,13.28,0,0,0,380.53,1070Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M361.26,860.85c-.19-3.67-.11-7.34.05-11s.47-7.35.86-11c.2-1.84.4-3.67.65-5.51s.49-3.67.85-5.51a44.18,44.18,0,0,1,3.59-11,43.74,43.74,0,0,1,3.58,11c.37,1.84.63,3.67.86,5.51s.45,3.67.65,5.51c.38,3.67.68,7.34.85,11s.25,7.34.06,11Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M632.74,870v8c.26,34,.26,69,0,102.75,0,2.87,0,5.72,0,8.53v67.41A13.28,13.28,0,0,1,619.47,1070H380.53a13.28,13.28,0,0,1-13.27-13.28V998.52c0-2.51,0-5.07,0-7.65-.25-34.87-.25-69.87,0-105.3V860.85",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M626.74,870c-.19-4.17-.1-8.35.06-12.53s.47-8.35.85-12.53c.2-2.09.41-4.18.65-6.27s.49-4.17.86-6.26a54.55,54.55,0,0,1,3.58-12.53,55.09,55.09,0,0,1,3.59,12.53c.36,2.09.62,4.18.85,6.26s.45,4.18.65,6.27c.38,4.18.69,8.35.85,12.53s.25,8.36.06,12.53Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M380.53,758.82l233.23-.1",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M559.55,758.82a62.78,62.78,0,0,1-1.44,13.39,60.92,60.92,0,0,1-1.74,6.33,50.88,50.88,0,0,1-10,16.83,48.2,48.2,0,0,1-4.5,4.43c-25.17,18.2-65.17,19.2-89.48-.58a51.79,51.79,0,0,1-7.11-7.6,50.84,50.84,0,0,1-9.1-19.41,62.41,62.41,0,0,1-1.07-6.59,61,61,0,0,1-.37-6.8",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M503.4,828.39a66.61,66.61,0,0,1-18.39,1.1,69.79,69.79,0,0,1-18.2-3.76,61.46,61.46,0,0,1-16.5-8.64l-1.86-1.41c-.61-.48-1.2-1-1.79-1.52a32.24,32.24,0,0,1-3.33-3.28,43.83,43.83,0,0,1-5.38-7.51,87.37,87.37,0,0,0,6.74,6.09c.58.48,1.17.95,1.75,1.4s1.23.82,1.84,1.24,1.22.84,1.85,1.23l1.91,1.16a88.05,88.05,0,0,0,16.1,7.46,106.26,106.26,0,0,0,17.25,4.45A173.7,173.7,0,0,0,503.4,828.39Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M307.83,892.5a24.54,24.54,0,0,0,3.68,2.77",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M674.7,882.69a19.88,19.88,0,0,1-6.76,2.52,34.83,34.83,0,0,1-7.2.65,40.16,40.16,0,0,1-7.18-.79c-1.18-.21-2.33-.56-3.49-.87s-2.27-.77-3.37-1.24c1.21,0,2.38.18,3.56.28l3.52.29c1.17,0,2.33.2,3.5.21s2.32.11,3.48.12q3.5.06,7-.19A49.31,49.31,0,0,0,674.7,882.69Z",
    fill: colors.outline
  }), React.createElement(Graphic, null));
};

var ContentEyes = function ContentEyes() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M703.51,506.11V519a49.59,49.59,0,0,1-1.94,25.32,45.67,45.67,0,0,1-3.51,7.65c-3.35,8.71-12.35,15.71-21.35,18.71-14,4-31,2-42-9-14-15-12-37-12.45-55.62",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M376.69,505.7c2.34,26.61-1.66,63.61-36.13,67.17a45.89,45.89,0,0,1-8.12,0A43.6,43.6,0,0,1,310,564.31c-18-15-14-39-13.95-58.62",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }));
};

var SeriousEyebrows = function SeriousEyebrows() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M407.29,474.84H286.65c-5.56,0-11.12-.08-16.68,0h-.24c-5.23,0-10.24,4.6-10,10a10.17,10.17,0,0,0,10,10H390.37c5.55,0,11.12.08,16.68,0h.24c5.23,0,10.24-4.6,10-10a10.18,10.18,0,0,0-10-10Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M726.32,474.84H605.68c-5.56,0-11.12-.08-16.68,0h-.24c-5.23,0-10.24,4.6-10,10a10.17,10.17,0,0,0,10,10H709.4c5.56,0,11.12.08,16.68,0h.24c5.23,0,10.24-4.6,10-10a10.18,10.18,0,0,0-10-10Z",
    fill: colors.outline
  }));
};

var RoundGlasses = function RoundGlasses() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("circle", {
    cx: "338.9",
    cy: "548.55",
    r: "93.31",
    fill: "white",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M744.47,606.82a103.27,103.27,0,0,1-188.33-51.49c-37-14.6-74.43-14.47-114.19.39a103.43,103.43,0,0,1-103,96.13c-32.48,0-76-36.5-71-28.39,14,20.69,47,36.45,72.54,36.45,54.55,0,97.87-39.29,101.56-92.92,39.76-14.85,77.23-15,114.19-.39,3.5,53.82,48.39,93.53,103.07,93.53C704,660.13,729.4,626,744.47,606.82Z",
    opacity: 0.15
  }), React.createElement("path", {
    d: "M320,648.75,443.07,525.67a93.05,93.05,0,0,0-10-17.27L302.72,638.76A93.1,93.1,0,0,0,320,648.75Z",
    fill: "white",
    opacity: 0.4
  }), React.createElement("circle", {
    cx: "338.9",
    cy: "548.55",
    r: "93.31",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "20px"
  }), React.createElement("circle", {
    cx: "659.21",
    cy: "548.55",
    r: "93.31",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "20px"
  }), React.createElement("path", {
    d: "M432.77,548.55c45.2-18.31,89.61-19,133.14,0",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "20px"
  }), React.createElement("path", {
    d: "M314.7,492.5c2.06,6.5-5.94,11.5-11.94,12.5-6,0-10-4-12-9-1-5,0-10,4-13,5-2,12-4,16.45,1.13A11.66,11.66,0,0,1,314.7,492.5Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M325.37,488.67c-.61,4.33-6.61,4.33-7.61.33,0-3,1-4,3.85-4.1A3.76,3.76,0,0,1,325.37,488.67Z",
    fill: "white"
  }), React.createElement("circle", {
    cx: "659.21",
    cy: "548.55",
    r: "93.31",
    fill: "white",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M645.19,640.81,751.47,534.52a94.74,94.74,0,0,0-2.41-11.22L634,638.4A94.31,94.31,0,0,0,645.19,640.81Z",
    fill: "white",
    opacity: 0.4
  }), React.createElement("circle", {
    cx: "659.21",
    cy: "548.55",
    r: "93.31",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "20px"
  }), React.createElement("path", {
    d: "M635,492.5c2.06,6.5-5.94,11.5-11.94,12.5-6,0-10-4-12-9-1-5,0-10,4-13,5-2,12-4,16.45,1.13A11.7,11.7,0,0,1,635,492.5Z",
    fill: "white"
  }), React.createElement("path", {
    d: "M645.69,488.67c-.61,4.33-6.61,4.33-7.61.33,0-3,1-4,3.84-4.1A3.77,3.77,0,0,1,645.69,488.67Z",
    fill: "white"
  }));
};

var AngryEyebrows = function AngryEyebrows() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M427.29,501.13l-13-4.39-31.2-10.54-37.6-12.71-32.49-11c-5.27-1.78-10.51-3.68-15.81-5.34l-.22-.08a10,10,0,0,0-5.32,19.29l13,4.39,31.2,10.54,37.6,12.7,32.49,11c5.26,1.78,10.5,3.67,15.81,5.34l.22.08a10,10,0,0,0,5.32-19.29Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M697.18,453.9,684.46,459l-30.54,12.31-36.81,14.84L585.3,499q-7.74,3.12-15.47,6.24l-.22.08c-2.51,1-4.56,2.17-6,4.6a10.18,10.18,0,0,0-1,7.71,10.06,10.06,0,0,0,4.6,6c2.22,1.18,5.26,2,7.7,1l12.73-5.13,30.54-12.31L655,492.33l31.81-12.82c5.15-2.08,10.32-4.15,15.47-6.24l.22-.09c2.51-1,4.56-2.17,6-4.59a10,10,0,0,0-3.59-13.69c-2.22-1.17-5.27-2-7.71-1Z",
    fill: colors.outline
  }));
};

var StubbleBeard = function StubbleBeard() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M664.05,702.32c28.31-23,54.41-54.72,70.68-86.1-.06-.1-3.49,3.38-3.55,3.28S710.11,638.28,649.66,638c-76.3-.31-60.54-21.68-152.51-21.68-81.42,0-68.49,11.89-145.15,16.15-62.09,3.45-83.62-13-83.62-13l-.2.33a261.18,261.18,0,0,0,40.56,57.53c4.32,4.65,8.86,9.18,13.48,13.48a193.3,193.3,0,0,0,15.35,13c5.18,3.95,10.67,7.72,16.33,11.21,21.71,12,46.48,21.14,73.63,27.13,6.49,1.43,13,2.64,19.31,3.6,65.81,5.85,141.08,6.7,200.74-31.12C653.21,710.78,658.75,706.63,664.05,702.32Z",
    opacity: 0.15
  }), React.createElement("circle", {
    cx: "311.51",
    cy: "659.14",
    r: "4.18",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "338.51",
    cy: "663.32",
    r: "2.96",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "401.05",
    cy: "707.98",
    r: "2.96",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "506.83",
    cy: "711.31",
    r: "2.96",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "517.63",
    cy: "704.5",
    r: "2.96",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "578.33",
    cy: "701.54",
    r: "2.96",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "581.29",
    cy: "683.15",
    r: "2.96",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "391.69",
    cy: "690.72",
    r: "5.37",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "600.44",
    cy: "707.45",
    r: "2.09",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "642.96",
    cy: "696.08",
    r: "4.18",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "462.56",
    cy: "724.04",
    r: "4.18",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "642.96",
    cy: "663.22",
    r: "2.96",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "654.05",
    cy: "673.06",
    r: "2.96",
    fill: colors.outline
  }));
};

var RedwoodGraphic = function RedwoodGraphic() {
  return React.createElement(React.Fragment, null, React.createElement("rect", {
    x: "441.15",
    y: "860.49",
    width: "112",
    height: "112",
    fill: "none"
  }), React.createElement("rect", {
    x: "433.91",
    y: "856",
    width: "132.18",
    height: "132.18",
    fill: "none"
  }), React.createElement("path", {
    d: "M490.59,859c-4.7,2.37-14.62,7-20,10.65s-4.7,7.1-7.05,9.47-9.4,8.28-14.1,11.83-3.53,13-4.7,16.56-3.53,11.83-4.71,15.38,2.35,8.28,4.71,13,8.22,17.74,10.57,22.48,9.41,2.36,15.28,7.09a206.67,206.67,0,0,0,20,14.2c5.87,3.55,8.23,3.55,14.1,0a205.35,205.35,0,0,0,20-14.2c5.88-4.73,12.93-2.36,15.29-7.09s8.22-17.75,10.57-22.48,5.88-9.47,4.71-13-3.53-11.83-4.71-15.38,0-13-4.7-16.56a174,174,0,0,1-14.1-11.83c-4-3.77-2.35-5.92-7.06-9.47s-15.28-8.28-20-10.65A14.93,14.93,0,0,0,490.59,859Z",
    fillRule: "evenodd",
    fill: colors.white
  }), React.createElement("path", {
    d: "M474,879.46l22,15a3.14,3.14,0,0,0,1.68.52,3,3,0,0,0,1.67-.52l22-15.07a3,3,0,0,0-.41-5.13l-22-10.9a3.05,3.05,0,0,0-2.64,0l-21.94,10.9a3,3,0,0,0-.36,5.18Zm31.14,19.73a3,3,0,0,0,1.3,2.49l17.64,12.06a3,3,0,0,0,3.66-.24l14.79-13.23a3,3,0,0,0-.13-4.6l-14.12-11.29a3,3,0,0,0-3.55-.14l-18.29,12.51A3,3,0,0,0,505.13,899.19Zm-43.87,16.4a3,3,0,0,1,1,2.54,3,3,0,0,1-1.49,2.29l-10.53,6.31a3,3,0,0,1-3.39-.23,3,3,0,0,1-1-3.27l3.9-12.25a3,3,0,0,1,2.05-2,2.92,2.92,0,0,1,2.78.66Zm57.13,1.28-19.05-13a3,3,0,0,0-3.34,0l-19,13a3,3,0,0,0-1.3,2.29,3.13,3.13,0,0,0,1,2.46l19,17a2.94,2.94,0,0,0,2,.75,3,3,0,0,0,2-.75l19-17a3,3,0,0,0,1-2.46A3,3,0,0,0,518.39,916.87ZM467.6,913.5l-14.78-13.23a3.07,3.07,0,0,1-1-2.37,3,3,0,0,1,1.12-2.28l14.12-11.36a3,3,0,0,1,3.57-.13l18.27,12.5a3.05,3.05,0,0,1,1.36,2.53,3,3,0,0,1-1.36,2.52l-17.62,12.06A3,3,0,0,1,467.6,913.5Zm75.88,19-15.05-9a3,3,0,0,0-3.51.34l-18.39,16.41a3,3,0,0,0,.87,5l25.51,10.34a3,3,0,0,0,3.85-1.57l7.9-17.71A3,3,0,0,0,543.48,932.51ZM545.57,911l3.89,12.25h0a3,3,0,0,1-2.86,3.93,2.91,2.91,0,0,1-1.52-.43l-10.55-6.31a2.93,2.93,0,0,1-1.44-2.29,3,3,0,0,1,1-2.54l6.69-6a3,3,0,0,1,2.77-.66A3,3,0,0,1,545.57,911Zm-55.8,32a3,3,0,0,0-1-2.76l-18.39-16.41a3,3,0,0,0-3.51-.34l-15,9a3.05,3.05,0,0,0-1.2,3.84l7.92,17.71a3,3,0,0,0,3.84,1.56l25.5-10.33A3,3,0,0,0,489.77,943Zm9,5,20.46,8.29a3,3,0,0,1,.54,5.27l-20.48,14.22a2.94,2.94,0,0,1-1.67.54,3,3,0,0,1-1.67-.54l-20.46-14.22a3,3,0,0,1,.58-5.27l20.46-8.29A3.09,3.09,0,0,1,498.79,948.06Z",
    fill: "#c04927",
    fillRule: "evenodd"
  }));
};

var GatsbyGraphic = function GatsbyGraphic() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M500,860.85a59.07,59.07,0,1,0,59.07,59.07A59.24,59.24,0,0,0,500,860.85Zm-32.91,92a45.79,45.79,0,0,1-13.5-32.07l46,45.57C487.76,965.91,476,961.69,467.09,952.83Zm43,12.23L454.86,909.8a46.37,46.37,0,0,1,82.69-17.3L531.22,898A39,39,0,0,0,500,882a38.38,38.38,0,0,0-35.86,25.31l48.52,48.52a38.26,38.26,0,0,0,24.47-27.42H516.88v-8.44h29.53A46.54,46.54,0,0,1,510.13,965.06Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "16px"
  }), React.createElement("path", {
    d: "M500,860.85a59.07,59.07,0,1,0,59.07,59.07A59.24,59.24,0,0,0,500,860.85Zm-32.91,92a45.79,45.79,0,0,1-13.5-32.07l46,45.57C487.76,965.91,476,961.69,467.09,952.83Zm43,12.23L454.86,909.8a46.37,46.37,0,0,1,82.69-17.3L531.22,898A39,39,0,0,0,500,882a38.38,38.38,0,0,0-35.86,25.31l48.52,48.52a38.26,38.26,0,0,0,24.47-27.42H516.88v-8.44h29.53A46.54,46.54,0,0,1,510.13,965.06Z",
    fill: "#663795"
  }));
};

var Front$c = function Front(_ref) {
  var color = _ref.color;

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      skin = _useTheme.skin;

  var base = colors.clothing[color].base;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M329.09,794.17c56.12,35.58,168.48,75.53,168.48,75.53l-.16,14S397,879.36,316.32,844.9C316.32,814.38,329.09,794.17,329.09,794.17Z",
    fill: base,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M648.66,870.5s17.7-1.85,30.9-9c-.11-4.25-.6-8.11-.6-8.11l-30.85,10.68Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M671.55,794.43C619,831.8,503,869.7,503,869.7l.17,14s100.41-4.3,181.08-38.76C684.29,822.67,671.55,794.43,671.55,794.43Z",
    fill: base,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M320.63,822.65c.28.24.83.61,1.27.92s1,.64,1.45.95c1,.6,2,1.21,3.08,1.77,2.08,1.16,4.23,2.25,6.43,3.28s4.42,2,6.65,3c1.12.5,2.23,1,3.34,1.58s2.22,1.1,3.31,1.76a40.85,40.85,0,0,1-7.42-1.08q-3.63-.9-7.17-2.15a65,65,0,0,1-7-2.89c-1.13-.56-2.26-1.16-3.36-1.84-.55-.34-1.09-.69-1.64-1.06a15.93,15.93,0,0,1-1.67-1.31Z",
    fill: colors.outline
  }));
};
var Back$c = function Back(_ref2) {
  var color = _ref2.color;

  var _useTheme2 = useTheme(),
      colors = _useTheme2.colors;

  var _colors$clothing$colo = colors.clothing[color],
      base = _colors$clothing$colo.base,
      shadow = _colors$clothing$colo.shadow;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M568.44,849.8c-21.18,6.89-42,17.48-62.85,19.67-26.75,2.82-54.1-13.37-82.3-21.08-2.15-2.58-18.35-14.44-33.47-13.94-11.88.4-15.09,4.3-18.4,8.19l-4.16,213.48a13.27,13.27,0,0,0,13.27,13.27H619.47a13.27,13.27,0,0,0,13.27-13.27l-2.38-215.36c-4.43,0-7.1-9.4-20.41-5.09C593.66,841,569.71,848.28,568.44,849.8Z",
    fill: base
  }), React.createElement("polygon", {
    points: "632.74 831.31 609.95 869.4 621.34 999.43 632.94 999.43 632.94 893.78 632.74 831.31",
    fill: shadow
  }), React.createElement("path", {
    d: "M380.53,1069.39H497.15c-109.2,0-100.91-231.14-129.89-231.14v217.87A13.27,13.27,0,0,0,380.53,1069.39Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M361.26,860.4a63.71,63.71,0,0,1-.1-8.29q.19-4.15.71-8.31c.18-1.39.35-2.77.57-4.16s.44-2.77.78-4.16a27.84,27.84,0,0,1,3.44-8.35,27.54,27.54,0,0,1,3.73,8.22c.39,1.38.68,2.76.93,4.13s.5,2.76.72,4.14c.44,2.75.79,5.51,1,8.27a62,62,0,0,1,.21,8.29Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M632.74,869.4v8c.26,34,.26,69,0,102.76,0,2.87,0,5.72,0,8.53v67.41a13.27,13.27,0,0,1-13.27,13.27H380.53a13.27,13.27,0,0,1-13.27-13.27V998q0-3.76,0-7.65c-.25-34.86-.25-69.86,0-105.3V860.29",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M626.76,869.38a65.79,65.79,0,0,1,.65-8.53q.57-4.25,1.46-8.47c.3-1.41.6-2.82.94-4.22s.69-2.81,1.15-4.21a29.21,29.21,0,0,1,4.18-8.28,28.9,28.9,0,0,1,3,8.78c.26,1.45.42,2.89.55,4.33s.25,2.88.35,4.31c.18,2.87.28,5.74.25,8.59a67.65,67.65,0,0,1-.54,8.54Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M557.91,889.36c4.41-.78,8.76-1.39,13.1-2l13-1.93c4.31-.65,8.61-1.36,12.91-2.1s8.61-1.58,13.07-2.2a62.58,62.58,0,0,1-12.33,5.26,87,87,0,0,1-13,3,94.61,94.61,0,0,1-13.33,1.11A65.72,65.72,0,0,1,557.91,889.36Z",
    fill: colors.outline
  }));
};
var braStraps = false;

var Dress = {
  __proto__: null,
  Front: Front$c,
  Back: Back$c,
  braStraps: braStraps
};

var SquintEyes = function SquintEyes(_ref) {
  var withLashes = _ref.withLashes;

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      skin = _useTheme.skin;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M271.4,576.82c-1-28.36,18-52.36,43.28-63.56a62.37,62.37,0,0,1,8.16-2.7,70,70,0,0,1,42.21,2.68A71.67,71.67,0,0,1,374,517.4c29.53,15.88,42.79,53.25,31.36,83.46a61.68,61.68,0,0,1-4.18,8.82,54.68,54.68,0,0,1-17.51,20.83,69.25,69.25,0,0,1-7.85,5c-27.38,13-64.38,9-86.45-11.4a69.35,69.35,0,0,1-6.11-7.47,64.89,64.89,0,0,1-5.57-9.5A55.78,55.78,0,0,1,272,585.39,75.67,75.67,0,0,1,271.4,576.82Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M269.77,558.47c-1-28.36,18-52.36,43.28-63.56a62.23,62.23,0,0,1,8.15-2.7,70,70,0,0,1,42.22,2.68,71.54,71.54,0,0,1,8.92,4.16c29.53,15.89,42.79,53.25,31.36,83.46a59.6,59.6,0,0,1-4.18,8.82,63.85,63.85,0,0,1-4.71,7.8,64.78,64.78,0,0,1-5.68,7,63.08,63.08,0,0,1-7.12,6.07,68.37,68.37,0,0,1-7.85,5c-27.38,13-64.38,9-86.44-11.4a67.24,67.24,0,0,1-6.11-7.47,65,65,0,0,1-5.58-9.5A55.59,55.59,0,0,1,270.32,567,71.3,71.3,0,0,1,269.77,558.47Z",
    fill: colors.white
  }), React.createElement("circle", {
    cx: "338.51",
    cy: "559.08",
    r: "12.24",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M339.2,490.12a68.31,68.31,0,0,0-48.45,20.07,69.79,69.79,0,0,0-6.86,8,73.12,73.12,0,0,0-10.3,18.39H403.92a58.59,58.59,0,0,0-20.12-30,69.37,69.37,0,0,0-6.28-4.79A68.21,68.21,0,0,0,339.2,490.12Z",
    fill: skin.base,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M274.09,581.45c5.5,13.75,15.3,25.93,27.92,33.32a68.27,68.27,0,0,0,10.15,4.7c24.63,9.09,55,5.07,74.49-11.61a69.9,69.9,0,0,0,7.29-7.61,55.62,55.62,0,0,0,4.6-6.42,77.37,77.37,0,0,0,4.94-12.38Z",
    fill: skin.base,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M269.77,558.47c-1-28.36,18-52.36,43.28-63.56a62.23,62.23,0,0,1,8.15-2.7,70,70,0,0,1,42.22,2.68,71.54,71.54,0,0,1,8.92,4.16c29.53,15.89,42.79,53.25,31.36,83.46a59.6,59.6,0,0,1-4.18,8.82,63.85,63.85,0,0,1-4.71,7.8,64.78,64.78,0,0,1-5.68,7,63.08,63.08,0,0,1-7.12,6.07,68.37,68.37,0,0,1-7.85,5c-27.38,13-64.38,9-86.44-11.4a67.24,67.24,0,0,1-6.11-7.47,65,65,0,0,1-5.58-9.5A55.59,55.59,0,0,1,270.32,567,71.3,71.3,0,0,1,269.77,558.47Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M583.89,568.76c.43-15.13,6.67-30.09,15.1-41.33a72.82,72.82,0,0,1,7.12-8.53A69.73,69.73,0,0,1,696.28,510a73.27,73.27,0,0,1,6.53,5.13c27,21.45,30.12,63.14,15.32,93.23a62.31,62.31,0,0,1-4.78,6.86,72.09,72.09,0,0,1-7.58,8.13c-20.27,17.83-51.81,22.13-77.41,12.42a71.34,71.34,0,0,1-10.55-5c-17.9-10.78-30.37-31.09-33.43-52.23A62.93,62.93,0,0,1,583.89,568.76Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M589.38,557.26c.42-14.15,6.42-28.15,14.52-38.66a70.56,70.56,0,0,1,6.86-8,68.55,68.55,0,0,1,86.77-8.37,69.81,69.81,0,0,1,6.28,4.79c26,20.07,29,59.07,14.74,87.22a56.5,56.5,0,0,1-4.6,6.42,68.91,68.91,0,0,1-7.29,7.6C687.15,625,656.8,629,632.17,619.9A68.79,68.79,0,0,1,622,615.19c-17.22-10.08-29.22-29.08-32.17-48.85A56.34,56.34,0,0,1,589.38,557.26Z",
    fill: colors.white
  }), React.createElement("circle", {
    cx: "659.21",
    cy: "559.08",
    r: "12.24",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M659.21,490.55a68.31,68.31,0,0,0-48.45,20.07,70.56,70.56,0,0,0-6.86,8A73.3,73.3,0,0,0,593.6,537H723.93A58.63,58.63,0,0,0,703.81,507a69.81,69.81,0,0,0-6.28-4.79A68.21,68.21,0,0,0,659.21,490.55Z",
    fill: skin.base,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M594.1,581.87c5.51,13.76,15.3,25.94,27.92,33.32a68.79,68.79,0,0,0,10.15,4.71c24.63,9.09,55,5.06,74.49-11.62a68.91,68.91,0,0,0,7.29-7.6,56.5,56.5,0,0,0,4.6-6.42,76.19,76.19,0,0,0,4.94-12.39Z",
    fill: skin.base,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M589.38,557.26c.42-14.15,6.42-28.15,14.52-38.66a70.56,70.56,0,0,1,6.86-8,68.55,68.55,0,0,1,86.77-8.37,69.81,69.81,0,0,1,6.28,4.79c26,20.07,29,59.07,14.74,87.22a56.5,56.5,0,0,1-4.6,6.42,68.91,68.91,0,0,1-7.29,7.6C687.15,625,656.8,629,632.17,619.9A68.79,68.79,0,0,1,622,615.19c-17.22-10.08-29.22-29.08-32.17-48.85A56.34,56.34,0,0,1,589.38,557.26Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), withLashes && React.createElement(React.Fragment, null, React.createElement(LeftLash, null), React.createElement(RightLash, null)));
};

var ConcernedEyebrows = function ConcernedEyebrows() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M255.06,519.62l13-4.4,31.2-10.54,37.6-12.7,32.49-11c5.27-1.78,10.55-3.51,15.8-5.34l.23-.07a10.6,10.6,0,0,0,6-4.6,10,10,0,0,0-3.58-13.68,10,10,0,0,0-7.71-1l-13,4.39-31.2,10.54-37.6,12.71-32.49,11c-5.27,1.78-10.55,3.52-15.8,5.34l-.23.08a10.6,10.6,0,0,0-6,4.6,10,10,0,0,0,3.58,13.68,10,10,0,0,0,7.71,1Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M617.56,475l12.73,5.13,30.54,12.31,36.81,14.84,31.81,12.83c5.15,2.07,10.26,4.3,15.47,6.24l.22.08c2.25.91,5.71.16,7.71-1a10,10,0,0,0,3.58-13.69l-1.56-2a10,10,0,0,0-4.41-2.57L737.73,502l-30.54-12.32-36.81-14.84L638.57,462c-5.15-2.08-10.26-4.31-15.47-6.24l-.22-.09c-2.25-.91-5.71-.16-7.71,1a10,10,0,0,0-3.58,13.68l1.56,2a10.07,10.07,0,0,0,4.41,2.58Z",
    fill: colors.outline
  }));
};

var Shades = function Shades() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M725,631.82a265.34,265.34,0,0,0,26.3-59.43c-17.24,35.74-49.84,65.46-92.11,65.46A106.75,106.75,0,0,1,552.58,531.22,105.67,105.67,0,0,1,560.41,491H758a105.33,105.33,0,0,1,7.62,33.39c.73-8,1.12-16.19,1.12-24.42a269.16,269.16,0,0,0-1.58-29H575v0H423.14v0H234.83a269.16,269.16,0,0,0-1.58,29c0,4.73.14,9.42.38,14.09A104.92,104.92,0,0,1,240.1,491H437.7a106.7,106.7,0,0,1-98.8,146.82c-38.8,0-68.82-25.83-87.48-56.89a266.14,266.14,0,0,0,24.76,52.84c19.39,12.07,38.25,24.05,62.72,24.05A126.78,126.78,0,0,0,465.53,531.22c0-1.81,0-3.61-.12-5.4,23.38-8.23,45.52-8.35,67.31-.36-.08,1.91-.14,3.83-.14,5.76A126.78,126.78,0,0,0,659.21,657.85C685,657.85,705,645.1,725,631.82ZM535.26,505.18c-23.4-7.55-47.64-7.42-72.33.39A124.62,124.62,0,0,0,459,491h80.1A122.6,122.6,0,0,0,535.26,505.18Z",
    opacity: 0.15
  }), React.createElement("path", {
    d: "M233.59,469.82s.41,32.23.41,50.2c0,64.41,40.48,116.63,104.9,116.63A116.68,116.68,0,0,0,444.2,469.82Z",
    fill: colors.outline,
    opacity: 0.95
  }), React.createElement("path", {
    d: "M553.91,469.82a116.68,116.68,0,0,0,105.3,166.83c64.42,0,107.54-52.22,107.54-116.63,0-18-2.23-50.2-2.23-50.2Z",
    fill: colors.outline,
    opacity: 0.95
  }), React.createElement("path", {
    d: "M320,626.86,443.07,503.78a93.05,93.05,0,0,0-10-17.27L302.72,616.88A93.62,93.62,0,0,0,320,626.86Z",
    fill: colors.white,
    opacity: 0.25
  }), React.createElement("path", {
    d: "M455.86,507.53c29.52-12,58.53-12.42,87,0",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "20px"
  }), React.createElement("path", {
    d: "M274.28,504.75c2.06,6.51-5.94,11.51-11.94,12.51-6,0-10-4-12-9-1-5,0-10,4-13,5-2,12-4,16.44,1.12A11.7,11.7,0,0,1,274.28,504.75Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M285,500.93c-.61,4.33-6.61,4.33-7.61.33,0-3,1-4,3.84-4.1A3.77,3.77,0,0,1,285,500.93Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M645.19,618.92,751.47,512.64a93.89,93.89,0,0,0-2.41-11.22L634,616.51A94.31,94.31,0,0,0,645.19,618.92Z",
    fill: colors.white,
    opacity: 0.25
  }), React.createElement("path", {
    d: "M590.68,505.73c2.06,6.51-5.94,11.51-11.94,12.51-6,0-10-4-12-9-1-5,0-10,4-13,5-2,12-4,16.45,1.12A11.69,11.69,0,0,1,590.68,505.73Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M601.35,501.91c-.61,4.33-6.61,4.33-7.61.33,0-3,1-4,3.85-4.1A3.76,3.76,0,0,1,601.35,501.91Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M233.59,469.82s-.34,31.69.41,50.2c2.6,64.36,40.48,116.63,104.9,116.63A116.68,116.68,0,0,0,444.2,469.82Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "20px"
  }), React.createElement("path", {
    d: "M553.91,469.82a116.68,116.68,0,0,0,105.3,166.83c64.42,0,107.54-51.53,107.54-115.94,0-18-2.23-50.89-2.23-50.89Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "20px"
  }), React.createElement("line", {
    x1: "423.14",
    y1: "469.81",
    x2: "574.97",
    y2: "469.81",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "20px"
  }));
};

var TankTop = function TankTop(_ref) {
  var color = _ref.color,
      _ref$graphic = _ref.graphic,
      Graphic = _ref$graphic === void 0 ? Noop : _ref$graphic;

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var _colors$clothing$colo = colors.clothing[color],
      base = _colors$clothing$colo.base,
      shadow = _colors$clothing$colo.shadow;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M613.76,758.16H559.55v.1H589a175.21,175.21,0,0,1-2.12,27.22q-1,6.57-2.57,12.88a116.51,116.51,0,0,1-14.71,34.22,92,92,0,0,1-6.61,9c-37.06,37-95.95,39-131.74-1.19A98.26,98.26,0,0,1,420.8,825a124.07,124.07,0,0,1-13.4-39.48q-1-6.57-1.58-13.39c-.35-4.54-.54-9.15-.54-13.82h29.47v-.1H380.53c.82,22.29-1.59,75.64-9.11,84.48l-4.16,213.48a13.27,13.27,0,0,0,13.27,13.27H619.47a13.27,13.27,0,0,0,13.27-13.27l-2.38-215.36C620.61,840.76,613.42,783.07,613.76,758.16Z",
    fill: base
  }), React.createElement("polygon", {
    points: "632.74 831.31 609.95 869.4 621.34 999.43 632.94 999.43 632.94 893.78 632.74 831.31",
    fill: shadow
  }), React.createElement("path", {
    d: "M380.53,1069.39H497.15c-109.2,0-100.91-231.14-129.89-231.14v217.87A13.27,13.27,0,0,0,380.53,1069.39Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M361.26,860.4a63.71,63.71,0,0,1-.1-8.29q.19-4.15.71-8.31c.18-1.39.35-2.77.57-4.16s.44-2.77.78-4.16a27.84,27.84,0,0,1,3.44-8.35,27.54,27.54,0,0,1,3.73,8.22c.39,1.38.68,2.76.93,4.13s.5,2.76.72,4.14c.44,2.75.79,5.51,1,8.27a62,62,0,0,1,.21,8.29Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M632.74,869.4v8c.26,34,.26,69,0,102.76,0,2.87,0,5.72,0,8.53v67.41a13.27,13.27,0,0,1-13.27,13.27H380.53a13.27,13.27,0,0,1-13.27-13.27V998q0-3.76,0-7.65c-.25-34.86-.25-69.86,0-105.3V860.29",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M626.76,869.38a65.79,65.79,0,0,1,.65-8.53q.57-4.25,1.46-8.47c.3-1.41.6-2.82.94-4.22s.69-2.81,1.15-4.21a29.21,29.21,0,0,1,4.18-8.28,28.9,28.9,0,0,1,3,8.78c.26,1.45.42,2.89.55,4.33s.25,2.88.35,4.31c.18,2.87.28,5.74.25,8.59a67.65,67.65,0,0,1-.54,8.54Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M368.1,833c21.58-5.27,12.43-74.73,12.43-74.73l233.23-.1s3.93,76.62,19.18,82.92",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M589,758.26a175.22,175.22,0,0,1-2.11,27.22q-1,6.57-2.57,12.88a116.51,116.51,0,0,1-14.71,34.22,92,92,0,0,1-6.61,9c-37.06,37-95.95,39-131.74-1.19A98.26,98.26,0,0,1,420.8,825a124.07,124.07,0,0,1-13.4-39.48q-1-6.57-1.58-13.39c-.35-4.54-.54-9.15-.54-13.82",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("g", {
    transform: "translate(0 30)"
  }, React.createElement(Graphic, null)));
};

var SimpleEyes = function SimpleEyes() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("circle", {
    cx: "341.06",
    cy: "569.08",
    r: "20.96",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M340.93,586c1.79-.1,3.79-.26,5.7-.46s3.86-.44,5.79-.74,3.87-.65,5.81-1,3.92-.68,6-.83a24.74,24.74,0,0,1-5.31,3.12,48.86,48.86,0,0,1-5.78,2,50.61,50.61,0,0,1-6,1.36,36.13,36.13,0,0,1-6.24.54Z",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "661.77",
    cy: "569.08",
    r: "20.96",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M661.77,586c1.8-.1,3.79-.26,5.7-.46s3.87-.44,5.8-.74,3.87-.65,5.81-1,3.92-.68,6-.83a25,25,0,0,1-5.31,3.12,48.86,48.86,0,0,1-5.78,2,51.06,51.06,0,0,1-6,1.36,36.22,36.22,0,0,1-6.24.54Z",
    fill: colors.outline
  }));
};

var Vue = function Vue() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M517.8,866.62l-14.4,24.94L489,866.62H441l62.36,108,62.36-108Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "16px"
  }), React.createElement("path", {
    d: "M517.8,866.62l-14.4,24.94L489,866.62H441l62.36,108,62.36-108Z",
    fill: "#44b783"
  }), React.createElement("path", {
    d: "M517.8,866.62l-14.4,24.94L489,866.62H466l37.42,64.81,37.42-64.81Z",
    fill: "#364a5e"
  }));
};

var DizzyEyes = function DizzyEyes() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("line", {
    x1: "375.88",
    y1: "603.9",
    x2: "306.24",
    y2: "534.26",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "16px"
  }), React.createElement("line", {
    x1: "306.24",
    y1: "603.9",
    x2: "375.88",
    y2: "534.26",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "16px"
  }), React.createElement("line", {
    x1: "695.99",
    y1: "603.9",
    x2: "626.34",
    y2: "534.26",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "16px"
  }), React.createElement("line", {
    x1: "626.34",
    y1: "603.9",
    x2: "695.99",
    y2: "534.26",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "16px"
  }));
};

var WinkEyes = function WinkEyes(_ref) {
  var withLashes = _ref.withLashes;

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      skin = _useTheme.skin;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M271.4,576.82c-1-28.36,18-52.36,43.28-63.56a62.37,62.37,0,0,1,8.16-2.7,70,70,0,0,1,42.21,2.68A71.67,71.67,0,0,1,374,517.4c29.53,15.88,42.79,53.25,31.36,83.46a61.68,61.68,0,0,1-4.18,8.82,54.68,54.68,0,0,1-17.51,20.83,69.25,69.25,0,0,1-7.85,5c-27.38,13-64.38,9-86.45-11.4a69.35,69.35,0,0,1-6.11-7.47,64.89,64.89,0,0,1-5.57-9.5A55.78,55.78,0,0,1,272,585.39,75.67,75.67,0,0,1,271.4,576.82Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M269.77,558.47c-1-28.36,18-52.36,43.28-63.56a62.23,62.23,0,0,1,8.15-2.7,70,70,0,0,1,42.22,2.68,71.54,71.54,0,0,1,8.92,4.16c29.53,15.89,42.79,53.25,31.36,83.46a59.6,59.6,0,0,1-4.18,8.82,63.85,63.85,0,0,1-4.71,7.8,64.78,64.78,0,0,1-5.68,7,63.08,63.08,0,0,1-7.12,6.07,68.37,68.37,0,0,1-7.85,5c-27.38,13-64.38,9-86.44-11.4a67.24,67.24,0,0,1-6.11-7.47,65,65,0,0,1-5.58-9.5A55.59,55.59,0,0,1,270.32,567,71.3,71.3,0,0,1,269.77,558.47Z",
    fill: colors.white,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("circle", {
    cx: "338.51",
    cy: "559.08",
    r: "12.24",
    fill: colors.outline
  }), React.createElement("line", {
    x1: "715.03",
    y1: "559.08",
    x2: "603.4",
    y2: "559.08",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "16px"
  }), React.createElement("path", {
    d: "M627,574.16a114.14,114.14,0,0,1,13.07-1.56c4.36-.3,8.72-.43,13.08-.44s8.71.14,13.07.43a114.34,114.34,0,0,1,13.08,1.57,112.18,112.18,0,0,1-13.08,1.58q-6.54.43-13.07.42t-13.08-.43A112,112,0,0,1,627,574.16Z",
    fill: colors.outline
  }), withLashes && React.createElement(LeftLash, null));
};

var HeartEyes = function HeartEyes(_ref) {
  var withLashes = _ref.withLashes;

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      skin = _useTheme.skin;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M271.4,576.82c-1-28.36,18-52.36,43.28-63.56a62.37,62.37,0,0,1,8.16-2.7,70,70,0,0,1,42.21,2.68A71.67,71.67,0,0,1,374,517.4c29.53,15.88,42.79,53.25,31.36,83.46a61.68,61.68,0,0,1-4.18,8.82,54.68,54.68,0,0,1-17.51,20.83,69.25,69.25,0,0,1-7.85,5c-27.38,13-64.38,9-86.45-11.4a69.35,69.35,0,0,1-6.11-7.47,64.89,64.89,0,0,1-5.57-9.5A55.78,55.78,0,0,1,272,585.39,75.67,75.67,0,0,1,271.4,576.82Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M269.77,558.47c-1-28.36,18-52.36,43.28-63.56a62.23,62.23,0,0,1,8.15-2.7,70,70,0,0,1,42.22,2.68,71.54,71.54,0,0,1,8.92,4.16c29.53,15.89,42.79,53.25,31.36,83.46a59.6,59.6,0,0,1-4.18,8.82,63.85,63.85,0,0,1-4.71,7.8,64.78,64.78,0,0,1-5.68,7,63.08,63.08,0,0,1-7.12,6.07,68.37,68.37,0,0,1-7.85,5c-27.38,13-64.38,9-86.44-11.4a67.24,67.24,0,0,1-6.11-7.47,65,65,0,0,1-5.58-9.5A55.59,55.59,0,0,1,270.32,567,71.3,71.3,0,0,1,269.77,558.47Z",
    fill: colors.white,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M374,551.07v5.67a2,2,0,0,0-.13.39,21.27,21.27,0,0,1-1.92,6.53,44.36,44.36,0,0,1-8.59,12.09,120.43,120.43,0,0,1-24.25,18.93.87.87,0,0,1-1.06,0,128.66,128.66,0,0,1-19.86-14.63,61.62,61.62,0,0,1-11.37-13.31,24,24,0,0,1-3.08-18.5c3.22-14.32,21-20.17,32.15-10.57.95.81,1.79,1.76,2.74,2.7a2.75,2.75,0,0,1,.19-.28c5-5.56,11.1-8,18.44-6.81,8.05,1.35,13.32,6.16,15.89,13.9A36.94,36.94,0,0,1,374,551.07Z",
    fill: "#e2495b"
  }), React.createElement("path", {
    d: "M583.89,568.76c.43-15.13,6.67-30.09,15.1-41.33a72.82,72.82,0,0,1,7.12-8.53A69.73,69.73,0,0,1,696.28,510a73.27,73.27,0,0,1,6.53,5.13c27,21.45,30.12,63.14,15.32,93.23a62.31,62.31,0,0,1-4.78,6.86,72.09,72.09,0,0,1-7.58,8.13c-20.27,17.83-51.81,22.13-77.41,12.42a71.34,71.34,0,0,1-10.55-5c-17.9-10.78-30.37-31.09-33.43-52.23A62.93,62.93,0,0,1,583.89,568.76Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M589.38,557.26c.42-14.15,6.42-28.15,14.52-38.66a70.56,70.56,0,0,1,6.86-8,68.55,68.55,0,0,1,86.77-8.37,69.81,69.81,0,0,1,6.28,4.79c26,20.07,29,59.07,14.74,87.22a56.5,56.5,0,0,1-4.6,6.42,68.91,68.91,0,0,1-7.29,7.6C687.15,625,656.8,629,632.17,619.9A68.79,68.79,0,0,1,622,615.19c-17.22-10.08-29.22-29.08-32.17-48.85A56.34,56.34,0,0,1,589.38,557.26Z",
    fill: colors.white,
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M695.19,549.32v5.6a2.91,2.91,0,0,0-.12.39,21,21,0,0,1-1.89,6.44,43.87,43.87,0,0,1-8.49,11.94,118.43,118.43,0,0,1-24,18.69.87.87,0,0,1-1,0,127,127,0,0,1-19.61-14.44,61.31,61.31,0,0,1-11.22-13.14,23.82,23.82,0,0,1-3-18.27c3.18-14.14,20.79-19.91,31.75-10.44.94.8,1.77,1.74,2.7,2.67.06-.1.13-.19.19-.28,4.9-5.49,11-7.94,18.21-6.72,8,1.33,13.16,6.08,15.69,13.72A33.67,33.67,0,0,1,695.19,549.32Z",
    fill: "#e2495b"
  }), withLashes && React.createElement(React.Fragment, null, React.createElement(LeftLash, null), React.createElement(RightLash, null)));
};

var OpenMouth = function OpenMouth() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("circle", {
    cx: "499.7",
    cy: "642.93",
    r: "53.95",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M491.21,663.39c-14.07-3.37-27.62,1-33.45,9.87a48.46,48.46,0,0,0,52.82,20.14,49.33,49.33,0,0,0,6-2C517.93,679.39,507.08,667.18,491.21,663.39Z",
    fill: colors.tongue
  }), React.createElement("path", {
    d: "M478.65,652l.8,0h.65c.43,0,.84,0,1.25.06a17.92,17.92,0,0,1,2.44.35,21,21,0,0,1,4.74,1.53,18.15,18.15,0,0,1,7.78,6.65,17.17,17.17,0,0,1,2.77,9.28,14.75,14.75,0,0,1-2.69,8.47c-1.3-2.76-2.24-5.2-3.31-7.29a24,24,0,0,0-1.62-2.87,12.38,12.38,0,0,0-1.95-2.21,13,13,0,0,0-4.82-2.66,24.72,24.72,0,0,0-2.85-.69c-.49-.07-1-.16-1.47-.22l-.73-.07-.33,0c-.08,0-.26,0-.19,0Z",
    fill: colors.outline
  }), React.createElement("circle", {
    cx: "499.7",
    cy: "642.93",
    r: "53.95",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }));
};

var SeriousMouth = function SeriousMouth() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement("line", {
    x1: "446.66",
    y1: "606.02",
    x2: "542.53",
    y2: "606.02",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  });
};

var ReactGraphic = function ReactGraphic() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M566.88,917.83c0-8.86-11.1-17.26-28.11-22.47,3.93-17.34,2.18-31.13-5.51-35.55a9.56,9.56,0,0,0-6.08-1.56c-8,.13-17.31,5.35-27.23,14.62C490,863.65,479,858.2,472.71,858.36c-3.16.09-4.37.52-6.16,1.56-7.67,4.41-9.38,18.18-5.43,35.47-17,5.23-28,13.61-28,22.44s11.1,17.26,28.11,22.47c-3.93,17.34-2.18,31.13,5.51,35.55a11.93,11.93,0,0,0,6.13,1.53c7.5,0,17.31-5.35,27.24-14.62,9.92,9.22,19.74,14.51,27.24,14.51a12.11,12.11,0,0,0,6.16-1.53c7.66-4.42,9.38-18.19,5.42-35.47C555.84,935.06,566.88,926.66,566.88,917.83Zm-39.72-53.49v0a6.32,6.32,0,0,1,3.1.71c3.71,2.13,5.32,10.23,4.07,20.64-.3,2.56-.79,5.26-1.39,8a133,133,0,0,0-17.32-3,132.78,132.78,0,0,0-11.34-13.63C513.16,868.87,521.49,864.35,527.16,864.34Zm-51.32,67.45q1.92,3.27,3.93,6.38c-3.87-.57-7.61-1.28-11.18-2.15,1-3.52,2.26-7.15,3.68-10.77C473.39,927.43,474.56,929.61,475.84,931.79Zm-7.33-32.15c3.57-.84,7.33-1.58,11.23-2.15-1.33,2.1-2.67,4.25-3.92,6.46s-2.43,4.36-3.55,6.54A114.8,114.8,0,0,1,468.51,899.64Zm6.95,18.27c1.69-3.65,3.6-7.31,5.65-10.88s4.3-7.17,6.57-10.41c4.06-.36,8.18-.55,12.32-.55s8.23.19,12.27.52c2.26,3.24,4.47,6.71,6.6,10.36s4,7.2,5.67,10.85c-1.72,3.66-3.6,7.31-5.65,10.88s-4.3,7.17-6.57,10.42c-4.06.35-8.18.54-12.32.54s-8.23-.19-12.27-.52c-2.26-3.24-4.47-6.7-6.6-10.36S477.18,921.56,475.46,917.91Zm48.7,13.8c1.25-2.18,2.42-4.39,3.54-6.57A114.8,114.8,0,0,1,531.46,936c-3.57.87-7.33,1.61-11.23,2.18C521.57,936.07,522.9,933.92,524.16,931.71Zm0-27.84c-1.25-2.18-2.59-4.31-3.93-6.38q5.82.85,11.18,2.15c-1,3.52-2.26,7.15-3.68,10.77C526.58,908.23,525.41,906.05,524.13,903.87ZM507.5,890.15c-2.46-.1-5-.19-7.5-.19s-5.1.06-7.58.19a105.71,105.71,0,0,1,7.5-8.72A114.37,114.37,0,0,1,507.5,890.15Zm-37.93-25a6.08,6.08,0,0,1,3.14-.71v0c5.64,0,14,4.5,22.9,12.71a129.42,129.42,0,0,0-11.26,13.6,129.07,129.07,0,0,0-17.34,3c-.63-2.72-1.09-5.37-1.42-7.9C464.31,875.43,465.89,867.33,469.57,865.18Zm-6.87,69.23c-2.7-.85-5.26-1.78-7.63-2.78-9.66-4.12-15.9-9.52-15.9-13.8s6.24-9.71,15.9-13.8c2.34-1,4.9-1.91,7.55-2.75a130.83,130.83,0,0,0,6.13,16.6A130.68,130.68,0,0,0,462.7,934.41Zm10.12,36.91a6.43,6.43,0,0,1-3.08-.73c-3.71-2.13-5.32-10.23-4.07-20.64.3-2.57.79-5.26,1.39-8a131.33,131.33,0,0,0,17.32,3,131.87,131.87,0,0,0,11.34,13.64C486.83,966.8,478.49,971.32,472.82,971.32Zm27.23-17.09a114.59,114.59,0,0,1-7.58-8.73c2.46.11,5,.19,7.5.19s5.1-.05,7.58-.19A105.91,105.91,0,0,1,500.05,954.23Zm30.38,16.25a6.08,6.08,0,0,1-3.14.71c-5.64,0-14-4.5-22.9-12.71a129.42,129.42,0,0,0,11.26-13.6,129.07,129.07,0,0,0,17.34-3,75.63,75.63,0,0,1,1.42,7.93C535.69,960.23,534.11,968.32,530.43,970.48Zm14.48-38.85c-2.35,1-4.91,1.9-7.56,2.75a131.52,131.52,0,0,0-6.13-16.61,129,129,0,0,0,6-16.52c2.7.85,5.26,1.77,7.66,2.78,9.66,4.12,15.9,9.52,15.9,13.8S554.56,927.54,544.91,931.63Z",
    stroke: colors.white,
    strokeWidth: "16px"
  }), React.createElement("circle", {
    cx: "499.97",
    cy: "917.83",
    r: "12.46",
    stroke: colors.white,
    strokeWidth: "24px"
  }), React.createElement("path", {
    d: "M566.88,917.83c0-8.86-11.1-17.26-28.11-22.47,3.93-17.34,2.18-31.13-5.51-35.55a9.56,9.56,0,0,0-6.08-1.56c-8,.13-17.31,5.35-27.23,14.62C490,863.65,479,858.2,472.71,858.36c-3.16.09-4.37.52-6.16,1.56-7.67,4.41-9.38,18.18-5.43,35.47-17,5.23-28,13.61-28,22.44s11.1,17.26,28.11,22.47c-3.93,17.34-2.18,31.13,5.51,35.55a11.93,11.93,0,0,0,6.13,1.53c7.5,0,17.31-5.35,27.24-14.62,9.92,9.22,19.74,14.51,27.24,14.51a12.11,12.11,0,0,0,6.16-1.53c7.66-4.42,9.38-18.19,5.42-35.47C555.84,935.06,566.88,926.66,566.88,917.83Zm-39.72-53.49v0a6.32,6.32,0,0,1,3.1.71c3.71,2.13,5.32,10.23,4.07,20.64-.3,2.56-.79,5.26-1.39,8a133,133,0,0,0-17.32-3,132.78,132.78,0,0,0-11.34-13.63C513.16,868.87,521.49,864.35,527.16,864.34Zm-51.32,67.45q1.92,3.27,3.93,6.38c-3.87-.57-7.61-1.28-11.18-2.15,1-3.52,2.26-7.15,3.68-10.77C473.39,927.43,474.56,929.61,475.84,931.79Zm-7.33-32.15c3.57-.84,7.33-1.58,11.23-2.15-1.33,2.1-2.67,4.25-3.92,6.46s-2.43,4.36-3.55,6.54A114.8,114.8,0,0,1,468.51,899.64Zm6.95,18.27c1.69-3.65,3.6-7.31,5.65-10.88s4.3-7.17,6.57-10.41c4.06-.36,8.18-.55,12.32-.55s8.23.19,12.27.52c2.26,3.24,4.47,6.71,6.6,10.36s4,7.2,5.67,10.85c-1.72,3.66-3.6,7.31-5.65,10.88s-4.3,7.17-6.57,10.42c-4.06.35-8.18.54-12.32.54s-8.23-.19-12.27-.52c-2.26-3.24-4.47-6.7-6.6-10.36S477.18,921.56,475.46,917.91Zm48.7,13.8c1.25-2.18,2.42-4.39,3.54-6.57A114.8,114.8,0,0,1,531.46,936c-3.57.87-7.33,1.61-11.23,2.18C521.57,936.07,522.9,933.92,524.16,931.71Zm0-27.84c-1.25-2.18-2.59-4.31-3.93-6.38q5.82.85,11.18,2.15c-1,3.52-2.26,7.15-3.68,10.77C526.58,908.23,525.41,906.05,524.13,903.87ZM507.5,890.15c-2.46-.1-5-.19-7.5-.19s-5.1.06-7.58.19a105.71,105.71,0,0,1,7.5-8.72A114.37,114.37,0,0,1,507.5,890.15Zm-37.93-25a6.08,6.08,0,0,1,3.14-.71v0c5.64,0,14,4.5,22.9,12.71a129.42,129.42,0,0,0-11.26,13.6,129.07,129.07,0,0,0-17.34,3c-.63-2.72-1.09-5.37-1.42-7.9C464.31,875.43,465.89,867.33,469.57,865.18Zm-6.87,69.23c-2.7-.85-5.26-1.78-7.63-2.78-9.66-4.12-15.9-9.52-15.9-13.8s6.24-9.71,15.9-13.8c2.34-1,4.9-1.91,7.55-2.75a130.83,130.83,0,0,0,6.13,16.6A130.68,130.68,0,0,0,462.7,934.41Zm10.12,36.91a6.43,6.43,0,0,1-3.08-.73c-3.71-2.13-5.32-10.23-4.07-20.64.3-2.57.79-5.26,1.39-8a131.33,131.33,0,0,0,17.32,3,131.87,131.87,0,0,0,11.34,13.64C486.83,966.8,478.49,971.32,472.82,971.32Zm27.23-17.09a114.59,114.59,0,0,1-7.58-8.73c2.46.11,5,.19,7.5.19s5.1-.05,7.58-.19A105.91,105.91,0,0,1,500.05,954.23Zm30.38,16.25a6.08,6.08,0,0,1-3.14.71c-5.64,0-14-4.5-22.9-12.71a129.42,129.42,0,0,0,11.26-13.6,129.07,129.07,0,0,0,17.34-3,75.63,75.63,0,0,1,1.42,7.93C535.69,960.23,534.11,968.32,530.43,970.48Zm14.48-38.85c-2.35,1-4.91,1.9-7.56,2.75a131.52,131.52,0,0,0-6.13-16.61,129,129,0,0,0,6-16.52c2.7.85,5.26,1.77,7.66,2.78,9.66,4.12,15.9,9.52,15.9,13.8S554.56,927.54,544.91,931.63Z",
    fill: "#61dafb"
  }), React.createElement("circle", {
    cx: "499.97",
    cy: "917.83",
    r: "12.46",
    fill: "#61dafb"
  }));
};

var TinyGlasses = function TinyGlasses() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("circle", {
    cx: "382.91",
    cy: "594.66",
    r: "33.84",
    fill: colors.white,
    opacity: 0.2
  }), React.createElement("path", {
    d: "M375.87,631l43.31-41.74a147.47,147.47,0,0,0-7.57-12.9l-45.87,44.21C367.64,621.9,373.72,630.08,375.87,631Z",
    fill: colors.white,
    opacity: 0.4
  }), React.createElement("circle", {
    cx: "382.91",
    cy: "594.66",
    r: "33.84",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M378,580.47c1.22,3.83-3.5,6.78-7,7.37-3.54,0-5.9-2.36-7.08-5.31-.59-2.95,0-5.9,2.36-7.67,2.95-1.18,7.08-2.36,9.7.67A6.85,6.85,0,0,1,378,580.47Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M384.32,578.21a2.29,2.29,0,0,1-4.49.19c0-1.77.59-2.36,2.27-2.42a2.22,2.22,0,0,1,2.22,2.22Z",
    fill: colors.white
  }), React.createElement("circle", {
    cx: "615.2",
    cy: "594.66",
    r: "33.84",
    fill: colors.white,
    opacity: 0.2
  }), React.createElement("path", {
    d: "M610.12,628.11l38.54-38.54c-.21-1.37-5.91-8.1-6.29-9.44l-41.72,41.74C602,622.24,608.75,627.91,610.12,628.11Z",
    fill: colors.white,
    opacity: 0.4
  }), React.createElement("circle", {
    cx: "615.2",
    cy: "594.66",
    r: "33.84",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M607.36,579.91c1,3.25-3,5.75-6,6.25-3,0-5-2-6-4.5-.5-2.5,0-5,2-6.5,2.5-1,6-2,8.23.57A5.85,5.85,0,0,1,607.36,579.91Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M612.7,578a1.94,1.94,0,0,1-3.8.16c0-1.5.5-2,1.92-2A1.88,1.88,0,0,1,612.7,578Z",
    fill: colors.white
  }), React.createElement("path", {
    d: "M416.74,594.66q83.68-30,164.63,0",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M615.2,634.5A39.9,39.9,0,0,1,575.6,599c-50-17.65-101.46-17.64-153.1,0a39.81,39.81,0,0,1-50.92,33.84,38,38,0,0,0,54.51-29.91c49.22-16.86,98.28-16.88,145.93,0a38,38,0,0,0,54.51,30A40,40,0,0,1,615.2,634.5Z",
    opacity: 0.15
  }));
};

var VNeck = function VNeck(_ref) {
  var color = _ref.color,
      _ref$graphic = _ref.graphic,
      Graphic = _ref$graphic === void 0 ? Noop : _ref$graphic;

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      skin = _useTheme.skin;

  var _colors$clothing$colo = colors.clothing[color],
      base = _colors$clothing$colo.base,
      shadow = _colors$clothing$colo.shadow;
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M680.7,905.78c.2-37.1-1.21-70.07-7.74-95.39-10.08-25.35-28.18-40.47-60.12-40.47l22.85,134.47S658.2,914.68,680.7,905.78Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M689.3,895.23a20.28,20.28,0,0,1-3.69,2.42",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M329,809.32c-6.82,25.57-8,59.13-7.74,97,19.9,8.55,50.43-2.15,50.43-2.15L389,771.89C358.14,771.89,339.74,785.79,329,809.32Z",
    fill: skin.shadow
  }), React.createElement("path", {
    d: "M616.66,758.16l-38.44.1c0,53.72-75.33,111.14-75.33,111.14s-80.8-60.58-80.8-111.14l-38.66-.1a13.28,13.28,0,0,0-13.28,13.27v284.69a13.28,13.28,0,0,0,13.28,13.27H622.36a13.27,13.27,0,0,0,13.27-13.27V778C635.63,765.82,629.75,758.16,616.66,758.16Z",
    fill: base
  }), React.createElement("path", {
    d: "M612.84,758.16c63.54,0,73.4,56,73.9,133.16-18.59,11.62-48.91,1.32-48.91,1.32Z",
    fill: base
  }), React.createElement("path", {
    d: "M635.63,831.31,612.84,869.4l11.39,130h11.6V893.78l17.28,2.89C647.49,824.5,635.63,831.31,635.63,831.31Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M389,758.16c-61.78,0-75.82,53.79-76.85,127.66,19,19.85,57.95,4.58,57.95,4.58Z",
    fill: base
  }), React.createElement("path", {
    d: "M370.12,831.31V890.4l-17.31,4.3C358.48,824.63,370.12,831.31,370.12,831.31Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M612.84,758.16c67.42,0,78.45,56.28,78.9,133.78-26.2,12.42-53.91.7-53.91.7",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M389,758.16c-66.79,0-80.08,54.69-80.75,130.71,20.59,14.79,61.85,1.53,61.85,1.53",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M383.43,1069.39H500c-109.19,0-100.91-231.14-129.89-231.14v217.87A13.28,13.28,0,0,0,383.43,1069.39Z",
    fill: shadow
  }), React.createElement("path", {
    d: "M364.15,860.29c-.19-3.67-.11-7.35.06-11s.47-7.34.85-11c.2-1.83.41-3.67.65-5.51s.49-3.67.85-5.5a44.05,44.05,0,0,1,3.59-11,44.05,44.05,0,0,1,3.59,11c.36,1.83.62,3.67.85,5.5s.45,3.68.65,5.51q.58,5.52.86,11c.16,3.67.24,7.35,0,11Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M635.63,869.4v8c.26,34,.26,69,0,102.76,0,2.87,0,5.72,0,8.53v67.41a13.27,13.27,0,0,1-13.27,13.27H383.43a13.28,13.28,0,0,1-13.28-13.27V990.3c-.26-34.86-.26-69.86,0-105.3V860.29",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M629.63,869.4c-.19-4.18-.1-8.36.06-12.53s.47-8.36.86-12.53c.2-2.09.4-4.18.64-6.27s.49-4.18.86-6.27a54.83,54.83,0,0,1,3.58-12.53,54.37,54.37,0,0,1,3.59,12.53c.36,2.09.63,4.18.85,6.27s.45,4.18.65,6.27c.39,4.17.69,8.35.85,12.53s.26,8.35.06,12.53Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M383.43,758.26l233.23-.1",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M310.72,891.94a24.84,24.84,0,0,0,3.68,2.76",
    fill: "none",
    stroke: colors.outline,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("path", {
    d: "M677.59,882.13a20.25,20.25,0,0,1-6.75,2.52,34.91,34.91,0,0,1-7.21.64,39.94,39.94,0,0,1-7.17-.78c-1.18-.22-2.34-.57-3.49-.87s-2.28-.78-3.38-1.24c1.21,0,2.39.17,3.56.27l3.52.29c1.17,0,2.33.2,3.5.21s2.33.11,3.49.12c2.32.05,4.64,0,7-.18A50.81,50.81,0,0,0,677.59,882.13Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M578.22,758.26c0,53.72-75.33,111.14-75.33,111.14s-80.8-60.58-80.8-111.14",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "12px"
  }), React.createElement("g", {
    transform: "translate(0 30)"
  }, React.createElement(Graphic, null)));
};

var GraphQLGraphic = function GraphQLGraphic() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M551.55,939.73a11.33,11.33,0,0,0-3-1.2V907.92a11.25,11.25,0,0,0,3.06-1.22,11.49,11.49,0,1,0-14.08-17.84L511,873.57a11.48,11.48,0,1,0-22.48-3.28,11.68,11.68,0,0,0,.47,3.26l-26.5,15.3a11.65,11.65,0,0,0-2.59-2.05,11.49,11.49,0,1,0-11.48,19.9,11.25,11.25,0,0,0,3.06,1.22v30.6a11.71,11.71,0,0,0-3,1.21,11.49,11.49,0,1,0,11.48,19.9,11.65,11.65,0,0,0,2.57-2L489,972.9a11.25,11.25,0,0,0-.47,3.25,11.48,11.48,0,1,0,23,0,11.68,11.68,0,0,0-.58-3.62l26.33-15.2a11.24,11.24,0,0,0,2.84,2.3,11.49,11.49,0,0,0,11.48-19.9ZM465.35,947a11.36,11.36,0,0,0-1.21-3,11.59,11.59,0,0,0-2-2.56l34.68-60.06a11.67,11.67,0,0,0,3.2.45,11.37,11.37,0,0,0,3.21-.46l34.67,60.06a11.45,11.45,0,0,0-3.23,5.6Zm69.45-53.36a11.46,11.46,0,0,0,8.26,14.28v30.65l-.44.11-34.68-60.07.3-.3Zm-43.06-15.34.33.32-34.68,60.07-.45-.12V907.89a11.45,11.45,0,0,0,8.25-14.29Zm16.75,90.14a11.5,11.5,0,0,0-16.76-.23l-26.51-15.31.12-.44h69.32c.06.25.13.51.21.75Z",
    stroke: colors.white,
    strokeWidth: "16px"
  }), React.createElement("path", {
    d: "M551.55,939.73a11.33,11.33,0,0,0-3-1.2V907.92a11.25,11.25,0,0,0,3.06-1.22,11.49,11.49,0,1,0-14.08-17.84L511,873.57a11.48,11.48,0,1,0-22.48-3.28,11.68,11.68,0,0,0,.47,3.26l-26.5,15.3a11.65,11.65,0,0,0-2.59-2.05,11.49,11.49,0,1,0-11.48,19.9,11.25,11.25,0,0,0,3.06,1.22v30.6a11.71,11.71,0,0,0-3,1.21,11.49,11.49,0,1,0,11.48,19.9,11.65,11.65,0,0,0,2.57-2L489,972.9a11.25,11.25,0,0,0-.47,3.25,11.48,11.48,0,1,0,23,0,11.68,11.68,0,0,0-.58-3.62l26.33-15.2a11.24,11.24,0,0,0,2.84,2.3,11.49,11.49,0,0,0,11.48-19.9ZM465.35,947a11.36,11.36,0,0,0-1.21-3,11.59,11.59,0,0,0-2-2.56l34.68-60.06a11.67,11.67,0,0,0,3.2.45,11.37,11.37,0,0,0,3.21-.46l34.67,60.06a11.45,11.45,0,0,0-3.23,5.6Zm69.45-53.36a11.46,11.46,0,0,0,8.26,14.28v30.65l-.44.11-34.68-60.07.3-.3Zm-43.06-15.34.33.32-34.68,60.07-.45-.12V907.89a11.45,11.45,0,0,0,8.25-14.29Zm16.75,90.14a11.5,11.5,0,0,0-16.76-.23l-26.51-15.31.12-.44h69.32c.06.25.13.51.21.75Z",
    fill: "#e535ab"
  }));
};

var Tongue = function Tongue() {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: "M443.14,621.86c0-18.9,113.72-16.06,113.72,0a56.86,56.86,0,0,1-113.72,0Z",
    fill: colors.outline
  }), React.createElement("path", {
    d: "M443.14,621.86c0-18.9,113.72-16.06,113.72,0a56.86,56.86,0,0,1-113.72,0Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "6px"
  }), React.createElement("path", {
    d: "M532.49,646.6c0-8.06-14.55-14.6-32.49-14.6s-32.49,6.54-32.49,14.6h0v44.34c0,14.41,14.55,26.08,32.49,26.08s32.49-11.67,32.49-26.08V646.61Z",
    fill: colors.tongue
  }), React.createElement("path", {
    d: "M532.49,646.6c0-8.06-14.55-14.6-32.49-14.6s-32.49,6.54-32.49,14.6h0v44.34c0,14.41,14.55,26.08,32.49,26.08s32.49-11.67,32.49-26.08V646.61Z",
    fill: "none",
    stroke: colors.outline,
    strokeMiterlimit: 10,
    strokeWidth: "8px"
  }), React.createElement("path", {
    d: "M479.31,626.6l.91-.21.76-.14c.49-.08,1-.14,1.46-.18a21.42,21.42,0,0,1,2.89-.1,25,25,0,0,1,5.79.81,21.39,21.39,0,0,1,10.34,6.11A20.07,20.07,0,0,1,506.54,643a17.19,17.19,0,0,1-1.37,10.35c-2.08-2.93-3.66-5.55-5.32-7.76a27.26,27.26,0,0,0-2.46-3,14.09,14.09,0,0,0-2.69-2.16,15.31,15.31,0,0,0-6.11-2.08,25.67,25.67,0,0,0-3.43-.22c-.59,0-1.18,0-1.76,0l-.85.06-.4,0c-.09,0-.29,0-.22,0Z",
    fill: colors.outline
  }));
};

var eyesMap = {
  normal: NormalEyes,
  leftTwitch: LeftTwitchEyes,
  happy: HappyEyes,
  content: ContentEyes,
  squint: SquintEyes,
  simple: SimpleEyes,
  dizzy: DizzyEyes,
  wink: WinkEyes,
  heart: HeartEyes
};
var eyebrowsMap = {
  raised: NormalEyebrows,
  leftLowered: LeftLoweredEyebrows,
  serious: SeriousEyebrows,
  angry: AngryEyebrows,
  concerned: ConcernedEyebrows
};
var mouthsMap = {
  grin: Grin,
  sad: SadMouth,
  openSmile: SmileOpen,
  lips: Lips,
  open: OpenMouth,
  serious: SeriousMouth,
  tongue: Tongue
};
var hairMap = {
  none: {
    Front: Noop,
    Back: Noop
  },
  "long": LongHair,
  bun: BunHair,
  "short": ShortHair,
  pixie: PixieCut,
  balding: BaldingHair,
  buzz: BuzzCut,
  afro: Afro,
  bob: BobCut
};
var facialHairMap = {
  none: Noop,
  none2: Noop,
  none3: Noop,
  stubble: StubbleBeard,
  mediumBeard: MediumBeard
};
var clothingMap = {
  naked: {
    Back: Noop,
    Front: Noop
  },
  shirt: {
    Back: Shirt,
    Front: Noop
  },
  dressShirt: {
    Back: DressShirt,
    Front: Noop
  },
  vneck: {
    Back: VNeck,
    Front: Noop
  },
  tankTop: {
    Back: TankTop,
    Front: Noop
  },
  dress: Dress
};
var accessoryMap = {
  none: Noop,
  roundGlasses: RoundGlasses,
  tinyGlasses: TinyGlasses,
  shades: Shades
};
var graphicsMap = {
  none: Noop,
  redwood: RedwoodGraphic,
  gatsby: GatsbyGraphic,
  vue: Vue,
  react: ReactGraphic,
  graphQL: GraphQLGraphic
};
var hatMap = {
  none: {
    Front: Noop,
    Back: Noop
  },
  none2: {
    Front: Noop,
    Back: Noop
  },
  none3: {
    Front: Noop,
    Back: Noop
  },
  none4: {
    Front: Noop,
    Back: Noop
  },
  none5: {
    Front: Noop,
    Back: Noop
  },
  beanie: Beanie,
  turban: Turban
};
var bodyMap = {
  chest: Chest,
  breasts: Breasts
};

function selectRandomKey(object) {
  return Object.keys(object)[Math.floor(Math.random() * Object.keys(object).length)];
}

var Avatar = function Avatar(_ref) {
  var _ref$skinTone = _ref.skinTone,
      skinTone = _ref$skinTone === void 0 ? selectRandomKey(colors.skin) : _ref$skinTone,
      _ref$eyes = _ref.eyes,
      eyes = _ref$eyes === void 0 ? selectRandomKey(eyesMap) : _ref$eyes,
      _ref$eyebrows = _ref.eyebrows,
      eyebrows = _ref$eyebrows === void 0 ? selectRandomKey(eyebrowsMap) : _ref$eyebrows,
      _ref$mouth = _ref.mouth,
      mouth = _ref$mouth === void 0 ? selectRandomKey(mouthsMap) : _ref$mouth,
      _ref$hair = _ref.hair,
      hair = _ref$hair === void 0 ? selectRandomKey(hairMap) : _ref$hair,
      _ref$facialHair = _ref.facialHair,
      facialHair = _ref$facialHair === void 0 ? selectRandomKey(facialHairMap) : _ref$facialHair,
      _ref$clothing = _ref.clothing,
      clothing = _ref$clothing === void 0 ? selectRandomKey(clothingMap) : _ref$clothing,
      _ref$accessory = _ref.accessory,
      accessory = _ref$accessory === void 0 ? selectRandomKey(accessoryMap) : _ref$accessory,
      _ref$graphic = _ref.graphic,
      graphic = _ref$graphic === void 0 ? selectRandomKey(graphicsMap) : _ref$graphic,
      _ref$hat = _ref.hat,
      hat = _ref$hat === void 0 ? selectRandomKey(hatMap) : _ref$hat,
      _ref$body = _ref.body,
      body = _ref$body === void 0 ? selectRandomKey(bodyMap) : _ref$body,
      _ref$hairColor = _ref.hairColor,
      hairColor = _ref$hairColor === void 0 ? selectRandomKey(colors.hair) : _ref$hairColor,
      _ref$clothingColor = _ref.clothingColor,
      clothingColor = _ref$clothingColor === void 0 ? selectRandomKey(colors.clothing) : _ref$clothingColor,
      _ref$circleColor = _ref.circleColor,
      circleColor = _ref$circleColor === void 0 ? selectRandomKey(colors.bgColors) : _ref$circleColor,
      _ref$lipColor = _ref.lipColor,
      lipColor = _ref$lipColor === void 0 ? selectRandomKey(colors.lipColors) : _ref$lipColor,
      _ref$hatColor = _ref.hatColor,
      hatColor = _ref$hatColor === void 0 ? selectRandomKey(colors.clothing) : _ref$hatColor,
      _ref$faceMaskColor = _ref.faceMaskColor,
      faceMaskColor = _ref$faceMaskColor === void 0 ? selectRandomKey(colors.clothing) : _ref$faceMaskColor,
      _ref$mask = _ref.mask,
      mask = _ref$mask === void 0 ? true : _ref$mask,
      _ref$faceMask = _ref.faceMask,
      faceMask = _ref$faceMask === void 0 ? true : _ref$faceMask,
      _ref$lashes = _ref.lashes,
      lashes = _ref$lashes === void 0 ? Math.random() > 0.5 : _ref$lashes,
      rest = _objectWithoutPropertiesLoose(_ref, ["skinTone", "eyes", "eyebrows", "mouth", "hair", "facialHair", "clothing", "accessory", "graphic", "hat", "body", "hairColor", "clothingColor", "circleColor", "lipColor", "hatColor", "faceMaskColor", "mask", "faceMask", "lashes"]);

  var skin = colors.skin[skinTone];
  var Eyes = eyesMap[eyes];
  var Eyebrows = eyebrowsMap[eyebrows];
  var Mouth = mouthsMap[mouth];
  var Hair = hairMap[hair];
  var FacialHair = facialHairMap[facialHair];
  var Clothing = clothingMap[clothing];
  var Accessory = accessoryMap[accessory];
  var Graphic = graphicsMap[graphic];
  var Hat = hatMap[hat];
  var Body = bodyMap[body];
  return React.createElement(ThemeContext.Provider, {
    value: {
      colors: colors,
      skin: skin
    }
  }, React.createElement(Base, Object.assign({
    eyes: Eyes,
    eyebrows: Eyebrows,
    mouth: Mouth,
    hair: Hair,
    facialHair: FacialHair,
    clothing: Clothing,
    accessory: Accessory,
    graphic: Graphic,
    hat: Hat,
    body: Body,
    hatColor: hatColor,
    hairColor: hairColor,
    clothingColor: clothingColor,
    circleColor: circleColor,
    lipColor: lipColor,
    mask: mask,
    faceMask: faceMask,
    faceMaskColor: faceMaskColor,
    lashes: lashes
  }, rest)));
};

export { Avatar, Avatar as BigHead, Noop, ThemeContext, accessoryMap, bodyMap, clothingMap, eyebrowsMap, eyesMap, facialHairMap, graphicsMap, hairMap, hatMap, mouthsMap, theme };
//# sourceMappingURL=core.esm.js.map
